/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s) {
    "use strict";
    function o(t, e) {
        let i;
        return function () {
            if (t) {
                const s = () => t.apply(this, arguments);
                clearTimeout(i), (i = setTimeout(s, e));
            }
        };
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1440 }),
        (window.theme.keyboardKeys = { TAB: "Tab", ENTER: "Enter", NUMPADENTER: "NumpadEnter", ESCAPE: "Escape", SPACE: "Space", LEFTARROW: "ArrowLeft", RIGHTARROW: "ArrowRight" }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const n = "body",
        r = "[data-main]",
        a = "[data-site-header]",
        l = "[data-prevent-transparent-header]",
        c = "supports-transparent-header",
        h = "site-header--transparent",
        d = "is-first-section-transparent",
        u = "data-transparent",
        p = () => {
            const t = document.querySelector(n),
                e = t.querySelector(a);
            if (!e) return;
            const i = "true" === e.getAttribute(u),
                s = t.querySelector(r).children[0];
            if (!s) return;
            const o = s.querySelector(`${l}:first-of-type`);
            window.isHeaderTransparent = i && s.classList.contains(c) && !o;
            CSS.supports("(selector(:has(*)))") || (t.classList.toggle(d, window.isHeaderTransparent), e.classList.toggle(h, window.isHeaderTransparent));
        },
        m = ".section-footer--parallax",
        g = "[data-section-type]",
        f = ":scope > [data-wave]",
        y = ".wavy:not(.site-footer)",
        v = ".parallax-shadow:not(.site-footer)",
        b = "wavy",
        w = "parallax-shadow",
        S = "parallax-rounded-corners",
        E = "section-footer--parallax",
        L = "body--rounded-corners-large",
        k = "data-parallax-wavy",
        A = (t) => {
            const e = t,
                i = document.querySelectorAll(y),
                s = document.querySelectorAll(v);
            i.forEach((t) => {
                t.classList.remove(b);
                [...t.querySelectorAll(f)].map((t) => t.remove());
            }),
                s.forEach((t) => {
                    t.classList.remove(w), t.classList.remove(S), document.body.classList.remove(L);
                    [...t.querySelectorAll(f)].map((t) => t.remove());
                });
            const o = document.querySelectorAll(m);
            if (o.length > 0) {
                const t = o[0].querySelector(g);
                t.hasAttribute(k) && t.classList.add(b);
            }
            e.classList.contains(E) || document.dispatchEvent(new CustomEvent("theme:footer:unload"));
        };
    (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const C = window.Shopify.theme.sections.registered,
        q = window.Shopify.theme.sections.instances,
        T = { id: "data-section-id", type: "data-section-type" };
    let P = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        },
        x = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                    if (null === t.getAttribute(T.id)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + T.id + " attribute.");
                    return t;
                })(t)),
                    (this.id = t.getAttribute(T.id)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
                }
            }
        };
    function I(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== C[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new P(t, e);
        return (C[t] = i), C;
    }
    function H(t, e) {
        (t = O(t)),
            void 0 === e && (e = document.querySelectorAll("[" + T.type + "]")),
            (e = B(e)),
            t.forEach(function (t) {
                const i = C[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(M(e).length > 0) && null !== e.getAttribute(T.type) && (e.getAttribute(T.type) !== t || (q.push(new x(e, i)), !1));
                    }));
            });
    }
    function F(t) {
        M(t).forEach(function (t) {
            var e = q
                .map(function (t) {
                    return t.id;
                })
                .indexOf(t.id);
            q.splice(e, 1), t.onUnload();
        });
    }
    function M(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            B(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            O(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function D(t) {
        for (var e, i = 0; i < q.length; i++)
            if (q[i].id === t) {
                e = q[i];
                break;
            }
        return e;
    }
    function O(t) {
        return (
            "*" === t
                ? (t = Object.keys(C))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === x
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === x &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function B(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            !0 === window.Shopify.visualPreviewMode && null === i && (i = t.target.querySelector(`[${T.id}]`)), null !== i && H(i.getAttribute(T.type), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] &&
                M(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] && F(i);
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const z = '[data-parallax="card-scrolling"]',
        _ = () => {
            setTimeout(() => {
                window.Shopify.theme.sections.instances
                    .filter((t) => {
                        const e = "slider" === t.type,
                            i = "banner-image" === t.type,
                            s = t.container.matches(z);
                        return (e && s) || (i && s);
                    })
                    .forEach((t) => {
                        F(t.id), setTimeout(() => H(t.id));
                    });
            });
        };
    let $ = Y();
    const V = {
            body: "body",
            main: "[data-main]",
            collectionFilters: "[data-collection-filters]",
            footer: '[data-section-type*="footer"]',
            header: "[data-header-height]",
            stickyHeader: '[data-site-header][data-position="fixed"]',
            announcementBar: "[data-announcement-bar]",
            collectionStickyBar: "[data-collection-sticky-bar]",
            logoTextLink: "[data-logo-text-link]",
        },
        R = { templateCollection: "template-collection", templateSearch: "template-search", supportsTransparentHeader: "supports-transparent-header" };
    function N() {
        var t, e;
        const i = {};
        return (
            (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (i.footerHeight = K(V.footer)),
            (i.headerHeight = K(V.header)),
            (i.stickyHeaderHeight = Q() ? window.stickyHeaderHeight : 0),
            (i.headerInitialHeight =
                parseInt((null === (t = document.querySelector(V.header)) || void 0 === t ? void 0 : t.dataset.height) || (null === (e = document.querySelector(V.header)) || void 0 === e ? void 0 : e.offsetHeight)) || 0),
            (i.announcementBarHeight = K(V.announcementBar)),
            (i.collectionStickyBarHeight = K(V.collectionStickyBar)),
            i
        );
    }
    function W() {
        document.addEventListener("theme:resize", j), U(), document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
    }
    function U() {
        G();
    }
    function j() {
        G(!0);
    }
    function G(t = !1) {
        const e = document.querySelector(V.body),
            i = document.querySelector(V.collectionFilters),
            s = null !== document.querySelector(V.logoTextLink);
        let { windowHeight: o, headerHeight: n, headerInitialHeight: r, announcementBarHeight: a, footerHeight: l, collectionStickyBarHeight: c } = N();
        s &&
            (n = (function () {
                document.documentElement.style.setProperty("--header-height", "auto"), document.documentElement.style.setProperty("--header-sticky-height", "auto");
                const t = document.querySelector(V.header).offsetHeight;
                return (
                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                    }),
                    t
                );
            })());
        const h = window.isHeaderTransparent && document.querySelector(V.main).firstElementChild.classList.contains(R.supportsTransparentHeader) ? o - a : o - r - a;
        let d = Q() ? o - window.stickyHeaderHeight : o;
        const u = e.classList.contains(R.templateCollection),
            p = e.classList.contains(R.templateSearch),
            m = (u && i) || (p && i);
        if (
            (document.documentElement.style.setProperty("--footer-height", `${l}px`),
            document.documentElement.style.setProperty("--content-full", `${h}px`),
            document.documentElement.style.setProperty("--content-min", o - n - l + "px"),
            document.documentElement.style.setProperty("--collection-sticky-bar-height", `${c}px`),
            m && (d = o),
            !t)
        )
            return void document.documentElement.style.setProperty("--full-height", `${d}px`);
        const g = Y();
        g !== $ && (document.documentElement.style.setProperty("--full-height", `${d}px`), ($ = g));
    }
    function K(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function Q() {
        return document.querySelector(V.stickyHeader);
    }
    function Y() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    const X = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]",
    };
    function J(t, e) {
        let i = 0;
        e.forEach((t) => {
            i = t.offsetHeight > i ? t.offsetHeight : i;
        });
        const s = t.querySelectorAll(X.overflowBackground);
        [t, ...s].forEach((t) => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
        });
    }
    function Z(t) {
        if (window.innerWidth < window.theme.sizes.small) {
            return void t.querySelectorAll(X.overflowFrame).forEach((t) => {
                const e = t.querySelectorAll(X.overflowContent);
                J(t, e);
            });
        }
        let e = 0;
        const i = t.querySelectorAll(X.overflowFrame);
        t.querySelectorAll(X.overflowContent).forEach((t) => {
            t.offsetHeight > e && (e = t.offsetHeight);
        });
        [...i, ...t.querySelectorAll(X.overflowBackground)].forEach((t) => {
            t.style.setProperty("min-height", `${e}px`);
        }),
            t.style.setProperty("min-height", `${e}px`);
    }
    function tt(t) {
        const e = t.querySelectorAll(X.overflowContainer);
        e &&
            e.forEach((t) => {
                const e = t.querySelectorAll(X.overflowContent);
                J(t, e),
                    document.addEventListener("theme:resize", () => {
                        J(t, e);
                    });
            });
        const i = t.querySelectorAll(X.overflowWrapper);
        i &&
            i.forEach((t) => {
                Z(t),
                    document.addEventListener("theme:resize", () => {
                        Z(t);
                    });
            });
    }
    function et() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            window.lastWindowWidth !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (window.lastWindowWidth = window.innerWidth));
    }
    window.lastWindowWidth = window.innerWidth;
    let it = window.pageYOffset,
        st = null,
        ot = null,
        nt = null,
        rt = null,
        at = 0;
    const lt = { quickViewVisible: "js-quick-view-visible", cartDrawerOpen: "js-drawer-open-cart" };
    function ct(e) {
        setTimeout(() => {
            at && clearTimeout(at), t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function ht(t) {
        const e = t.detail;
        e ? (at = setTimeout(dt, e)) : dt();
    }
    function dt() {
        document.body.classList.contains(lt.quickViewVisible) || document.body.classList.contains(lt.cartDrawerOpen) || (t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked"));
    }
    const ut = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return s.classList.add(e), s.setAttribute("data-scroll-lock-scrollable", ""), t.parentNode.insertBefore(s, t), s.appendChild(t);
    };
    function pt(t) {
        t.querySelectorAll("table").forEach((t) => {
            ut(t, "table-wrapper");
        });
    }
    const mt = { loading: "is-loading", imgIn: "img-in" },
        gt = { img: "img.is-loading", section: "[data-section-type]" };
    function ft(t) {
        t.querySelectorAll(gt.img).forEach((t) => {
            if (t.complete) {
                t.classList.remove(mt.loading), t.parentNode.classList.remove(mt.loading);
                const e = t.closest(gt.section);
                e && e.classList.add(mt.imgIn);
            }
        });
    }
    const yt = "img",
        vt = "template",
        bt = ".shopify-section",
        wt = "[data-deferred-content]",
        St = "[data-product-image]",
        Et = "srcset",
        Lt = "data-loaded",
        kt = "data-deferred-container";
    let At = class extends HTMLElement {
        connectedCallback() {
            0 != this.deferredTriggers.length
                ? this.deferredTriggers.forEach((t) => {
                      t.addEventListener(
                          "mouseenter",
                          () => {
                              this.hasAttribute(Lt) || this.loadTemplate();
                          },
                          { once: !0 }
                      );
                  })
                : this.container.addEventListener(
                      "mouseenter",
                      () => {
                          this.hasAttribute(Lt) || this.loadTemplate();
                      },
                      { once: !0 }
                  );
        }
        loadTemplate() {
            var t;
            const e = document.createElement("div"),
                i = this.querySelector(vt);
            if (!i || !(null == i || null === (t = i.content) || void 0 === t ? void 0 : t.firstElementChild)) return;
            e.appendChild(i.content.firstElementChild.cloneNode(!0));
            const s = e.querySelector(wt);
            if (!s) return;
            this.append(s), this.setAttribute(Lt, !0);
            s.querySelectorAll(yt).length > 0 && this.reloadSrcset(this);
        }
        reloadSrcset(t) {
            t &&
                t.querySelectorAll(yt).forEach((t) => {
                    if (!t.parentNode.matches(St)) {
                        const e = t.getAttribute(Et);
                        t.setAttribute(Et, ""), t.setAttribute(Et, e);
                    }
                });
        }
        constructor() {
            super(), (this.container = this), this.hasAttribute(kt) && (this.container = this.closest(this.getAttribute(kt)) || this.closest(bt)), (this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers));
        }
    };
    function Ct(t) {
        return new Promise((e) => {
            function i(s) {
                s.target == t && (t.removeEventListener("animationend", i), t.removeEventListener("transitionend", i), e());
            }
            null == t || t.addEventListener("animationend", i), null == t || t.addEventListener("transitionend", i);
        });
    }
    const qt = "[data-aos]",
        Tt = "[data-has-highlight]",
        Pt = "[data-highlight-holder]",
        xt = "path",
        It = "sup",
        Ht = ".flickity-enabled",
        Ft = "[data-slide].is-selected",
        Mt = "[data-sticky-text]",
        Dt = "text-count-up",
        Ot = ".text-reveal__cropper",
        Bt = "data-highlight-type",
        zt = "data-is-active",
        _t = "is-active",
        $t = "overflow-hidden",
        Vt = {
            "circle-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 1e3, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
            },
            circle: {
                keyframes: [
                    { strokeDashoffset: "506", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 800, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" },
            },
            highlight: {
                keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
                timing: { duration: 600, delay: 200, iterations: 1, fill: "forwards", easing: "ease", pseudoElement: "::before" },
                keyframesHover: [{ transform: "scaleY(0.1)" }, { transform: "scaleY(1)" }],
            },
            "highlight-color": {
                keyframes: [
                    { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
                    { backgroundSize: "200% 100%", backgroundPosition: "0 0", offset: 0.2 },
                    { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
                ],
                timing: { duration: 2e3, delay: 200, iterations: 1, fill: "forwards", easing: "cubic-bezier(0, 0, 0.9, 0.4)" },
            },
            squiggle: { keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }], timing: { duration: 1200, delay: 200, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" } },
            stroke: { keyframes: [{ backgroundPosition: "100% 0" }, { backgroundPosition: "0 0" }], timing: { duration: 1200, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)" } },
            underline: { keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }], timing: { duration: 900, delay: 200, iterations: 1, fill: "forwards", easing: "ease", pseudoElement: "::before" } },
            "underline-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 1e3, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
            },
        };
    let Rt = class extends HTMLElement {
        connectedCallback() {
            (this.timeout = null),
                (this.controller = new AbortController()),
                this.type &&
                    this.target &&
                    ((this.animation = this.target.animate(Vt[this.type].keyframes, Vt[this.type].timing)),
                    this.animation.pause(),
                    this.bindAnimation("init"),
                    this.bindAnimation("pause"),
                    this.modifyDefaults("slider"),
                    this.animation && (this.link && this.listen(), theme.settings.animationsEnabled || (this.animation.play(), this.bindAnimation("play"))));
        }
        disconnectedCallback() {
            this.controller.abort();
        }
        attributeChangedCallback(t, e, i) {
            const s = t === zt,
                o = null === e && s,
                n = "true" === i;
            s && n && !("true" === e && "true" === i) && this.triggerAnimation(), o || n || this.reset();
        }
        triggerAnimation() {
            const t = this.closest(qt);
            var e;
            t
                ? (null === (e = this.textRevealCropper) || void 0 === e || e.classList.add($t),
                  this.textCountUp
                      ? (clearTimeout(this.timeout),
                        (this.timeout = setTimeout(() => {
                            var t;
                            null === (t = this.textRevealCropper) || void 0 === t || t.classList.remove($t), this.setAnimationDelay(0), this.animate();
                        }, 100)))
                      : Ct(t).then(() => {
                            var e;
                            const i = 1e3 * (window.getComputedStyle(t).getPropertyValue("animation-delay") || 0).replace("s", ""),
                                s = Math.max(i - 250, 0);
                            null === (e = this.textRevealCropper) || void 0 === e || e.classList.remove($t), this.setAnimationDelay(s), this.animate();
                        }))
                : this.animate();
        }
        listen() {
            this.link.addEventListener("mouseenter", (t) => this.onMouseenter(t), { signal: this.controller.signal }), this.link.addEventListener("mouseleave", (t) => this.onMouseleave(t), { signal: this.controller.signal });
        }
        animate() {
            this.animation && (this.animation.play(), this.bindAnimation("play"), (this.animation.onfinish = () => this.onFinish()));
        }
        shouldAnimate() {
            requestAnimationFrame(() => {
                let t = !0;
                Boolean(this.closest(Ht)) && (t = Boolean(this.closest(Ft)));
                const e = this.closest(Mt);
                e && (t = Boolean(e.classList.contains(_t))), this.setTriggerAttribute(t);
            });
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(zt, t);
        }
        reset() {
            this.animation && (this.animation.cancel(), this.bindAnimation("cancel"), this.setAnimationDelay(Vt[this.type].timing.delay));
        }
        onMouseenter(t) {
            t.stopImmediatePropagation(), this.setAnimationDelay(0), this.modifyDefaults("mouseenter"), this.animation.reverse(), this.bindAnimation("mouseenter");
        }
        onMouseleave(t) {
            t.stopImmediatePropagation(), this.modifyDefaults("mouseleave"), this.animation.reverse(), this.bindAnimation("mouseleave");
        }
        onFinish() {
            if (this.hasAttribute(zt)) {
                const t = "true" === this.getAttribute(zt) ? 0 : Vt[this.type].timing.delay;
                this.setAnimationDelay(t);
            } else this.setAnimationDelay(0);
        }
        setAnimationDelay(t = 0) {
            this.animation.effect.getTiming().delay !== t && (this.animation.effect.updateTiming({ delay: t }), this.bindAnimation("delay"));
        }
        modifyDefaults(t = "mouseenter", e) {
            if ((e || (e = this.animation), "mouseenter" === t))
                return (
                    Vt[this.type].keyframesHover && e.effect.setKeyframes(Vt[this.type].keyframesHover),
                    "highlight" === this.type && e.effect.updateTiming({ duration: 350, fill: "both" }),
                    "highlight-color" === this.type && e.effect.updateTiming({ duration: 800 }),
                    void ("underline" === this.type && e.effect.updateTiming({ duration: 400 }))
                );
            if ("mouseleave" === t)
                return (
                    Vt[this.type].keyframesHover && e.effect.setKeyframes(Vt[this.type].keyframes),
                    void (("highlight" !== this.type && "highlight-color" !== this.type && "underline" !== this.type) || e.effect.updateTiming({ duration: Vt[this.type].timing.duration }))
                );
            if ("slider" === t && (theme.settings.animationsEnabled || ((Vt[this.type].timing.delay = 300), e.effect.updateTiming({ delay: Vt[this.type].timing.delay })), this.closest(Ht))) {
                const t = Vt[this.type].timing.delay + 200;
                "highlight" === this.type && e.effect.updateTiming({ delay: t });
            }
        }
        bindAnimation(t = !1) {
            if (
                this.bind &&
                t &&
                ("init" === t && (this.boundAnimation = this.bind.animate(Vt[this.type].keyframes, Vt[this.type].timing)),
                "pause" === t && this.boundAnimation.pause(),
                "play" === t && this.boundAnimation.play(),
                "cancel" === t && this.boundAnimation.cancel(),
                "mouseenter" === t && (this.modifyDefaults("mouseenter", this.boundAnimation), this.boundAnimation.reverse()),
                "mouseleave" === t && (this.modifyDefaults("mouseleave", this.boundAnimation), this.boundAnimation.reverse()),
                "delay" === t)
            ) {
                const t = this.animation.effect.getTiming().delay;
                this.boundAnimation.effect.getTiming().delay !== t && this.boundAnimation.effect.updateTiming({ delay: t });
            }
        }
        constructor() {
            super(),
                (this.animation = null),
                (this.bind = null),
                (this.boundAnimation = null),
                (this.link = this.closest(Tt)),
                (this.type = this.getAttribute(Bt)),
                (this.highlightHolder = this.querySelector(Pt)),
                (this.textCountUp = this.closest(Dt)),
                (this.sup = this.querySelector(It)),
                (this.textRevealCropper = this.closest(Ot)),
                (this.target = this.highlightHolder),
                ("circle-hand-drawn" !== this.type && "circle" !== this.type && "underline-hand-drawn" !== this.type) || (this.target = this.querySelector(xt)),
                ("highlight-color" !== this.type && "stroke" !== this.type) || (this.sup && (this.bind = this.sup));
        }
    };
    var Nt, Wt, Ut;
    (Ut = [zt]), (Wt = "observedAttributes") in (Nt = Rt) ? Object.defineProperty(Nt, Wt, { value: Ut, enumerable: !0, configurable: !0, writable: !0 }) : (Nt[Wt] = Ut);
    const jt = ".shopify-section",
        Gt = "[data-slider]",
        Kt = "[data-hover-slideshow-holder]",
        Qt = "[data-hover-slideshow-item]",
        Yt = "[data-hover-slideshow-progress]",
        Xt = ".flickity-button",
        Jt = "fill";
    let Zt = class extends HTMLElement {
        get holder() {
            return this.querySelector(Kt);
        }
        get items() {
            return [...this.querySelectorAll(Qt)];
        }
        get progress() {
            return this.querySelector(Yt);
        }
        connectedCallback() {
            "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.init();
        }
        init() {
            (this.section = this.closest(jt)),
                (this.outerSliders = this.section.querySelectorAll(Gt)),
                (this.autoplaySpeed = 2200),
                (this.timer = 0),
                (this.flkty = new e.data(this.holder)),
                !this.flkty.isActive &&
                    this.items.length > 1 &&
                    ((this.flkty = new e(this.holder, {
                        draggable: !this.outerSliders.length,
                        cellSelector: Qt,
                        contain: !0,
                        wrapAround: !0,
                        imagesLoaded: !0,
                        pageDots: !1,
                        prevNextButtons: !1,
                        adaptiveHeight: !1,
                        pauseAutoPlayOnHover: !1,
                        selectedAttraction: 0.2,
                        friction: 1,
                        on: {
                            ready: () => {
                                this.section.style.setProperty("--autoplay-speed", `${this.autoplaySpeed}ms`), setTimeout(() => this.flkty.resize(), 1e3);
                            },
                            change: () => {
                                this.timer && clearTimeout(this.timer),
                                    this.progress.classList.remove(Jt),
                                    this.progress.offsetWidth,
                                    requestAnimationFrame(() => this.progress.classList.add(Jt)),
                                    (this.timer = setTimeout(() => this.progress.classList.remove(Jt), this.autoplaySpeed));
                            },
                            dragEnd: () => {
                                this.flkty.playPlayer();
                            },
                        },
                    })),
                    this.addEventListener("mouseenter", () => {
                        this.progress.classList.add(Jt),
                            this.timer && clearTimeout(this.timer),
                            (this.timer = setTimeout(() => this.progress.classList.remove(Jt), this.autoplaySpeed)),
                            (this.flkty.options.autoPlay = this.autoplaySpeed),
                            this.flkty.playPlayer();
                    }),
                    this.addEventListener("mouseleave", () => {
                        this.flkty.stopPlayer(), this.timer && clearTimeout(this.timer), this.progress.classList.remove(Jt);
                    })),
                this.addEventListener("click", (t) => {
                    t.target.matches(Xt) && t.preventDefault();
                });
        }
        constructor() {
            super();
        }
    };
    const te = {
            inputSearch: 'input[type="search"]',
            inputType: 'input[name="type"]',
            form: "form",
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            popdownBody: "[data-popdown-body]",
            mainInputSearch: "[data-main-input-search]",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearch: "predictive-search",
            searchForm: "search-form",
        },
        ee = "is-searched",
        ie = "template-search";
    let se = class extends HTMLElement {
        getQuery() {
            return this.input.value.trim();
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery();
        }
        onChange() {
            this.classList.toggle(ee, !this.isFormCleared()), (this.searchTerm = this.getQuery());
        }
        isFormCleared() {
            return 0 === this.input.value.length;
        }
        submit() {
            this.form.submit();
        }
        reset() {
            this.input.val = "";
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(te.selectedLink)) || t.preventDefault();
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        onKeyup(t) {
            switch ((!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        switchOption(t) {
            const e = "up" === t,
                i = this.classList.contains(ee) && this.predictiveSearchResults ? this.predictiveSearchResults : this.popularSearches;
            if (!i) return;
            this.selectedElement = i.querySelector(te.ariaSelected);
            const s = Array.from(i.querySelectorAll(te.allVisibleElements)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !this.selectedElement) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= s.length; ) s[r] === this.selectedElement && (n = r), r++;
            !e && this.selectedElement ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1), o !== n && ((this.activeElement = s[o]), this.handleFocusableDescendants());
        }
        selectOption() {
            const t = this.querySelector(te.selectedOption);
            t && t.click();
        }
        handleFocusableDescendants(t = !1) {
            const e = this.selectedElement ? this.selectedElement : this.querySelector(te.ariaSelected);
            var i;
            if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
                return (
                    (this.selectedElement = null),
                    null === (i = this.activeElement) || void 0 === i || i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-expanded", !1),
                    void this.input.setAttribute("aria-activedescendant", "")
                );
            this.activeElement.setAttribute("aria-selected", !0), this.input.setAttribute("aria-activedescendant", this.activeElement.id);
        }
        constructor() {
            var t;
            super(),
                (this.input = this.querySelector(te.inputSearch)),
                (this.form = this.querySelector(te.form)),
                (this.popdownBody = this.closest(te.popdownBody)),
                (this.popularSearches = null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(te.popularSearches)),
                (this.predictiveSearchResults = this.querySelector(te.predictiveSearchResults)),
                (this.predictiveSearch = this.matches(te.predictiveSearch)),
                (this.searchForm = this.matches(te.searchForm)),
                (this.selectedElement = null),
                (this.activeElement = null),
                (this.searchTerm = ""),
                (this.currentSearchTerm = ""),
                (this.isSearchPage = document.body.classList.contains(ie)),
                this.input.addEventListener(
                    "input",
                    o((t) => {
                        this.onChange(t);
                    }, 300).bind(this)
                ),
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this)),
                this.isSearchPage && ((this.mainInputType = document.querySelector(`${te.mainInputSearch} ${te.inputType}`)), (this.inputType = this.querySelector(te.inputType)), (this.inputType.value = this.mainInputType.value));
        }
    };
    customElements.define("search-form", se);
    const oe = "predictive-search",
        ne = "#shopify-section-api-predictive-search",
        re = "[data-predictive-search-results]",
        ae = "[data-predictive-search-status]",
        le = "[data-predictive-search-live-region-count-value]",
        ce = "[data-search-results-wrapper]",
        he = "reset",
        de = "data-aos-anchor",
        ue = "aria-hidden",
        pe = "open",
        me = "loading",
        ge = "data-loading-text",
        fe = "results";
    customElements.define(
        "predictive-search",
        class extends se {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t) => {
                    t.target !== this.predictiveSearchResults || this.getQuery().length || (this.classList.remove(he), requestAnimationFrame(() => this.clearResultsHTML()));
                });
            }
            onChange() {
                super.onChange(), this.classList.remove(he), this.searchTerm.length ? requestAnimationFrame(() => this.getSearchResults(this.searchTerm)) : this.classList.add(he);
            }
            onFocus() {
                super.onFocus(), this.currentSearchTerm.length && (this.searchTerm !== this.currentSearchTerm ? this.onChange() : "true" === this.getAttribute(fe) ? this.open() : this.getSearchResults(this.searchTerm));
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit);
                let s = "query";
                (s += window.theme.settings.suggestArticles ? ",article" : ""),
                    (s += window.theme.settings.suggestCollections ? ",collection" : ""),
                    (s += window.theme.settings.suggestProducts ? ",product" : ""),
                    (s += window.theme.settings.suggestPages ? ",page" : ""),
                    this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`, { signal: this.abortController.signal })
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = new Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(ne).innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            switchOption(t) {
                super.switchOption(t), this.statusElement && (this.statusElement.textContent = "");
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(ae)), (this.loadingText = this.loadingText || this.getAttribute(ge)), this.setLiveRegionText(this.loadingText), this.setAttribute(me, !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute(ue, "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute(ue, "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                this.predictiveSearchResults.innerHTML = t;
                const e = this.predictiveSearchResults.parentElement.id,
                    i = this.predictiveSearchResults.querySelector(ce),
                    s = i.id;
                (i.id = `${s}--${e}`), i.setAttribute(de, `#${i.id}`), this.setAttribute(fe, !0), this.setLiveRegionResults(), this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute(me), this.setLiveRegionText(this.querySelector(le).textContent);
            }
            open() {
                this.setAttribute(pe, !0);
            }
            close(t = !1) {
                this.closeResults(t);
            }
            closeResults(t = !1) {
                t && (this.reset(), this.removeAttribute(fe), this.classList.remove(he)), this.removeAttribute(me), this.removeAttribute(pe);
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = "";
            }
            constructor() {
                super(), (this.abortController = new AbortController()), (this.allPredictiveSearchInstances = document.querySelectorAll(oe)), (this.predictiveSearchResults = this.querySelector(re)), (this.cachedResults = {});
            }
        }
    );
    let ye = class extends HTMLElement {
        constructor() {
            super(),
                document.addEventListener("DOMContentLoaded", () => {
                    document.documentElement.classList.remove("page-loading");
                });
        }
    };
    function ve() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function be() {
        return ve() >= window.theme.sizes.small;
    }
    function we() {
        return ve() < window.theme.sizes.small;
    }
    const Se = {
            aos: "[data-aos]:not(.aos-animate)",
            aosAnchor: "[data-aos-anchor]",
            animatable: "[data-aos], [data-aos-anchor]",
            watchMutations: '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
            skeletonLoading: ".skeleton-loading",
            textHighlight: "text-highlight",
            counterUps: "text-count-up",
            flickitySlider: ".flickity-slider",
            slide: "[data-slide]",
            carouselMobile: ".carousel--mobile",
        },
        Ee = { aosAnimate: "aos-animate", isLoading: "is-loading", isSelected: ".is-selected" },
        Le = {
            aos: "data-aos",
            aosAnchor: "data-aos-anchor",
            aosIntersection: "data-aos-intersection",
            aosDebounce: "data-aos-debounce",
            aosCustomInit: "data-aos-custom-init",
            aosWatchAnchors: "data-aos-watch-anchors",
            aosTrigger: "data-aos-trigger",
            aosCarouselMobile: "data-aos-carousel-mobile",
            aosCarouselDesktop: "data-aos-carousel-desktop",
        },
        ke = 0.1,
        Ae = 0;
    let Ce = new Set();
    function qe(t) {
        t.length &&
            (t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                let i;
                "" != e && (i = document.querySelector(e)), i && !Ce.has(t) && Ce.add(i);
            }),
            Ce.forEach((t) => {
                Te.observe(t);
            }));
    }
    const Te = new IntersectionObserver(
        (t, e) => {
            t.forEach((t) => {
                const i = t.target,
                    s = t.intersectionRatio,
                    o = t.isIntersecting;
                let n,
                    r = ke;
                i.hasAttribute(Le.aosIntersection) && (r = Number(i.getAttribute(Le.aosIntersection)));
                let a = Ae;
                i.hasAttribute(Le.aosDebounce) && (a = Number(i.getAttribute(Le.aosDebounce))), o && s > r && (0 !== a ? (n && clearTimeout(n), (n = setTimeout(() => Pe(i), a))) : Pe(i), e.unobserve(i), Ce.delete(i));
            });
        },
        { root: null, rootMargin: "0px", threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1] }
    );
    function Pe(t) {
        if (!t) return;
        xe(t);
        const e = t.closest(Se.skeletonLoading);
        if (
            (e &&
                e.querySelectorAll("img").forEach((t) => {
                    t.classList.contains(Ee.isLoading) && t.setAttribute("loading", "eager");
                }),
            t.hasAttribute(Le.aosCarouselDesktop) && be())
        ) {
            if (t.querySelector(Se.flickitySlider)) {
                const e = t.querySelectorAll(Se.slide),
                    i = [...e].filter((t) => {
                        if (t.matches(Ee.isSelected)) return t;
                    }),
                    s = [...e].filter((t) => {
                        if (!t.matches(Ee.isSelected)) return t;
                    });
                if (i.length > 0) {
                    const t = i[i.length - 1].id;
                    i[i.length - 1].setAttribute(Le.aosTrigger, `#${t}`),
                        s.forEach((e) => {
                            e.querySelectorAll(Se.animatable).forEach((e) => {
                                e.setAttribute(Le.aosAnchor, `#${t}`);
                            });
                        });
                }
            }
        }
        if (t.hasAttribute(Le.aosCarouselMobile) && we()) {
            const e = t.querySelector(Se.carouselMobile);
            if (e) {
                const t = [...e.children],
                    i = t[0].id;
                t.length > 1 &&
                    (t[0].setAttribute(Le.aosTrigger, `#${i}`),
                    t.forEach((t) => {
                        t.querySelectorAll(Se.animatable).forEach((t) => {
                            t.setAttribute(Le.aosAnchor, `#${i}`);
                        });
                    }));
            }
        }
        if (t.hasAttribute(Le.aosTrigger)) {
            const e = t.getAttribute(Le.aosTrigger);
            document.querySelectorAll(`[${Le.aosAnchor}="${e}"]`).forEach((t) => xe(t));
        }
        let i = t.querySelectorAll(Se.aos);
        if (t.hasAttribute(Le.aosWatchAnchors)) {
            i = [...i].filter((e) => {
                const i = !!e.hasAttribute(Le.aosAnchor) && e.getAttribute(Le.aosAnchor);
                if (i && `#${t.id}` === i) return e;
            });
        }
        i.forEach((e) => {
            e.hasAttribute(Le.aosCustomInit) ? t.dispatchEvent(new CustomEvent("theme:target:animate", { bubbles: !0, detail: e })) : xe(e);
        });
    }
    function xe(t) {
        requestAnimationFrame(() => t.classList.add(Ee.aosAnimate)),
            (function (t) {
                const e = t.querySelectorAll(Se.textHighlight);
                e.forEach((t) => t.shouldAnimate());
            })(t),
            (function (t) {
                const e = t.querySelectorAll(Se.counterUps);
                e.forEach((t) => t.shouldAnimate());
            })(t);
    }
    function Ie() {
        qe(document.querySelectorAll(Se.aosAnchor)),
            (function () {
                const t = (t) => t instanceof HTMLElement;
                new MutationObserver((e) => {
                    for (const i of e) {
                        if ("childList" === !i.type) return;
                        const e = i.target,
                            s = [...i.addedNodes],
                            o = [...i.removedNodes],
                            n = e.matches(Se.watchMutations) || s.some((e) => !!t(e) && e.matches(Se.watchMutations)) || o.some((e) => !!t(e) && e.matches(Se.watchMutations)),
                            r = e.matches(Se.animatable) || s.some((e) => !!t(e) && e.matches(Se.animatable)),
                            a = null !== e.querySelector(`[${Le.aosAnchor}="#${e.id}"]`);
                        (r || a || n) && qe(e.querySelectorAll(Se.aosAnchor));
                    }
                }).observe(document.body, { attributes: !1, childList: !0, subtree: !0 });
            })();
    }
    const He = (t) => {
            clearTimeout(t.countUpTimeout), t._countUpOrigInnerHTML && ((t.innerHTML = t._countUpOrigInnerHTML), (t._countUpOrigInnerHTML = void 0)), (t.style.visibility = "");
        },
        Fe = (t, e = {}) => {
            const { duration: i = 1e3, delay: s = 16 } = e,
                o = i / s,
                n = t.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
                r = [];
            for (let t = 0; t < o; t++) r.push("");
            for (let t = 0; t < n.length; t++)
                if (/([0-9.][,.0-9]*[0-9]*)/.test(n[t]) && !/<[^>]+>/.test(n[t])) {
                    let e = n[t];
                    const i = [...e.matchAll(/[.,]/g)].map((t) => ({ char: t[0], i: e.length - t.index - 1 })).sort((t, e) => t.i - e.i);
                    e = e.replace(/[.,]/g, "");
                    let s = r.length - 1;
                    for (let t = o; t >= 1; t--) {
                        let n = parseInt((e / o) * t, 10);
                        (n = i.reduce((t, { char: e, i: i }) => (t.length <= i ? t : t.slice(0, -i) + e + t.slice(-i)), n.toString())), (r[s--] += n);
                    }
                } else for (let e = 0; e < o; e++) r[e] += n[t];
            return (r[r.length] = t.toString()), r;
        };
    const Me = "data-count-up-duration",
        De = "data-count-up-init";
    let Oe = class extends HTMLElement {
        connectedCallback() {
            theme.settings.animationsEnabled || this.startCountUp();
        }
        attributeChangedCallback(t, e, i) {
            null === e && t === De && "true" === i && this.startCountUp();
        }
        shouldAnimate() {
            requestAnimationFrame(() => this.setTriggerAttribute());
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(De, t);
        }
        startCountUp() {
            ((t, e = {}) => {
                const { action: i = "start", duration: s = 1e3, delay: o = 16 } = e;
                if ("stop" === i) return void He(t);
                if ((He(t), !/[0-9]/.test(t.innerHTML))) return;
                const n = Fe(t.innerHTML, { duration: s || t.getAttribute("data-duration"), delay: o || t.getAttribute("data-delay") });
                (t._countUpOrigInnerHTML = t.innerHTML), (t.innerHTML = n[0] || "&nbsp;"), (t.style.visibility = "visible");
                const r = function () {
                    (t.innerHTML = n.shift() || "&nbsp;"), n.length ? (clearTimeout(t.countUpTimeout), (t.countUpTimeout = setTimeout(r, o))) : (t._countUpOrigInnerHTML = void 0);
                };
                t.countUpTimeout = setTimeout(r, o);
            })(this, { duration: this.duration, delay: 0.016 * this.duration });
        }
        constructor() {
            super(), (this.container = this), (this.countUpDuration = this.getAttribute(Me)), (this.duration = (100 / parseInt(this.countUpDuration, 10)) * 1e3);
        }
    };
    !(function (t, e, i) {
        e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
    })(Oe, "observedAttributes", [De]),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (t) {
                var e = Date.now();
                return setTimeout(function () {
                    t({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - e));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.addEventListener("resize", o(et, 50)),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                t > it ? ((ot = !0), (st = !1)) : t < it ? ((ot = !1), (st = !0)) : ((st = null), (ot = null)),
                                    (it = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: st, down: ot, position: t }, bubbles: !1 })),
                                    st && !nt && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    ot && !rt && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (rt = ot),
                                    (nt = st);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", ct),
                window.addEventListener("theme:scroll:unlock", ht);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                if ("img" == t.target.tagName.toLowerCase() && t.target.classList.contains(mt.loading)) {
                    t.target.classList.remove(mt.loading), t.target.parentNode.classList.remove(mt.loading);
                    const e = t.target.closest(gt.section);
                    e && e.classList.add(mt.imgIn);
                }
            },
            !0
        );
    const Be = o(() => {
        p();
    }, 300);
    window.addEventListener("DOMContentLoaded", () => {
        W(), tt(document), pt(document), ft(document), window.theme.settings.animationsEnabled && Ie();
    }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            window.dispatchEvent(new Event("resize"), { bubbles: !0 }), tt(e), pt(e), W(), Be(), A(e), _(), window.theme.settings.animationsEnabled && Ie();
        }),
        document.addEventListener("shopify:section:reorder", (t) => {
            const e = t.target;
            Be(), A(e), _(), window.theme.settings.animationsEnabled && Ie();
        }),
        document.addEventListener("shopify:section:unload", (t) => {
            const e = t.target;
            Be(), A(e), _();
        }),
        customElements.get("text-highlight") || customElements.define("text-highlight", Rt),
        customElements.get("deferred-loading") || customElements.define("deferred-loading", At),
        customElements.get("loading-overlay") || customElements.define("loading-overlay", ye),
        customElements.get("text-count-up") || customElements.define("text-count-up", Oe),
        customElements.get("hover-slideshow") || customElements.define("hover-slideshow", Zt),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
            };
        })();
    const ze = (t, e) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            (s = clearTimeout(s)), !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
        };
    };
    function _e(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    _e.prototype = Error.prototype;
    const $e = "[data-collapsible-single]",
        Ve = "[data-collapsible-trigger]",
        Re = "[data-collapsible-content]",
        Ne = "is-expanded",
        We = "aria-expanded",
        Ue = "aria-controls",
        je = "data-collapsible-trigger-mobile",
        Ge = "data-collapsible-transition-override",
        Ke = 500,
        Qe = {};
    let Ye = class {
        init() {
            this.triggers.forEach((t) => {
                t.addEventListener("click", this.collapsibleToggleEvent), t.addEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        collapsibleToggle(t) {
            t.preventDefault();
            const e = t.target.matches(Ve) ? t.target : t.target.closest(Ve),
                i = e.getAttribute(Ue),
                s = document.getElementById(i),
                o = e.hasAttribute(je),
                n = e.classList.contains(Ne),
                r = t.code === theme.keyboardKeys.SPACE,
                a = t.code === theme.keyboardKeys.ESCAPE,
                l = window.innerWidth < theme.sizes.small;
            (this.isTransitioning && !this.transitionOverride) ||
                ((!t.code || r || a) &&
                    ((!n && a) ||
                        (o && !l) ||
                        ((this.isTransitioning = !0),
                        (e.disabled = !0),
                        this.single &&
                            this.triggers.forEach((t) => {
                                const i = t.classList.contains(Ne);
                                if (e == t || !i) return;
                                const s = t.getAttribute(Ue),
                                    o = document.getElementById(s);
                                requestAnimationFrame(() => {
                                    this.closeItem(o, t);
                                });
                            }),
                        n
                            ? requestAnimationFrame(() => {
                                  this.closeItem(s, e);
                              })
                            : requestAnimationFrame(() => {
                                  this.openItem(s, e);
                              }))));
        }
        openItem(t, e) {
            let i = t.querySelector(Re).offsetHeight;
            this.setDropdownHeight(t, i, e, !0), e.classList.add(Ne), e.setAttribute(We, !0), e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } }));
        }
        closeItem(t, e) {
            let i = t.querySelector(Re).offsetHeight;
            requestAnimationFrame(() => {
                (i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(Ne);
            }),
                this.setDropdownHeight(t, i, e, !1),
                e.classList.remove(Ne),
                e.setAttribute(We, !1);
        }
        setDropdownHeight(t, e, i, s) {
            (t.style.height = `${e}px`),
                t.setAttribute(We, s),
                t.classList.toggle(Ne, s),
                this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
                0 == e &&
                    (this.resetHeightTimer = setTimeout(() => {
                        t.style.height = "";
                    }, Ke)),
                s
                    ? (this.resetHeightTimer = setTimeout(() => {
                          (t.style.height = "auto"), (this.isTransitioning = !1);
                      }, Ke))
                    : (this.isTransitioning = !1),
                setTimeout(() => {
                    i.disabled = !1;
                }, Ke);
        }
        onUnload() {
            this.triggers.forEach((t) => {
                t.removeEventListener("click", this.collapsibleToggleEvent), t.removeEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        constructor(t) {
            (this.container = t),
                (this.single = this.container.querySelector($e)),
                (this.triggers = this.container.querySelectorAll(Ve)),
                (this.resetHeightTimer = 0),
                (this.isTransitioning = !1),
                (this.transitionOverride = this.container.hasAttribute(Ge)),
                (this.collapsibleToggleEvent = (t) => ze(this.collapsibleToggle(t), 1250)),
                this.init();
        }
    };
    const Xe = {
            onLoad() {
                Qe[this.id] = new Ye(this.container);
            },
            onUnload() {
                Qe[this.id].onUnload();
            },
        },
        Je = "[data-quantity-holder]",
        Ze = "[data-quantity-field]",
        ti = "[data-quantity-button]",
        ei = "[data-quantity-minus]",
        ii = "[data-quantity-plus]",
        si = "read-only",
        oi = "is-disabled";
    let ni = class {
        init() {
            (this.quantity = this.holder.querySelector(Je)),
                this.quantity &&
                    ((this.field = this.quantity.querySelector(Ze)),
                    (this.buttons = this.quantity.querySelectorAll(ti)),
                    (this.increaseButton = this.quantity.querySelector(ii)),
                    (this.quantityValue = Number(this.field.value || 0)),
                    (this.cartItemID = this.field.getAttribute("data-id")),
                    (this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
                    (this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
                    (this.disableIncrease = this.disableIncrease.bind(this)),
                    (this.emptyField = !1),
                    (this.updateQuantity = this.updateQuantity.bind(this)),
                    (this.decrease = this.decrease.bind(this)),
                    (this.increase = this.increase.bind(this)),
                    this.disableIncrease(),
                    this.quantity.classList.contains(si) || (this.changeValueOnClick(), this.changeValueOnInput()));
        }
        changeValueOnClick() {
            this.buttons.forEach((t) => {
                t.addEventListener("click", (t) => {
                    t.preventDefault(), (this.quantityValue = Number(this.field.value || 0));
                    const e = t.target,
                        i = e.matches(ei) || e.closest(ei),
                        s = e.matches(ii) || e.closest(ii);
                    i && this.decrease(), s && this.increase(), this.updateQuantity();
                });
            });
        }
        changeValueOnInput() {
            this.field.addEventListener("input", () => {
                (this.quantityValue = this.field.value), this.updateQuantity();
            });
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
                this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
                (this.field.value = this.quantityValue),
                this.disableIncrease(),
                this.quantityUpdateCart ? (document.dispatchEvent(new CustomEvent("theme:cart:update")), this.updateCart()) : this.triggerInputChange();
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
        }
        increase() {
            this.quantityValue++;
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(oi, this.quantityValue >= this.maxValue && null !== this.maxValue);
        }
        updateCart() {
            if ("" === this.quantityValue) return;
            const t = new CustomEvent("theme:cart:update", { bubbles: !0, detail: { id: this.cartItemID, quantity: this.quantityValue } });
            this.holder.dispatchEvent(t);
        }
        triggerInputChange() {
            this.field.dispatchEvent(new Event("change"));
        }
        constructor(t, e = !1) {
            (this.holder = t), (this.quantityUpdateCart = e);
        }
    };
    const ri = {
        state: { firstFocusable: null, lastFocusable: null, trigger: null, mainTrigger: null },
        trapFocus: function (t) {
            var e = Array.from(t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (t) {
                var e = t.offsetWidth,
                    i = t.offsetHeight;
                return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display");
            });
            (e = e.filter(function (t) {
                return !t.classList.contains("deferred-media__poster");
            })),
                (this.state.firstFocusable = e[0]),
                (this.state.lastFocusable = e[e.length - 1]),
                t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler),
                t.container.setAttribute("tabindex", "-1"),
                t.elementToFocus.focus();
        },
        removeTrapFocus: function (t) {
            const e = !document.body.classList.contains("no-outline");
            t && t.container && t.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler), this.state.trigger && e && this.state.trigger.focus();
        },
        _manageFocus: function (t) {
            t.code === theme.keyboardKeys.TAB &&
                (t.target !== this.state.lastFocusable || t.shiftKey || (t.preventDefault(), this.state.firstFocusable.focus()),
                t.target === this.state.firstFocusable && t.shiftKey && (t.preventDefault(), this.state.lastFocusable.focus()));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (t) {
            (t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable) || document.addEventListener("keydown", this._manageFocusHandler);
        },
        _setupHandlers: function () {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
        },
    };
    const ai = {};
    function li(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return ai[t.url]
                ? ai[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((o = !0), e());
                                        }),
                                        s.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (ai[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return ai[t.json]
                ? Promise.resolve(ai[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((ai[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return ai[e]
                ? ai[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (ai[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    const ci = "[data-video-id]",
        hi = "loaded",
        di = "data-enable-sound",
        ui = "data-enable-background",
        pi = "data-enable-autoplay",
        mi = "data-enable-loop",
        gi = "data-video-id",
        fi = "data-video-type";
    const yi = { videoIframe: "[data-video-id]", videoWrapper: ".video-wrapper", youtubeWrapper: "[data-youtube-wrapper]" },
        vi = "data-section-id",
        bi = "data-enable-sound",
        wi = "data-check-player-visibility",
        Si = "data-video-id",
        Ei = "data-video-type",
        Li = "loaded",
        ki = [];
    const Ai = "[data-notification-form]",
        Ci = "[data-notification]",
        qi = "[data-popup-close]",
        Ti = "pswp--success",
        Pi = "notification-popup-visible";
    function xi(t) {
        const i = e.data(t);
        i &&
            (i.on("dragStart", (t, e) => {
                document.ontouchmove = function (t) {
                    t.preventDefault();
                };
            }),
            i.on("dragEnd", (t, e) => {
                document.ontouchmove = function (t) {
                    return !0;
                };
            }));
    }
    const Ii = "html5",
        Hi = "youtube",
        Fi = "vimeo",
        Mi = "[data-deferred-media]",
        Di = "[data-deferred-media-button]",
        Oi = "[data-product-single-media-wrapper]",
        Bi = "[data-video]",
        zi = ".media--hidden",
        _i = "media--hidden",
        $i = "loaded",
        Vi = "data-section-id",
        Ri = "data-autoplay-video",
        Ni = "data-media-id";
    let Wi = class {
        init() {
            this.container.querySelectorAll(Bi).forEach((t) => {
                const e = t.querySelector(Di);
                e && e.addEventListener("click", this.loadContent.bind(this, t)), this.autoplayVideo && this.loadContent(t);
            });
        }
        loadContent(t) {
            if (t.querySelector(Mi).getAttribute($i)) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(Mi);
            n.appendChild(s),
                n.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: o,
                    ready: () => {
                        this.createPlayer(i);
                    },
                });
            const r = this.players[i];
            switch (r.host) {
                case Ii:
                    this.loadVideo(r, Ii);
                    break;
                case Fi:
                    window.isVimeoAPILoaded ? this.loadVideo(r, Fi) : li({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(r, Fi));
                    break;
                case Hi:
                    window.isYoutubeAPILoaded ? this.loadVideo(r, Hi) : li({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, Hi));
            }
        }
        hostFromVideoElement(t) {
            if ("VIDEO" === t.tagName) return Ii;
            if ("IFRAME" === t.tagName) {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)) return Hi;
                if (t.src.includes("vimeo.com")) return Fi;
            }
            return null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t];
            switch (e.host) {
                case Ii:
                    e.element.addEventListener("play", () => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                        e.element.addEventListener("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case Fi:
                    (e.player = new Vimeo.Player(e.element)),
                        e.player.play(),
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                        (window.isVimeoAPILoaded = !0),
                        e.player.on("play", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                        }),
                        e.player.on("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case Hi:
                    if (e.host == Hi && e.player) return;
                    YT.ready(() => {
                        const i = e.container.dataset.videoId;
                        (e.player = new YT.Player(e.element, {
                            videoId: i,
                            events: {
                                onReady: (t) => {
                                    t.target.playVideo(), e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                                },
                                onStateChange: (t) => {
                                    1 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                                        2 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 }),
                                        0 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            this.autoplayVideo && this.observeVideo(e, t);
                    });
            }
            e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)), e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)), e.container.addEventListener("xrLaunch", (t) => this.onHidden(t));
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        const i = 0 == e.intersectionRatio,
                            s = !t.element.closest(zi);
                        i ? this.pauseVideo(t) : s && this.playVideo(t);
                    });
                },
                { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
            ).observe(t.element);
        }
        playVideo(t) {
            t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play ? t.element.play() : t.player && t.player.play && t.player.play(),
                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
        }
        pauseVideo(t) {
            if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
            else if (t.player && t.player.pause) t.player.pause();
            else if (t.element && !t.element.paused) {
                var e;
                if ("function" == typeof t.element.pause) null === (e = t.element) || void 0 === e || e.pause();
            }
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                setTimeout(() => {
                    this.playVideo(i);
                }, 50),
                    this.pauseContainerMedia(e);
            }
        }
        pauseOtherMedia(t, e) {
            const i = `[${Ni}="${t}"]`,
                s = e.querySelectorAll(`${Oi}:not(${i})`);
            s.length &&
                s.forEach((t) => {
                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(_i);
                });
        }
        constructor(t) {
            (this.container = t),
                (this.id = this.container.getAttribute(Vi)),
                (this.autoplayVideo = "true" === this.container.getAttribute(Ri)),
                (this.players = {}),
                (this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e)),
                this.init();
        }
    };
    function Ui(t, e, i = [], s = !1) {
        const o = new FormData(t),
            n = new URLSearchParams(o);
        if (!e) return n.toString();
        const r = new FormData(e),
            a = new URLSearchParams(r),
            l = [];
        for (const t of o.entries()) "" === t[1] && l.push(t[0]);
        for (const t of r.entries()) "" === t[1] && l.push(t[0]);
        for (let t = 0; t < l.length; t++) {
            const e = l[t];
            n.has(e) && n.delete(e), a.has(e) && a.delete(e);
        }
        for (const t of n.keys()) a.has(t) && a.delete(t);
        if (i.length > 0)
            for (let t = 0; t < i.length; t++) {
                const e = i[t];
                n.has(e) && n.delete(e), a.has(e) && a.delete(e);
            }
        return s && (a.has("type") && a.delete("type"), n.set("type", s)), `${n.toString()}&${a.toString()}`;
    }
    const ji = "[data-custom-scrollbar]",
        Gi = "[data-custom-scrollbar-items]",
        Ki = "[data-custom-scrollbar-thumb]",
        Qi = ".current";
    let Yi = class {
        calculateTrack(t) {
            if (!t) return this.scrollbar.style.setProperty("--thumb-scale", 0), void this.scrollbar.style.setProperty("--thumb-position", "0px");
            const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            this.scrollbar.style.setProperty("--thumb-scale", e), this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px");
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const t = [...this.scrollbarItems.children];
                (this.trackWidth = 0),
                    t.forEach((t) => {
                        this.trackWidth += t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight);
                    }),
                    this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`);
            }
        }
        onScrollbarChange(t) {
            t && t.detail && t.detail.element && this.container.contains(t.detail.element) && this.calculateTrack(t.detail.element);
        }
        events() {
            document.addEventListener("theme:resize:width", this.calcScrollbarEvent), document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.calcScrollbarEvent), document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        constructor(t) {
            (this.container = t),
                (this.scrollbarItems = t.querySelector(Gi)),
                (this.scrollbar = t.querySelector(ji)),
                (this.scrollbarThumb = t.querySelector(Ki)),
                (this.trackWidth = 0),
                (this.calcScrollbarEvent = () => this.calculateScrollbar()),
                (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
                this.scrollbar && this.scrollbarItems && (this.events(), this.calculateScrollbar(), this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector(Qi)));
        }
    };
    const Xi = "[data-tooltip]",
        Ji = "[data-tooltip-container]",
        Zi = "[data-tooltip-arrow]",
        ts = "[data-aos]",
        es = "tooltip-default",
        is = "is-animating",
        ss = "is-visible",
        os = "is-hiding",
        ns = "data-aos",
        rs = "data-tooltip",
        as = "data-tooltip-container",
        ls = "data-tooltip-stop-mouseenter",
        cs = {};
    let hs = class {
        init() {
            if (!document.querySelector(Ji)) {
                const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`,
                    e = document.createElement("div");
                (e.className = `${this.rootClass} ${this.isAnimatingClass}`), e.setAttribute(as, ""), (e.innerHTML = t), document.body.appendChild(e);
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                document.addEventListener("theme:tooltip:close", this.removePinEvent);
            const t = document.querySelector(Ji);
            theme.settings.animationsEnabled &&
                this.animatedContainer &&
                ("hero" === this.animatedContainer.getAttribute(ns)
                    ? this.animatedContainer.addEventListener("animationend", () => {
                          t.classList.remove(is);
                      })
                    : this.animatedContainer.addEventListener("transitionend", (e) => {
                          "transform" === e.propertyName && t.classList.remove(is);
                      }));
        }
        addPin(t = !1) {
            const e = document.querySelector(Ji),
                i = e.querySelector(Zi);
            if (e && ((t && !this.tooltip.hasAttribute(ls)) || !t)) {
                const t = e.querySelector(`.${this.rootClass}__inner`),
                    s = e.querySelector(`.${this.rootClass}__text`);
                this.label.includes("ß") && (this.label = this.label.replace(/ß/g, '<span style="text-transform: lowercase;">ß</span>')), (s.innerHTML = this.label);
                const o = t.offsetWidth,
                    n = this.tooltip.getBoundingClientRect(),
                    r = n.top,
                    a = n.width,
                    l = r + n.height + window.scrollY;
                let c = n.left - o / 2 + a / 2,
                    h = "50%";
                const d = c + o - window.innerWidth;
                d > 0 && (c -= d), c < 0 && ((h = `calc(50% + ${c}px)`), (c = 0)), (i.style.left = h), (e.style.transform = `translate(${c}px, ${l}px)`), e.classList.remove(os);
                const u = (i) => {
                    i.target === t && (("transform" !== i.propertyName && "opacity" !== i.propertyName) || requestAnimationFrame(() => (e.style.transform = "translate(0, -100%)")), e.removeEventListener("transitionend", u));
                };
                e.addEventListener("transitionend", u), e.classList.add(ss), document.addEventListener("theme:scroll", this.removePinEvent);
            }
        }
        removePin(t, e = !1, i = !1) {
            const s = document.querySelector(Ji),
                o = s.classList.contains(ss);
            s &&
                ((e && !this.tooltip.hasAttribute(ls)) || !e) &&
                (o &&
                    (i || t.detail.hideTransition) &&
                    (s.classList.add(os),
                    this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                    (this.hideTransitionTimeout = setTimeout(() => {
                        s.classList.remove(os);
                    }, this.transitionSpeed))),
                s.classList.remove(ss),
                document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                document.removeEventListener("theme:scroll", this.removePinEvent);
        }
        constructor(t) {
            (this.tooltip = t),
                this.tooltip.hasAttribute(rs) &&
                    ((this.rootClass = es),
                    (this.isAnimatingClass = is),
                    (this.label = this.tooltip.getAttribute(rs)),
                    (this.transitionSpeed = 200),
                    (this.hideTransitionTimeout = 0),
                    (this.animatedContainer = this.tooltip.closest(ts)),
                    (this.addPinEvent = () => this.addPin()),
                    (this.addPinMouseEvent = () => this.addPin(!0)),
                    (this.removePinEvent = (t) => ze(this.removePin(t), 50)),
                    (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                    this.init());
        }
    };
    const ds = {
            onLoad() {
                cs[this.id] = [];
                this.container.querySelectorAll(Xi).forEach((t) => {
                    cs[this.id].push(new hs(t));
                });
            },
            onUnload() {
                cs[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        us = "[data-range-slider]",
        ps = "[data-range-left]",
        ms = "[data-range-right]",
        gs = "[data-range-line]",
        fs = "[data-range-holder]",
        ys = "data-se-min",
        vs = "data-se-max",
        bs = "data-se-min-value",
        ws = "data-se-max-value",
        Ss = "data-se-step",
        Es = "data-range-filter-update",
        Ls = "[data-field-price-min]",
        ks = "[data-field-price-max]",
        As = "is-initialized";
    function Cs() {
        this.entries = [];
    }
    function qs(t, e) {
        Ts(t);
        var i = (function (t, e) {
            Ts(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            Ts(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e);
            var i = t.variants.filter(function (t) {
                return e.every(function (e, i) {
                    return t.options[i] === e;
                });
            });
            return i[0] || null;
        })(t, i);
    }
    function Ts(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (Cs.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (Cs.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var Ps = '[name="id"]',
        xs = '[name="selling_plan"]',
        Is = '[name^="options"]',
        Hs = '[name="quantity"]',
        Fs = '[name^="properties"]';
    const Ms = { color: "ash" },
        Ds = "[data-swatch]",
        Os = "[data-product-block]",
        Bs = "[data-product-image-hover]",
        zs = "[data-button-quick-view]",
        _s = "[data-grid-image]",
        $s = "[data-grid-link]",
        Vs = "[data-swatches-more]",
        Rs = "[data-section-type]",
        Ns = "[data-swatches-container]",
        Ws = "[data-swatches-label]",
        Us = "[data-swatches-button]",
        js = "[data-option-position]",
        Gs = "[data-slider]",
        Ks = ".variant__labels--hide",
        Qs = {
            mediaVisible: "product__media--featured-visible",
            mediaHoverVisible: "product__media__hover-img--visible",
            noImage: "swatch__link--no-image",
            noOutline: "no-outline",
            isVisible: "is-visible",
            selectorLarge: "selector-wrapper--large",
        },
        Ys = "data-swatch",
        Xs = "data-swatch-handle",
        Js = "data-swatch-label",
        Zs = "data-swatch-image",
        to = "data-swatch-image-id",
        eo = "data-swatch-variant",
        io = "data-variant-id",
        so = "data-variant-secondary-id";
    let oo = {};
    const no = {};
    let ro = class {
            init() {
                this.setStyles(), this.variant && this.outer && this.handleClicks(), !this.image && this.swatchLink && this.swatchLink.classList.add(Qs.noImage);
            }
            setStyles() {
                "native" == window.theme.settings.colorSwatchesType ||
                    (this.colorMatch && this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch && this.colorMatch.path && this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`));
            }
            handleClicks() {
                this.swatchLink.addEventListener("click", (t) => {
                    const e = !document.body.classList.contains(Qs.noOutline),
                        i = this.swatchLink.getAttribute(eo);
                    e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
                }),
                    this.swatchLink.addEventListener("keyup", (t) => {
                        const e = !document.body.classList.contains(Qs.noOutline),
                            i = this.swatchLink.getAttribute(eo);
                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
                            e ||
                            (t.preventDefault(), this.swatchLink.dispatchEvent(new Event("mouseenter", { bubbles: !0 })), this.updateImagesAndLinksOnEvent(i));
                    });
            }
            updateImagesAndLinksOnEvent(t) {
                this.updateLinks(), this.replaceImages(t);
            }
            updateLinks() {
                (this.linkElements = this.outer.querySelectorAll($s)),
                    (this.quickView = this.outer.querySelector(zs)),
                    this.linkElements.length &&
                        this.linkElements.forEach((t) => {
                            const e = ((i = t.getAttribute("href")), (s = this.variant), /variant=/.test(i) ? i.replace(/(variant=)[^&]+/, "$1" + s) : /\?/.test(i) ? i.concat("&variant=").concat(s) : i.concat("?variant=").concat(s));
                            var i, s;
                            t.setAttribute("href", e);
                        }),
                    this.quickView && "quick_buy" === theme.settings.quickBuy && this.quickView.setAttribute(io, this.variant);
            }
            replaceImages(t) {
                const e = this.outer.querySelector(`[${so}="${t}"]`),
                    i = this.outer.querySelector(`[${io}="${t}"]`),
                    s = [...this.outer.querySelectorAll(_s)].find((t) => t.classList.contains(Qs.mediaVisible));
                if (i && this.imageId) {
                    if (!e || !s) return;
                    const t = () => {
                        requestAnimationFrame(() => {
                            s.classList.remove(Qs.mediaVisible),
                                i.classList.add(Qs.mediaVisible),
                                requestAnimationFrame(() => {
                                    e.classList.remove(Qs.mediaVisible);
                                });
                        }),
                            e.removeEventListener("animationend", t);
                    };
                    requestAnimationFrame(() => {
                        e.classList.add(Qs.mediaVisible);
                    }),
                        e.addEventListener("animationend", t);
                }
                "image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll(Bs)),
                    this.hoverImages.length > 1 &&
                        this.hoverImages.forEach((t) => {
                            t.classList.remove(Qs.mediaHoverVisible), t.getAttribute(io) === this.variant ? t.classList.add(Qs.mediaHoverVisible) : this.hoverImages[0].classList.add(Qs.mediaHoverVisible);
                        });
            }
            constructor(t) {
                (this.element = t),
                    (this.swatchLink = this.element.nextElementSibling),
                    (this.colorString = t.getAttribute(Ys)),
                    (this.image = this.element.getAttribute(Zs)),
                    (this.imageId = this.element.getAttribute(to)),
                    (this.variant = this.element.getAttribute(eo)),
                    (this.outer = this.element.closest(Os)),
                    (this.hoverImages = []);
                const e = new (class {
                    getColor() {
                        return this.match;
                    }
                    init() {
                        return li({ json: theme.assets.swatches })
                            .then((t) => this.matchColors(t, this.settings.color))
                            .catch((t) => {
                                console.log("failed to load swatch colors script"), console.log(t);
                            });
                    }
                    matchColors(t, e) {
                        let i = "#E5E5E5",
                            s = null;
                        const o = theme.assets.base || "/",
                            n = e.toLowerCase().replace(/\s/g, ""),
                            r = t.colors;
                        if (r) {
                            let t = null;
                            if (
                                r.filter((e, i) => {
                                    if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n) return (t = i), e;
                                }).length &&
                                null !== t
                            ) {
                                const e = Object.values(r[t])[0];
                                (i = e), (e.includes(".jpg") || e.includes(".jpeg") || e.includes(".png") || e.includes(".svg")) && ((s = `${o}${e}`), (i = "#888888"));
                            }
                        }
                        return { color: this.settings.color, path: s, hex: i };
                    }
                    constructor(t = {}) {
                        (this.settings = { ...Ms, ...t }), (this.match = this.init());
                    }
                })({ color: this.colorString });
                e.getColor().then((t) => {
                    (this.colorMatch = t), this.init();
                });
            }
        },
        ao = class extends HTMLElement {
            init() {
                (this.swatchElements = this.querySelectorAll(Ds)),
                    this.swatchElements.forEach((t) => {
                        new ro(t);
                    }),
                    this.handleShowMore();
            }
            handleShowMore() {
                (this.initialHeight = this.offsetHeight), (this.expandedHeight = this.initialHeight);
                const t = this.closest(Rs),
                    e = this.querySelector(Vs);
                e &&
                    (null == e ||
                        e.addEventListener("click", () => {
                            this.classList.add(Qs.isVisible);
                        }),
                    null == t ||
                        t.addEventListener("touchstart", (t) => {
                            this.contains(t.target) || (this.classList.remove(Qs.isVisible), this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
                        }),
                    this.addEventListener("mouseenter", () => {
                        const t = (e) => {
                            this.expandedHeight = this.offsetHeight;
                            const i = e.target.closest(Gs);
                            this.expandedHeight > this.initialHeight && i && requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))), this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }),
                    this.addEventListener("mouseleave", () => {
                        const t = (e) => {
                            const i = e.target.closest(Gs);
                            this.expandedHeight > this.initialHeight && i && requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))), this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }));
            }
            constructor() {
                super(),
                    (this.handle = this.getAttribute(Xs)),
                    (this.label = this.getAttribute(Js).trim().toLowerCase()),
                    (function (t) {
                        const e = `${theme.routes.root}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        (this.product = t), (this.colorOption = t.options.find((t) => t.name.toLowerCase() === this.label || null)), this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
            }
        },
        lo = class {
            checkSwatchesHeight(t) {
                const e = t.querySelector(Ws),
                    i = Boolean(e.closest(Ks)),
                    s = i ? 1 : e.offsetHeight,
                    o = t.querySelector(Us),
                    n = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
                    r = i ? 0 : parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
                    a = parseInt(window.getComputedStyle(o).getPropertyValue("margin-bottom")),
                    l = t.closest(js);
                l.classList.remove(Qs.selectorLarge, Qs.selectorVisible),
                    t.style.removeProperty("--swatches-max-height"),
                    requestAnimationFrame(() => {
                        t.offsetHeight - n > s + r + 2 * o.offsetHeight + 2 * a && (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`), l.classList.add(Qs.selectorLarge));
                    });
            }
            onUnload() {
                this.swatchesContainers.forEach((t) => {
                    document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                });
            }
            constructor(t) {
                (this.container = t),
                    (this.swatchesContainers = this.container.querySelectorAll(Ns)),
                    this.swatchesContainers.forEach((t) => {
                        (this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t)), this.checkSwatchesHeight(t), document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                    });
            }
        };
    const co = (t) => {
            oo = [];
            t.querySelectorAll(Ds).forEach((t) => {
                oo.push(new ro(t));
            });
        },
        ho = {
            onLoad() {
                co(this.container);
            },
        },
        uo = {
            onLoad() {
                no[this.id] = new lo(this.container);
            },
            onUnload() {
                no[this.id].onUnload();
            },
        },
        po = "[data-product]",
        mo = "[data-popup-close]",
        go = "js-quick-view-visible",
        fo = {};
    let yo = class {
        popupClose() {
            const t = document.querySelector(po);
            if (t) {
                t.querySelector(mo).dispatchEvent(new Event("click"));
            }
        }
        onBlockSelect() {
            this.body.classList.contains(go) && this.popupClose();
        }
        onDeselect() {
            this.body.classList.contains(go) && this.popupClose();
        }
        onUnload() {
            this.body.classList.contains(go) && this.popupClose();
        }
        constructor(t) {
            (this.container = t), (this.body = document.body), new gh(this.container);
        }
    };
    const vo = {
            onLoad() {
                fo[this.id] = new yo(this.container);
            },
            onBlockSelect() {
                fo[this.id].onBlockSelect();
            },
            onDeselect() {
                fo[this.id].onDeselect();
            },
            onUnload() {
                fo[this.id].onUnload();
            },
        },
        bo = "#AjaxinateLoop",
        wo = "#AjaxinatePagination",
        So = "[data-product-block]",
        Eo = "[data-promo]",
        Lo = "data-ajaxinate-id",
        ko = "data-columns-tablet",
        Ao = "data-columns-mobile",
        Co = "is-loaded",
        qo = "loaded-item",
        To = "collection-promo--full",
        Po = "collection-promo--two-columns",
        xo = "collection-promo--grid-second",
        Io = "collection-promo--grid-third",
        Ho = "collection-promo--grid-even",
        Fo = "collection-promo--one-column";
    let Mo = {},
        Do = class {
            init() {
                this.loadMoreFix(),
                    (this.ajaxinateContainer = this.container.querySelectorAll(bo)),
                    this.ajaxinateContainer.forEach((t) => {
                        const e = `${bo}[${Lo}="${t.dataset.ajaxinateId}"]`,
                            i = `${wo}[${Lo}="${t.dataset.ajaxinateId}"]`;
                        if (t.children.length > 0) {
                            const o = new s({ container: e, pagination: i, method: "scroll" }),
                                n = t.querySelectorAll(Eo),
                                r = Number(t.getAttribute(ko)),
                                a = Number(t.getAttribute(Ao));
                            if (r >= 3) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        t.classList.contains(To)
                                            ? t.classList.contains(Io)
                                                ? (e += 1)
                                                : t.classList.contains(xo)
                                                ? (e += 2)
                                                : (e += 3)
                                            : t.classList.contains(Po)
                                            ? t.classList.contains(Io)
                                                ? (e += 1)
                                                : (e += 2)
                                            : (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = r - (e % r);
                                    i === r && (i = 0), t.classList.add(`grid--empty-items-tablet-${i}`);
                                }
                            }
                            if (2 === a) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        (t.classList.contains(Ho) || t.classList.contains(Fo)) && (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = a - (e % a);
                                    i === a && (i = 0), t.classList.add(`grid--empty-items-mobile-${i}`);
                                }
                            }
                            t.classList.add(Co), this.endlessScroll.push(o);
                        }
                    });
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(bo);
                const e = (e) => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    const t = this.endlessScroll.findIndex(e);
                    this.endlessScroll.splice(t, 1), (i.settings.method = "scroll"), i.destroy();
                }
                const o = [...this.ajaxinateContainer].find((e) => `${bo}[${Lo}="${e.dataset.ajaxinateId}"]` === t);
                if (!o) return;
                const n = `${bo}[${Lo}="${o.dataset.ajaxinateId}"]`,
                    r = `${wo}[${Lo}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                const a = new s({ container: n, pagination: r, method: "scroll" });
                o.classList.add(Co), this.endlessScroll.push(a);
            }
            loadMoreFix() {
                s.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (4 === !this.request.readyState || 200 === !this.request.status) return;
                            const t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            t.querySelectorAll(So).forEach((t) => t.classList.add(qo)),
                                this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML), this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML), this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll.length > 0 &&
                    (this.endlessScroll.forEach((t) => {
                        (t.settings.method = "scroll"), t.destroy();
                    }),
                    this.ajaxinateContainer.forEach((t) => t.classList.remove(Co)));
            }
            constructor(t) {
                (this.container = t), (this.endlessScroll = []), theme.settings.enableInfinityScroll && this.init();
            }
        };
    const Oo = {
            onLoad() {
                Mo = new Do(this.container);
            },
            onUnload: function () {
                "function" == typeof Mo.unload && Mo.unload();
            },
        },
        Bo = 300,
        zo = "[data-toggle-filters]",
        _o = "[data-close-filters]",
        $o = "[data-open-filters]",
        Vo = "[data-collection-wrapper]",
        Ro = "[data-collapsible-trigger]",
        No = "[data-sort-toggle]",
        Wo = "[data-collection-sort-options]",
        Uo = "[data-input-sort]",
        jo = "[data-collection-filters]",
        Go = "[data-collection-filters-list]",
        Ko = "[data-collection-sticky-bar]",
        Qo = "[data-collection-filter]",
        Yo = "[data-collection-filter-tag]",
        Xo = "[data-collection-filter-tag-button]",
        Jo = "[data-collection-filters-form]",
        Zo = "[data-filter-reset-button]",
        tn = "[data-filter-tag-reset-button]",
        en = '[data-section-type="popups"]',
        sn = "[data-collection-products]",
        on = "[data-products-count]",
        nn = "[data-field-price-min]",
        rn = "[data-field-price-max]",
        an = "[data-se-min-value]",
        ln = "[data-se-max-value]",
        cn = "data-se-min-value",
        hn = "data-se-max-value",
        dn = "data-se-min",
        un = "data-se-max",
        pn = "[data-tooltip]",
        mn = "[data-tooltip-container]",
        gn = "[data-show-more]",
        fn = "[data-show-more-actions]",
        yn = "[data-show-more-container]",
        vn = "[data-show-more-trigger]",
        bn = "[data-search-performed]",
        wn = "[data-search-form]",
        Sn = "[data-custom-scrollbar]",
        En = "is-active",
        Ln = "is-expanded",
        kn = "is-visible",
        An = "is-loading",
        Cn = "popup--visible",
        qn = "collection__filters--visible",
        Tn = "collection__sort__option-wrapper--visible",
        Pn = "data-filter-active",
        xn = "data-prevent-scroll-lock",
        In = "data-filters-default-state",
        Hn = "tabindex",
        Fn = "aria-expanded",
        Mn = "data-current-type",
        Dn = {};
    let On = class {
        initFacetedFilters() {
            "tag" != this.filterMode &&
                "group" != this.filterMode &&
                this.enableFilters &&
                (this.rangeSlider = new (class {
                    init() {
                        if (((this.slider = this.container.querySelector(us)), !this.slider)) return;
                        (this.resizeFilters = o(this.reset.bind(this), 50)),
                            (this.onMoveEvent = (t) => this.onMove(t)),
                            (this.onStopEvent = (t) => this.onStop(t)),
                            (this.onStartEvent = (t) => this.onStart(t)),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.touchLeft = this.slider.querySelector(ps)),
                            (this.touchRight = this.slider.querySelector(ms)),
                            (this.lineSpan = this.slider.querySelector(gs)),
                            (this.min = parseFloat(this.slider.getAttribute(ys))),
                            (this.max = parseFloat(this.slider.getAttribute(vs))),
                            (this.step = 0),
                            (this.normalizeFact = 20);
                        let t = this.min;
                        this.slider.hasAttribute(bs) && (t = parseFloat(this.slider.getAttribute(bs)));
                        let e = this.max;
                        this.slider.hasAttribute(ws) && (e = parseFloat(this.slider.getAttribute(ws))),
                            t < this.min && (t = this.min),
                            e > this.max && (e = this.max),
                            t > e && (t = e),
                            this.slider.getAttribute(Ss) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Ss)))),
                            this.reset(),
                            window.addEventListener("theme:resize", this.resizeFilters),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.selectedTouch = null),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                            this.setMinValue(t),
                            this.setMaxValue(e),
                            this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                            this.touchRight.addEventListener("mousedown", this.onStartEvent),
                            this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.slider.classList.add(As);
                    }
                    reset() {
                        (this.touchLeft.style.left = "0px"),
                            (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.lineSpan.style.marginLeft = "0px"),
                            (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
                    }
                    setMinValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(bs, t);
                    }
                    setMaxValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(ws, t);
                    }
                    onStart(t) {
                        t.preventDefault();
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                            (this.startX = e.pageX - this.x),
                            (this.selectedTouch = t.currentTarget),
                            document.addEventListener("mousemove", this.onMoveEvent),
                            document.addEventListener("mouseup", this.onStopEvent),
                            document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
                    }
                    onMove(t) {
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            (this.x = e.pageX - this.startX),
                            this.selectedTouch === this.touchLeft
                                ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                                  (this.selectedTouch.style.left = this.x + "px"))
                                : this.selectedTouch === this.touchRight &&
                                  (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                                  (this.selectedTouch.style.left = this.x + "px")),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.calculateValue(),
                            this.slider.getAttribute("on-change") && new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(bs), this.slider.getAttribute(ws)),
                            this.onChange(this.slider.getAttribute(bs), this.slider.getAttribute(ws));
                    }
                    onStop(t) {
                        document.removeEventListener("mousemove", this.onMoveEvent),
                            document.removeEventListener("mouseup", this.onStopEvent),
                            document.removeEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.removeEventListener("touchend", this.onStopEvent, { passive: !0 }),
                            (this.selectedTouch = null),
                            this.calculateValue(),
                            this.onChanged(this.slider.getAttribute(bs), this.slider.getAttribute(ws));
                    }
                    onChange(t, e) {
                        const i = this.slider.closest(fs);
                        if (i) {
                            const s = i.querySelector(Ls),
                                o = i.querySelector(ks);
                            s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
                        }
                    }
                    onChanged(t, e) {
                        this.slider.hasAttribute(Es) && this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
                    }
                    calculateValue() {
                        const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
                        let e = this.lineSpan.offsetLeft / this.initialValue,
                            i = e + t;
                        if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                            let t = Math.floor(e / this.step);
                            (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
                        }
                        this.selectedTouch === this.touchLeft && this.slider.setAttribute(bs, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(ws, i);
                    }
                    unload() {
                        document.removeEventListener("theme:filters:init", this.initListener), window.removeEventListener("theme:resize", this.resizeFilters);
                    }
                    constructor(t) {
                        (this.container = t), this.init(), (this.initListener = () => this.init()), document.addEventListener("theme:filters:init", this.initListener);
                    }
                })(this.container));
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(pn)), window.innerWidth < theme.sizes.small) && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(pn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new hs(t);
                }),
                this.handleVisibleTooltips();
        }
        handleVisibleTooltips() {
            if (this.tooltips.length > 0) {
                const t = document.querySelector(mn);
                t.classList.contains(kn) && t.classList.remove(kn);
            }
        }
        updateRange() {
            const t = this.filtersForm.querySelector(an),
                e = this.filtersForm.querySelector(ln),
                i = this.filtersForm.querySelector(nn),
                s = this.filtersForm.querySelector(rn);
            if (t.hasAttribute(cn) && e.hasAttribute(hn)) {
                const o = parseFloat(i.placeholder, 10),
                    n = parseFloat(s.placeholder, 10),
                    r = parseFloat(t.getAttribute(cn), 10),
                    a = parseFloat(e.getAttribute(hn), 10);
                (o === r && n === a) || ((i.value = parseInt(r)), (s.value = parseInt(a)), this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
            }
        }
        onSubmitHandler(t) {
            t.preventDefault();
            const e = new FormData(this.filtersForm),
                i = new URLSearchParams(e),
                s = [];
            let o = "";
            this.isSearchPage && ((this.searchForm = this.container.querySelector(wn)), (this.currentType = this.container.getAttribute(Mn)));
            const n = this.filtersForm.querySelector(an),
                r = this.filtersForm.querySelector(ln),
                a = this.filtersForm.querySelector(nn),
                l = this.filtersForm.querySelector(rn);
            if (n && r && a && l && n.hasAttribute(dn) && r.hasAttribute(un)) {
                const t = parseFloat(n.getAttribute(dn), 10),
                    e = parseFloat(r.getAttribute(un), 10),
                    o = a.value ? parseFloat(a.value, 10) : t,
                    c = l.value ? parseFloat(l.value, 10) : e;
                o <= t && c >= e && (s.push("filter.v.price.gte"), s.push("filter.v.price.lte"), i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"));
            }
            if (((o = i.toString()), this.isSearchPage)) {
                o = Ui(this.searchForm, this.filtersForm, s);
                let t = "";
                "all" === this.currentType && (t = "&type=product"), o.indexOf("&type=product") > -1 && (t = ""), (o += t);
            }
            this.renderSection(o, t);
        }
        onHistoryChange(t) {
            var e;
            if (!this.filters) return;
            let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
            if (this.isSearchPage) {
                t.state || (i = window.location.search);
                if (!(i.indexOf("type=product") > -1)) return;
            }
            this.renderSection(i, null, !1);
        }
        renderSection(t, e, i = !0) {
            this.startLoading();
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                o = (t) => t.url === s;
            this.filterData.some(o) ? this.renderSectionFromCache(o, e) : this.renderSectionFromFetch(s, e), i && this.updateURLHash(t);
        }
        renderSectionFromFetch(t) {
            fetch(t)
                .then((t) => t.text())
                .then((e) => {
                    const i = e;
                    (this.filterData = [...this.filterData, { html: i, url: t }]),
                        (this.inputSort = this.container.querySelectorAll(Uo)),
                        this.renderFilters(i),
                        this.bindFilterButtonsEvents(),
                        this.hideFiltersOnMobile(),
                        this.renderProductGrid(i),
                        this.updateProductsCount(i),
                        this.finishLoading(),
                        this.mobileFiltersScrollLock(),
                        this.handleSearchPageActiveTab();
                });
        }
        renderSectionFromCache(t, e) {
            const i = this.filterData.find(t).html;
            this.renderFilters(i, e), this.hideFiltersOnMobile(), this.renderProductGrid(i), this.updateProductsCount(i), this.finishLoading(), this.mobileFiltersScrollLock(), this.handleSearchPageActiveTab();
        }
        handleSearchPageActiveTab() {
            this.isSearchPage && ((this.scrollable = this.container.querySelector(Sn)), this.scrollable && !this.customScrollbar && (this.customScrollbar = new Yi(this.container)));
        }
        renderProductGrid(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(sn);
            e && ((this.productGrid.innerHTML = e.innerHTML), this.initProductGridEvents(theme.settings.enableInfinityScroll), this.filterShowMore());
        }
        updateProductsCount(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(on);
            e && (this.productsCount.innerHTML = e.innerHTML);
        }
        renderFilters(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(jo);
            e &&
                ((this.filters.innerHTML = e.innerHTML),
                (this.filtersForm = document.querySelector(Jo)),
                this.bindFilterButtonsEvents(),
                this.bindToggleButtonsEvents(),
                co(this.container),
                (this.collapsible = new Ye(this.container)),
                document.dispatchEvent(new CustomEvent("theme:filters:init", { bubbles: !0 })));
        }
        updateURLHash(t) {
            history.pushState({ searchParams: t }, "", `${window.location.pathname}${t && "?".concat(t)}`);
        }
        bindFilterButtonsEvents() {
            this.inputSort.length > 0 &&
                this.inputSort.forEach((t) => {
                    t.addEventListener("change", this.updateCollectionFormSortEvent);
                }),
                this.filtersForm && (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)), this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)),
                this.collectionSortOptions && this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent),
                "tag" != this.filterMode &&
                    "group" != this.filterMode &&
                    this.enableFilters &&
                    this.container.querySelectorAll(Zo).forEach((t) => {
                        t.addEventListener("click", this.onFilterResetClick, { once: !0 });
                    });
        }
        onFilterResetClick(t) {
            t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString());
        }
        bindToggleButtonsEvents() {
            var t;
            this.container.querySelectorAll(zo).forEach((t) => {
                t.addEventListener("click", this.onFilterToggleClick);
            }),
                this.container.querySelectorAll(_o).forEach((t) => {
                    t.addEventListener("click", this.hideFiltersDrawer);
                }),
                this.container.querySelectorAll($o).forEach((t) => {
                    t.addEventListener("click", this.showFiltersDrawer);
                }),
                null === (t = this.container.querySelector(Vo)) || void 0 === t || t.addEventListener("keyup", this.onKeyUpHandler);
        }
        onTabHandler(t) {
            if (t.code === theme.keyboardKeys.SPACE || t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) {
                const e = t.target.previousElementSibling.value;
                this.filtersForm.querySelectorAll(Uo).forEach((t) => {
                    t.checked && (t.checked = !1), t.value === e && (t.checked = !0);
                }),
                    this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
                    t.target.dispatchEvent(new Event("click", { bubbles: !0 }));
            }
        }
        onKeyUpHandler(t) {
            t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
        }
        onFilterToggleClick(t) {
            t.preventDefault(), U();
            this.filters.classList.contains(qn) ? this.hideFiltersDrawer() : this.showFiltersDrawer();
        }
        sortDropdownToggle() {
            this.collectionSortOptions && this.collectionSortOptions.classList.toggle(Tn);
        }
        bodyClick(t) {
            if (!this.collectionSortOptions) return;
            const e = this.sortToggle.contains(t.target);
            this.collectionSortOptions.classList.contains(Tn) && !e && this.sortDropdownToggle();
        }
        updateCollectionFormSort(t) {
            const e = t.target,
                i = e.value,
                s = e.closest(Wo);
            this.container.querySelectorAll(Uo).forEach((t) => {
                t.value === i && (t.checked = !0);
            }),
                null !== s && this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
        }
        showFiltersDrawer() {
            (this.a11y.state.trigger = document.querySelector(zo)), this.a11y.trapFocus({ container: this.filters }), this.mobileFiltersScrollLock();
        }
        mobileFiltersScrollLock() {
            if (window.innerWidth < theme.sizes.small) {
                const t = document.querySelector(Go);
                this.filters.classList.contains(qn) || this.filters.classList.add(qn), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t }));
            }
        }
        hideFiltersOnMobile() {
            const t = this.container.querySelectorAll(`${Ro}:not(${vn})`);
            window.innerWidth < theme.sizes.small &&
                requestAnimationFrame(() => {
                    t.forEach((t) => {
                        const e = "true" === t.getAttribute(Pn);
                        t.classList.contains(Ln) && !e && t.dispatchEvent(new Event("click"));
                    });
                });
        }
        showFiltersOnDesktop() {
            const t = this.container.querySelectorAll(`${Ro}:not(${vn})`),
                e = this.container.getAttribute(In),
                i = "first-open" === e,
                s = "open" === e,
                o = "closed" === e,
                n = this.enableSorting ? 1 : 0;
            t.forEach((t, e) => {
                const r = t.classList.contains(Ln),
                    a = "true" === t.getAttribute(Pn),
                    l = a && !r && s;
                (a && !l) || (((o && r) || (i && !r && e === n) || (i && r && e !== n) || (s && !r) || l) && t.dispatchEvent(new Event("click")));
            });
        }
        hideFiltersDrawer() {
            let t = this.filters.classList.contains(qn),
                e = this.container.classList.contains(An);
            t && (this.filters.classList.remove(qn), this.a11y.removeTrapFocus()), e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Bo }));
        }
        filtersResizeEvents() {
            window.innerWidth >= theme.sizes.small ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer()) : this.hideFiltersOnMobile();
        }
        filterShowMore() {
            (this.showMore = this.container.querySelectorAll(gn)),
                0 !== this.showMore.length &&
                    this.showMore.forEach((t) => {
                        const e = t.querySelector(Ro),
                            i = t.querySelector(fn);
                        if (!i) return;
                        const s = i.querySelector(vn),
                            o = i.querySelector(yn),
                            n = o.querySelectorAll(window.theme.focusable);
                        "true" === o.getAttribute(Fn) ||
                            n.forEach((t) => {
                                t.setAttribute(Hn, "-1");
                            }),
                            s.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateShowMoreFocusableElements(t, n);
                            }),
                            s.addEventListener("click", (t) => {
                                this.updateShowMoreFocusableElements(t, n);
                            }),
                            e.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateCollapsedContainerFocusableElements(e, s, n);
                            }),
                            e.addEventListener("click", () => {
                                this.updateCollapsedContainerFocusableElements(e, s, n);
                            });
                    });
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
            requestAnimationFrame(() => {
                const s = "true" === t.getAttribute(Fn),
                    o = "true" === e.getAttribute(Fn);
                i.forEach((t) => {
                    !s && o && t.setAttribute(Hn, "-1"), s && o && t.removeAttribute(Hn);
                });
            });
        }
        updateShowMoreFocusableElements(t, e) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const i = "true" === t.target.getAttribute(Fn);
                    e.forEach((t, e) => {
                        if (i) return t.removeAttribute(Hn), void (0 === e && t.focus());
                        t.setAttribute(Hn, "-1");
                    });
                });
            });
        }
        initTagFilters() {
            ("tag" != this.filterMode && "group" != this.filterMode) || !this.enableFilters || ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent());
        }
        renderTagFiltersProducts(t) {
            this.startLoading(),
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                fetch(t)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = e,
                            s = new DOMParser().parseFromString(i, "text/html"),
                            o = s.querySelector(sn).innerHTML,
                            n = s.querySelector(jo).innerHTML;
                        (this.productGrid.innerHTML = o),
                            (this.filters.innerHTML = n),
                            (this.inputSort = this.container.querySelectorAll(Uo)),
                            (this.filtersForm = document.querySelector(Jo)),
                            (this.filterData = [...this.filterData, { html: i, url: t }]),
                            (this.alreadyClicked = !1),
                            this.bindFilterTagButtonsEvents(),
                            this.bindFilterButtonsEvents(),
                            this.bindSortChangeEvent(),
                            this.bindToggleButtonsEvents(),
                            this.initProductGridEvents(theme.settings.enableInfinityScroll),
                            this.updateProductsCount(i),
                            this.mobileFiltersScrollLock(),
                            this.hideFiltersOnMobile(),
                            co(this.container),
                            (this.collapsible = new Ye(this.container)),
                            this.filterShowMore(),
                            history.replaceState && window.history.pushState({ path: t }, "", t);
                    })
                    .catch((t) => {
                        this.finishLoading(), console.log(`Error: ${t}`);
                    });
        }
        bindFilterTagButtonsEvents() {
            this.container.querySelectorAll(Xo).forEach((t) => {
                t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
            }),
                this.container.querySelectorAll(tn).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagClearClick);
                }),
                this.container.querySelectorAll(Zo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagResetClick);
                });
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(Uo).forEach((t) => {
                t.addEventListener("input", this.debouncedSortEvent.bind(this));
            });
        }
        onFilterTagButtonClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget,
                i = e.dataset.tag;
            if (e.parentNode.classList.contains(En)) {
                let t = this.tags.indexOf(i);
                e.parentNode.classList.remove(En), t > -1 && this.tags.splice(t, 1);
            } else e.parentNode.classList.add(En), this.tags.push(i);
            let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.querySelector(Qo).classList.remove(Ln), this.container.querySelector(Qo).setAttribute(Fn, !1), this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
        }
        onFilterTagClearClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget.dataset.tag,
                i = this.tags.indexOf(e);
            i > -1 && this.tags.splice(i, 1);
            const s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
        }
        onSortChange() {
            let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(t);
        }
        getSortValue() {
            let t = "";
            return (
                this.inputSort.forEach((e) => {
                    e.checked && (t = e.value);
                }),
                t
            );
        }
        onFilterTagResetClick(t) {
            if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
            (this.alreadyClicked = !0),
                this.container.querySelectorAll(Yo).forEach((t) => {
                    t.classList.remove(En);
                }),
                this.container.querySelectorAll(Qo).forEach((t) => {
                    t.classList.remove(Ln), t.setAttribute(Fn, !1);
                }),
                (this.tags = []),
                this.container.setAttribute("data-tags", "");
            let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(e);
        }
        getProductsOffsetTop() {
            return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight;
        }
        getStickyBarOffsetTop() {
            return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
        }
        initProductGridEvents(t) {
            if (t) return this.initInfinityScroll(), void this.initProductGridEvents(!1);
            (this.productGridEvents = new yo(this.container)),
                this.initTooltips(),
                setTimeout(() => {
                    this.finishLoading();
                }, 1.5 * Bo);
        }
        initInfinityScroll() {
            if (this.isSearchPage) {
                if (!this.enableFilters) return;
                document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", { bubbles: !0, detail: "product" }));
            } else
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                    (this.endlessCollection = new Do(this.container)),
                    0 !== this.endlessCollection.endlessScroll.length && (this.endlessCollection.endlessScroll[0].settings.callback = () => this.initProductGridEvents(!1));
        }
        startLoading() {
            this.container.classList.add(An), window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            let t = this.getProductsOffsetTop();
            window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
        finishLoading() {
            const t = document.querySelectorAll(`${en} .${Cn}`),
                e = t.length > 0;
            if ((this.container.classList.remove(An), e)) {
                let e = 0;
                [...t].forEach((t) => {
                    t.hasAttribute(xn) && (e += 1);
                }),
                    e === t.length && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Bo }));
            } else window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Bo }));
        }
        onDeselect() {
            this.productGridEvents && this.productGridEvents.onDeselect();
        }
        onUnload() {
            "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                this.productGridEvents && this.productGridEvents.onUnload(),
                this.collapsible && this.collapsible.onUnload(),
                this.rangeSlider && this.rangeSlider.unload(),
                this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent),
                document.removeEventListener("click", this.bodyClickEvent),
                this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
                this.finishLoading();
        }
        constructor(t) {
            var e;
            (this.container = t),
                (this.sectionId = t.dataset.sectionId),
                (this.enableFilters = "true" === t.dataset.enableFilters),
                (this.enableSorting = "true" === t.dataset.enableSorting),
                (this.filterMode = t.dataset.filterMode),
                (this.collectionHandle = this.container.dataset.collection),
                (this.isSearchPage = null != t.closest(bn)),
                (this.productGrid = this.container.querySelector(sn)),
                (this.productsCount = this.container.querySelector(on)),
                (this.groupTagFilters = this.container.querySelectorAll(Qo)),
                (this.filters = this.container.querySelector(jo)),
                (this.filterTriggers = this.container.querySelectorAll(Ro)),
                (this.filtersStickyBar = this.container.querySelector(Ko)),
                (this.filtersForm = this.container.querySelector(Jo)),
                (this.inputSort = this.container.querySelectorAll(Uo)),
                (this.sortToggle = this.container.querySelector(No)),
                (this.collectionSortOptions = this.container.querySelector(Wo)),
                (this.a11y = ri),
                (this.filterData = []),
                (this.rangeSlider = null),
                (this.sortDropdownEvent = () => this.sortDropdownToggle()),
                (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
                (this.updateCollectionFormSortEvent = (t) => this.updateCollectionFormSort(t)),
                (this.bodyClickEvent = (t) => this.bodyClick(t)),
                (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
                (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
                (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
                (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
                (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
                (this.updateRangeEvent = this.updateRange.bind(this)),
                (this.debouncedSubmitEvent = o((t) => {
                    this.onSubmitHandler(t);
                }, 500)),
                (this.debouncedSortEvent = o((t) => {
                    this.onSortChange(t);
                }, 500)),
                (this.productGridEvents = {}),
                this.filters &&
                    ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
                    (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
                    (this.resizeEvent = o(() => {
                        this.filtersResizeEvents();
                    }, 500)),
                    this.filtersResizeEvents(),
                    document.addEventListener("theme:resize:width", this.resizeEvent)),
                this.initTagFilters(),
                this.initFacetedFilters(),
                this.bindToggleButtonsEvents(),
                this.bindFilterButtonsEvents(),
                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                co(this.container),
                (this.collapsible = new Ye(this.container)),
                U(),
                window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent),
                document.addEventListener("click", this.bodyClickEvent),
                this.filterShowMore();
        }
    };
    const Bn = {
            onLoad() {
                Dn[this.id] = new On(this.container);
            },
            onDeselect() {
                Dn[this.id].onDeselect();
            },
            onUnload() {
                Dn[this.id].onUnload();
            },
        },
        zn = "[data-aos]",
        _n = "[data-aos-anchor]",
        $n = "[data-tabs-link]",
        Vn = "[data-tab]",
        Rn = "[data-tab-ref]",
        Nn = "[data-custom-scrollbar]",
        Wn = "[data-custom-scrollbar-holder]",
        Un = "[data-slider]",
        jn = "[data-tabs-contents]",
        Gn = "[data-search-form]",
        Kn = "[data-all-types-container]",
        Qn = "[data-collection-filters-form]",
        Yn = "[data-current-page]",
        Xn = "[data-tooltip]",
        Jn = "[data-collection-products]",
        Zn = "#AjaxinateLoop",
        tr = "current",
        er = "hide",
        ir = "alt",
        sr = "aos-animate",
        or = "is-loaded",
        nr = "data-tabs-link",
        rr = "data-tab",
        ar = "data-tab-ref",
        lr = "data-start-index",
        cr = "data-search-performed",
        hr = "data-type",
        dr = "data-current-type",
        ur = "data-all-types",
        pr = "data-current-page",
        mr = "data-ajaxinate-id",
        gr = {};
    let fr = class {
        assignSearchPageArguments() {
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(Gn)),
                (this.searchFormData = new FormData(this.searchForm)),
                (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
                (this.currentType = this.container.getAttribute(dr)),
                (this.sectionId = this.container.dataset.sectionId),
                (this.searchForAllTypes = "true" === this.container.getAttribute(ur)),
                (this.fetchURL = ""),
                (this.searchParams = ""),
                (this.cachedResults = {}),
                this.handleTabsHistory(),
                this.infiniteScrollListener(),
                this.initInfinityScroll(this.currentType));
        }
        init() {
            const t = this.container.querySelectorAll($n),
                e = this.container.querySelector(`[${nr}="${this.container.hasAttribute(lr) ? this.container.getAttribute(lr) : 0}"]`),
                i = this.container.querySelector(`[${rr}="${this.container.hasAttribute(lr) ? this.container.getAttribute(lr) : 0}"]`);
            null == i || i.classList.add(tr),
                null == e || e.classList.add(tr),
                this.checkVisibleTabsLinks(),
                t.forEach((t) => {
                    this.handleTabsNavListeners(t);
                });
        }
        handleTabsHistory() {
            window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
                this.tabsLink.forEach((t) => {
                    t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent);
                });
        }
        handleTabsNavListeners(t) {
            const e = t.getAttribute(nr),
                i = this.container.querySelector(`[${rr}="${e}"]`);
            i &&
                (t.addEventListener("click", (e) => {
                    this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i);
                }),
                t.addEventListener("keyup", (e) => {
                    (e.code !== theme.keyboardKeys.SPACE && e.code !== theme.keyboardKeys.ENTER && e.code !== theme.keyboardKeys.NUMPADENTER) || (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
                }));
        }
        openTabFromHistory(t) {
            const e = t.target,
                i = this.container.querySelector(t.detail.element).getAttribute(nr),
                s = this.container.querySelector(`[${rr}="${i}"]`);
            s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
        }
        handleURLSearchParams(t, e = !0) {
            const i = t.target.matches($n) ? t.target : t.target.closest($n),
                s = i.getAttribute(hr),
                o = i.getAttribute(nr),
                n = this.container.querySelector(`[${rr}="${o}"]`).querySelector(Yn),
                r = document.querySelector(Qn);
            let a = n ? `&page=${n.getAttribute(pr)}` : "";
            if (((this.searchParams = Ui(this.searchForm, r, [], s)), "product" === s)) {
                const t = this.searchParams.replace("&type=product", "");
                this.searchParams = `${t}&type=product`;
            } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
            theme.settings.enableInfinityScroll || "" === a || (this.searchParams += a),
                (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
                e && history.pushState({ searchParams: this.searchParams }, "", `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`);
        }
        tabChangeFetchContent(t, e) {
            const i = t.getAttribute(hr),
                s = t.getAttribute(nr),
                o = this.container.querySelector(`[${rr}="${s}"]`),
                n = this.currentType === i;
            if (this.cachedResults[s] || n)
                return (
                    "product" !== i || this.searchFilters || (this.searchFilters = new On(this.container)),
                    void requestAnimationFrame(() => {
                        this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.updateAjaxify(e, i);
                    })
                );
            fetch(this.fetchURL)
                .then((t) => {
                    if (!t.ok) {
                        throw new Error(t.status);
                    }
                    return t.text();
                })
                .then((n) => {
                    const r = new DOMParser().parseFromString(n, "text/html").querySelector(`[${rr}="${s}"]`).innerHTML;
                    var a;
                    this.searchForAllTypes && (null === (a = this.container.querySelector(Kn)) || void 0 === a || a.remove());
                    (this.cachedResults[s] = r),
                        (o.innerHTML = r),
                        "product" !== i || this.searchFilters || (this.searchFilters = new On(this.container)),
                        requestAnimationFrame(() => {
                            this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.initInfinityScroll(i);
                        });
                })
                .catch((t) => {
                    throw t;
                });
        }
        onHistoryChange(t) {
            var e;
            const i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
                s = i.indexOf("type=product") > -1,
                o = i.indexOf("type=article") > -1,
                n = i.indexOf("type=page") > -1,
                r = s || o || n,
                a = this.container.querySelector(`${$n}[${hr}="product"]`),
                l = this.container.querySelector(`${$n}[${hr}="article"]`),
                c = this.container.querySelector(`${$n}[${hr}="page"]`);
            r
                ? (s && (null == a || a.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${hr}="product"]` } }))),
                  o && (null == l || l.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${hr}="article"]` } }))),
                  n && (null == c || c.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${hr}="page"]` } }))))
                : (window.location = i);
        }
        initCustomScrollbar() {
            this.scrollable && !this.customScrollbar && (this.customScrollbar = new Yi(this.container));
        }
        infiniteScrollListener() {
            theme.settings.enableInfinityScroll && ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)), document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent));
        }
        ajaxifyFromFilters(t) {
            this.initInfinityScroll(t.detail);
        }
        initInfinityScroll(t) {
            if (!theme.settings.enableInfinityScroll) return;
            if (0 === this.container.querySelectorAll(Zn).length) return;
            const e = this.container.querySelector(`${Vn}.${tr}`),
                i = null == e ? void 0 : e.querySelector(Zn),
                s = null == i ? void 0 : i.classList.contains(or);
            e ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t), i && !s && this.initAjaxyfy(t)) : this.initAjaxyfy(t);
        }
        updateAjaxinateInstancesSettings(t) {
            setTimeout(() => {
                if (0 === this.endlessCollection.endlessScroll.length) return;
                [...this.endlessCollection.endlessScroll].forEach((t) => {
                    const e = t.containerElement,
                        i = [...this.tab].find((t) => t.classList.contains(tr));
                    !(null !== e.closest(`${Vn}.${tr}`)) && i && (t.settings.method = "click");
                });
                const e = () => this.initProductGridEvents();
                if ("product" === t || "all" === t) {
                    const t = (t) => t.settings.container.indexOf("resultsProducts") > -1 || t.settings.container.indexOf("allTypes") > -1,
                        i = [...this.endlessCollection.endlessScroll].find(t);
                    if (!i) return;
                    i.settings.callback = e;
                }
            });
        }
        initAjaxyfy(t) {
            if ("object" != typeof this.endlessCollection) return (this.endlessCollection = new Do(this.container)), void this.updateAjaxinateInstancesSettings(t);
            this.endlessCollection.endlessScroll.length > 0 && (this.endlessCollection.unload(), (this.endlessCollection = new Do(this.container)), this.updateAjaxinateInstancesSettings(t));
        }
        updateAjaxify(t, e) {
            var i;
            if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
            const s = t.querySelector(Zn),
                o = `${Zn}[${mr}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
            s && (this.endlessCollection.update(o), this.updateAjaxinateInstancesSettings(e));
        }
        initProductGridEvents() {
            (this.productGridEvents = new yo(this.container)), this.initTooltips();
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(Xn)), (this.productGrid = this.container.querySelector(Jn)), window.innerWidth < theme.sizes.small) &&
                (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(Xn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new hs(t);
                });
        }
        tabChange(t, e) {
            t.classList.contains(tr) ||
                (this.isSearchPage ? this.tabChangeFetchContent(t, e) : (this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.handleTabSliders(e), this.checkVisibleTabsLinks()));
        }
        handleActiveTabClasses(t, e) {
            var i;
            const s = this.container.querySelector(`${Vn}.${tr}`),
                o = this.container.querySelector(`${$n}.${tr}`);
            null == s || s.classList.remove(tr),
                null == o || o.classList.remove(tr),
                t.classList.add(tr),
                e.classList.add(tr),
                t.classList.contains(er) && e.classList.add(er),
                null === (i = this.tabRef) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        const i = t.classList.contains(tr),
                            s = t.getAttribute(ar) === e.getAttribute(rr);
                        t.classList.toggle(tr, !i && s);
                    });
        }
        scrollToCurrentTabLink(t) {
            const e = t.closest(Wn) ? t.closest(Wn) : t.parentElement,
                i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
            e.scrollTo({ top: 0, left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i, behavior: "smooth" }), t.dispatchEvent(new CustomEvent("theme:custom-scrollbar:change", { bubbles: !0, detail: { element: t } }));
        }
        triggerTabAnimations(t) {
            if ("false" == theme.settings.animationsEnabled) return;
            document.dispatchEvent(new CustomEvent("theme:scroll"));
            const e = this.tabsContents.querySelector(`[${rr}="resultsProducts"]`);
            if (e && e.classList.contains(tr)) {
                qe(this.tabsContents.querySelectorAll(_n));
            } else
                this.tabsContents.querySelectorAll(zn).forEach((t) => {
                    t.classList.remove(sr);
                }),
                    this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
                    (this.animateElementsTimer = setTimeout(() => {
                        t.querySelectorAll(zn).forEach((t) => {
                            t.classList.add(sr);
                        });
                    }, 150));
        }
        handleInactiveTabsAnimations() {
            this.tab.forEach((t) => {
                t.classList.contains(tr) ||
                    t.querySelectorAll(zn).forEach((t) => {
                        requestAnimationFrame(() => t.classList.remove(sr));
                    });
            });
        }
        handleTabSliders(t) {
            const e = t.querySelector(Un);
            e && e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
        }
        checkVisibleTabsLinks() {
            const t = this.container.querySelectorAll($n),
                e = this.container.querySelectorAll(`${$n}.${er}`);
            t.length - e.length < 2 ? this.container.classList.add(ir) : this.container.classList.remove(ir);
        }
        onBlockSelect(t) {
            const e = t.target;
            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
        }
        onUnload() {
            this.customScrollbar && this.customScrollbar.unload(),
                this.isSearchPage && theme.settings.enableInfinityScroll && document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent),
                document.removeEventListener("theme:scroll", this.inactiveTabsAnimationsCallback);
        }
        constructor(t) {
            (this.container = t),
                (this.tabsContents = t.querySelector(jn)),
                (this.animateElementsTimer = null),
                (this.isSearchPage = null != t.closest(`[${cr}="true"]`)),
                this.container &&
                    ((this.scrollable = this.container.querySelector(Nn)),
                    (this.tabRef = this.container.querySelectorAll(Rn)),
                    (this.tabsLink = this.container.querySelectorAll($n)),
                    (this.tab = this.container.querySelectorAll(Vn)),
                    this.assignSearchPageArguments(),
                    this.init(),
                    this.initCustomScrollbar(),
                    this.isSearchPage || this.initTooltips(),
                    (this.inactiveTabsAnimationsCallback = o(() => this.handleInactiveTabsAnimations(), 200)),
                    document.addEventListener("theme:scroll", this.inactiveTabsAnimationsCallback),
                    this.container.addEventListener("mouseenter", () => {
                        this.handleInactiveTabsAnimations();
                    }));
        }
    };
    const yr = {
            onLoad() {
                gr[this.id] = new fr(this.container);
            },
            onBlockSelect(t) {
                gr[this.id].onBlockSelect(t);
            },
            onUnload() {
                gr[this.id].onUnload();
            },
        },
        vr = "[data-drawer]",
        br = "[data-drawer-toggle]",
        wr = "[data-scroll]",
        Sr = "[data-quick-view-item]",
        Er = "[data-quick-view-focus]",
        Lr = "is-open",
        kr = "js-drawer-open",
        Ar = "js-drawer-open--size",
        Cr = "js-drawer-open--size-qv",
        qr = "cv-h",
        Tr = "site-header",
        Pr = "product-single",
        xr = "data-quick-view-item",
        Ir = "aria-expanded",
        Hr = "aria-controls",
        Fr = "aria-hidden";
    let Mr = {},
        Dr = class {
            initListeners() {
                this.drawerToggleButtons.forEach((t) => {
                    t.addEventListener("click", this.drawerToggleEvent);
                }),
                    this.drawers.forEach((t) => {
                        t.addEventListener("keyup", this.keyPressCloseEvent), (this.collapsible = new Ye(t)), (this.tabs = new fr(t));
                    }),
                    document.addEventListener("click", this.drawerCloseEvent),
                    document.addEventListener("theme:drawer:closing", this.drawerCloseEvent);
            }
            toggle(t) {
                t.preventDefault();
                const e = document.querySelector(`#${t.target.getAttribute(Hr)}`);
                if (!e) return;
                e.classList.contains(Lr) ? this.close() : this.open(t);
            }
            open(t) {
                const e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(Hr)}`);
                if (!i) return;
                const s = i.querySelector(wr) || i;
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s })),
                    document.dispatchEvent(new CustomEvent("theme:drawer:open"), { bubbles: !0 }),
                    this.body.classList.add(kr),
                    this.container.classList.contains(Pr) && this.body.classList.add(Ar),
                    this.container.hasAttribute(xr) && this.body.classList.add(Cr),
                    i.classList.add(Lr),
                    i.setAttribute(Fr, !1),
                    i.classList.remove(qr),
                    i.setAttribute(Fr, !1),
                    e.setAttribute(Ir, !0);
                const o = (t) => {
                    const s = "transform" === t.propertyName || "top" === t.propertyName;
                    t.target === i && s && ((this.a11y.state.trigger = e), this.a11y.trapFocus({ container: i }), i.removeEventListener("transitionend", o));
                };
                i.addEventListener("transitionend", o);
            }
            close(t = !1) {
                if (!this.body.classList.contains(kr)) return;
                const e = document.querySelector(`${vr}.${Lr}`);
                this.drawerToggleButtons.forEach((t) => {
                    t.setAttribute(Ir, !1);
                }),
                    this.a11y.removeTrapFocus({ container: e }),
                    e.setAttribute(Fr, !0),
                    e.classList.remove(Lr),
                    e.setAttribute(Fr, !0);
                const i = (t) => {
                    t.target === e &&
                        (requestAnimationFrame(() => {
                            e.classList.add(qr), document.dispatchEvent(new CustomEvent("theme:drawer:close"), { bubbles: !0 }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }),
                        e.removeEventListener("transitionend", i));
                };
                if ((e.addEventListener("transitionend", i), this.body.classList.remove(kr), this.body.classList.remove(Ar), this.body.classList.contains(Cr))) {
                    if ((this.body.classList.remove(Cr), t && t.code === theme.keyboardKeys.ESCAPE)) return (this.a11y.state.trigger = this.a11y.state.mainTrigger), void this.a11y.state.trigger.focus();
                    const e = this.a11y.state.trigger.closest(Er);
                    this.a11y.trapFocus({ container: e, elementToFocus: this.a11y.state.trigger }), (this.a11y.state.trigger = this.a11y.state.mainTrigger);
                }
            }
            onUnload() {
                this.close(),
                    this.drawerToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.drawerToggleEvent);
                    }),
                    this.drawers.forEach((t) => {
                        t.removeEventListener("keyup", this.keyPressCloseEvent);
                    }),
                    document.removeEventListener("click", this.drawerCloseEvent),
                    document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent),
                    this.collapsible && this.collapsible.onUnload(),
                    this.tabs && this.tabs.onUnload();
            }
            constructor(t) {
                (this.container = t),
                    (this.body = document.body),
                    (this.drawers = this.container.querySelectorAll(vr)),
                    (this.drawerToggleButtons = this.container.querySelectorAll(br)),
                    (this.a11y = ri),
                    (this.drawerToggleEvent = ze((t) => {
                        this.toggle(t);
                    }, 150)),
                    (this.keyPressCloseEvent = ze((t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.close(t);
                    }, 150)),
                    (this.drawerCloseEvent = (t) => {
                        const e = document.querySelector(`${vr}.${Lr}`);
                        let i = !1;
                        if (!e) return;
                        "click" === t.type && (i = t.target.matches(br));
                        const s = !!e && e.contains(t.target),
                            o = e.closest(Sr),
                            n = !!o && o.contains(t.target);
                        i || s || n || this.close();
                    }),
                    this.initListeners();
            }
        };
    const Or = {
            onLoad() {
                this.container.classList.contains(Tr) && (this.container = this.container.parentNode), (Mr[this.id] = new Dr(this.container));
            },
            onUnload() {
                Mr[this.id].onUnload();
            },
        },
        Br = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        zr = (t) => {
            t && (t.style.display = "none");
        },
        _r = (t) => {
            const { stickyHeaderHeight: e } = N();
            window.scrollTo({ top: t + Math.round(window.scrollY) - e, left: 0, behavior: "smooth" });
        },
        $r = "[data-store-availability-list]",
        Vr = { close: ".js-modal-close", open: ".js-modal-open-store-availability-modal", openClass: "modal--is-active", openBodyClass: "modal--is-visible", closeModalOnClick: !1, scrollIntoView: !1 };
    const Rr = "body",
        Nr = "[data-store-availability-modal]",
        Wr = "[data-store-availability-modal-open]",
        Ur = "[data-store-availability-modal-close]",
        jr = "[data-store-availability-modal-product__title]",
        Gr = "store-availabilities-modal--active";
    const Kr = "[data-product-form]",
        Qr = "[data-option-position]",
        Yr = '[name^="options"], [data-popout-option]',
        Xr = "sold-out",
        Jr = "unavailable",
        Zr = "data-option-position",
        ta = "data-value";
    const ea = 1,
        ia = "data-notification-popup",
        sa = { history: !1, focus: !1, mainClass: "pswp--notification pswp--not-close-btn", closeOnVerticalDrag: !1 };
    let oa = class {
        init() {
            const t = [{ html: this.notificationPopupHtml }];
            (this.a11y.state.trigger = this.button), new Yc(t, sa, ea);
        }
        constructor(t) {
            (this.button = t), (this.a11y = ri), (this.notificationPopupHtml = this.button.getAttribute(ia)), "" !== this.notificationPopupHtml.trim() && this.init();
        }
    };
    const na = "[data-product]",
        ra = "[data-product-form]",
        aa = "[data-add-to-cart]",
        la = "[data-add-to-cart-text]",
        ca = "[data-buy-it-now]",
        ha = "[data-compare-price]",
        da = "[data-form-wrapper]",
        ua = "[data-site-header]",
        pa = "[data-item-count-for-variant]",
        ma = "[data-max-inventory]",
        ga = "[data-product-select]",
        fa = "_preorder",
        ya = "[data-price-wrapper]",
        va = "[data-price-off]",
        ba = "[data-price-off-type]",
        wa = "[data-price-off-amount]",
        Sa = "[data-product-slide]",
        Ea = "[data-product-image]",
        La = "[data-product-single-media-slider]",
        ka = "[data-product-json]",
        Aa = "[data-product-price]",
        Ca = "[data-product-unit-price]",
        qa = "[data-product-base]",
        Ta = "[data-product-unit]",
        Pa = "[data-subscription-watch-price]",
        xa = "[data-subscription-selectors]",
        Ia = "[data-toggles-group]",
        Ha = "data-group-toggle",
        Fa = "[data-plan-description]",
        Ma = "[data-remaining-count]",
        Da = "[data-remaining-wrapper]",
        Oa = "[data-product-remaining-json]",
        Ba = "[data-store-availability-container]",
        za = "[data-upsell-btn]",
        _a = ".shopify-section",
        $a = "[data-quick-view-item]",
        Va = "[data-notification-button-text]",
        Ra = "[data-swatches-container]",
        Na = "[data-swatches-more]",
        Wa = "[data-option-position]",
        Ua = "[data-variant-buttons]",
        ja = "[data-variant-option-image]",
        Ga = "hidden",
        Ka = "variant--soldout",
        Qa = "variant--unavailabe",
        Ya = "product__price--sale",
        Xa = "product__price--hidden",
        Ja = "count-is-low",
        Za = "count-is-in",
        tl = "count-is-out",
        el = "count-is-unavailable",
        il = "selector-wrapper--visible",
        sl = "data-image-id",
        ol = "data-tall-layout",
        nl = "data-enable-history-state",
        rl = "data-notification-popup",
        al = "data-swatch-variant",
        ll = "data-atc-button",
        cl = "data-max-inventory-reached",
        hl = "data-error-message-position",
        dl = "data-variant-title";
    let ul = {},
        pl = class {
            init() {
                let t = null;
                const e = this.container.querySelector(ka);
                e && (t = e.innerHTML),
                    t
                        ? ((this.productJSON = JSON.parse(t)),
                          this.linkForm(),
                          (this.sellout = new (class {
                              init() {
                                  this.update();
                              }
                              update() {
                                  this.getCurrentState(),
                                      this.optionElements.forEach((t) => {
                                          const e = t.value || t.getAttribute(ta),
                                              i = t.closest(Qr);
                                          if (!i) return;
                                          const s = i.getAttribute(Zr),
                                              o = parseInt(s, 10) - 1;
                                          let n = [...this.selections];
                                          n[o] = e;
                                          const r = this.productJSON.variants.find((t) => {
                                              let e = !0;
                                              for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                                              return e;
                                          });
                                          t.parentElement.classList.remove(Xr, Jr), void 0 === r ? t.parentElement.classList.add(Jr) : !1 === (null == r ? void 0 : r.available) && t.parentElement.classList.add(Xr);
                                      });
                              }
                              getCurrentState() {
                                  for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                              }
                              constructor(t, e) {
                                  (this.container = t),
                                      (this.productJSON = e),
                                      (this.form = this.container.querySelector(Kr)),
                                      (this.formData = new FormData(this.form)),
                                      (this.optionElements = this.container.querySelectorAll(Yr)),
                                      this.productJSON && this.form && this.init();
                              }
                          })(this.container, this.productJSON)))
                        : console.error("Missing product JSON"),
                    this.hasVariantOptionWithImage && ((this.variantButtonsContainer = this.variantOptionImages[0].closest(Ua)), this.equalizeImageOptionContainers());
            }
            resizeEvents() {
                this.hasVariantOptionWithImage && this.equalizeImageOptionContainers();
            }
            linkForm() {
                this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? qs(this.product, t) : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null };
                        const i = new FormData(this.form).get("selling_plan");
                        return (
                            i &&
                                t &&
                                (e.allocation = t.selling_plan_allocations.find(function (t) {
                                    return t.selling_plan_id.toString() === i.toString();
                                })),
                            e.allocation &&
                                (e.group = this.product.selling_plan_groups.find(function (t) {
                                    return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                                })),
                            e.group &&
                                (e.detail = e.group.selling_plans.find(function (t) {
                                    return t.id.toString() === i.toString();
                                })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function (t) {
                            return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }
                    getFormState() {
                        const t = this.variant();
                        return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                    }
                    _setIdInputValue(t) {
                        t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                    }
                    _onSubmit(t, e) {
                        (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype.bind()
                            : function (e) {
                                  (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                              }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                            function (t) {
                                return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                            }.bind(this)
                        );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t;
                    }
                    constructor(t, e, i) {
                        (this.element = t),
                            (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                            (this.product = this._validateProductObject(e)),
                            (this.variantElement = this.element.querySelector(Ps)),
                            (i = i || {}),
                            (this._listeners = new Cs()),
                            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                            (this.optionInputs = this._initInputs(Is, i.onOptionChange)),
                            (this.planInputs = this._initInputs(xs, i.onPlanChange)),
                            (this.quantityInputs = this._initInputs(Hs, i.onQuantityChange)),
                            (this.propertyInputs = this._initInputs(Fs, i.onPropertyChange));
                    }
                })(this.productForm, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) });
                const t = this.productForm.getFormState();
                if ((this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer)) {
                    this.observeSwatch(t);
                    const e = this.swatchesContainer.closest(Wa),
                        i = e.querySelector(Na);
                    null == i ||
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.contains(il) ? e.classList.remove(il) : e.classList.add(il);
                        });
                }
                (this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()), document.addEventListener("theme:cart:close", this.checkLiveCartInfoCallback);
            }
            onOptionChange(t) {
                this.pushState(t.dataset), this.updateProductImage(t);
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            onQuantityChange(t) {
                this.pushState(t.dataset);
            }
            pushState(t, e = !1) {
                var i;
                (this.productState = this.setProductState(t)),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.updateTitleAttr(t),
                    this.fireHookEvent(t),
                    this.updateRemaining(t),
                    this.checkLiveCartInfo(t),
                    null === (i = this.sellout) || void 0 === i || i.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t),
                    this.storeAvailability && (t.variant ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title) : this.storeAvailability.clearContent());
            }
            updateTitleAttr(t) {
                const e = t.variant;
                if (!e) return;
                let i = this.productForm.product.title;
                e.public_title && (i += ` - ${e.title}`), this.productForm.element.setAttribute(dl, i);
            }
            updateAddToCartState(t) {
                const e = t.variant,
                    i = this.container.querySelectorAll(ya),
                    s = this.container.querySelectorAll(aa),
                    o = this.container.querySelectorAll(la),
                    n = this.container.querySelectorAll(da),
                    r = this.container.querySelector(ca);
                let a = theme.strings.add_to_cart;
                theme.settings.atcButtonShowPrice && (a = `${a}<span data-product-price class="product__price--regular"></span>`),
                    this.productJSON.tags.includes(fa) && (a = theme.strings.preorder),
                    null == i ||
                        i.forEach((t) => {
                            t.hasAttribute(ll) || t.classList.toggle(Xa, !e);
                        }),
                    null == s ||
                        s.forEach((t) => {
                            var i;
                            if (t.matches(za)) return;
                            if (((t.disabled = !0), null == r || r.classList.add(Ga), !e)) return;
                            if (((t.disabled = !1), e.available && (null == r || r.classList.remove(Ga)), !t.hasAttribute(rl))) return;
                            const s = t.id.replace("AddToCart", "NotificationForm"),
                                o = this.sessionStorage.getItem("notification_form_id");
                            let n = !1,
                                a = e.id,
                                l = e.name,
                                c = e.title;
                            if (o) {
                                const t = o.substring(0, o.lastIndexOf("--")),
                                    e = o.split("--").slice(-1)[0];
                                (n = s === t),
                                    n &&
                                        ((this.latestVariantId = a),
                                        (this.latestVariantName = l),
                                        (this.latestVariantTitle = c),
                                        (a = Number(e)),
                                        this.productJSON.variants.forEach((t) => {
                                            t.id === a && ((l = t.name), (c = t.title));
                                        }));
                            }
                            let h = t.getAttribute(rl);
                            const d = null === (i = new DOMParser().parseFromString(h, "text/html").querySelector(Va)) || void 0 === i ? void 0 : i.innerHTML;
                            if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                                var u;
                                (h = h.replaceAll(this.latestVariantId, a)),
                                    (h = h.replaceAll(`<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`, `<p class='product__notification__subtitle'>${c}</p>`)),
                                    (h = h.replaceAll(`value='${this.latestVariantName}'>`, `value='${l}'>`));
                                const t = null === (u = new DOMParser().parseFromString(h, "text/html").querySelector(Va)) || void 0 === u ? void 0 : u.innerHTML;
                                h = h.replace(t, d);
                            }
                            t.setAttribute(rl, h), n && (this.scrollToForm(this.product.closest(_a)), new oa(t)), (this.latestVariantId = a), (this.latestVariantName = l), (this.latestVariantTitle = c);
                        }),
                    null == o ||
                        o.forEach((t) => {
                            if (e) {
                                if (e.available) t.innerHTML = a;
                                else if (((t.innerHTML = theme.strings.sold_out), t.parentNode.hasAttribute(rl))) {
                                    if (t.closest($a)) return;
                                    t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                                }
                            } else t.innerHTML = theme.strings.unavailable;
                        }),
                    null == n ||
                        n.forEach((t) => {
                            if (!e) return t.classList.add(Qa), void t.classList.remove(Ka);
                            const i = t.querySelector(ga);
                            if ((i && (i.value = e.id), !e.available)) return t.classList.add(Ka), void t.classList.remove(Qa);
                            t.classList.remove(Ka, Qa);
                        });
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                    const n = t.toString();
                    window.history.replaceState({ path: n }, "", n);
                }
            }
            updateRemaining(t) {
                const e = t.variant,
                    i = [Za, tl, el, Ja];
                if (e && this.remainingWrapper && this.remainingJSON) {
                    const t = this.remainingJSON[e.id];
                    ("out" === t || t < 1) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(tl)),
                        ("in" === t || t >= this.remainingMaxInt) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Za)),
                        ("low" === t || (t > 0 && t < this.remainingMaxInt)) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ja), this.remainingCount && (this.remainingCount.innerHTML = t));
                } else !e && this.remainingWrapper && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(el));
            }
            checkLiveCartInfo(t) {
                const e = (t || this.productForm.getFormState()).variant;
                if (!e) return;
                const i = `${theme.routes.root}products/${this.productJSON.handle}?section_id=api-live-cart-info&variant=${e.id}`;
                fetch(i)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = new DOMParser().parseFromString(t, "text/html"),
                            i = Number(e.querySelector(pa).innerHTML),
                            s = e.querySelector(ma).innerHTML,
                            o = Number(s),
                            n = Boolean(this.productForm.quantity() + i > o),
                            r = "" !== s && n,
                            a = "" !== s && i === o ? "form" : "cart";
                        this.productForm.element.setAttribute(cl, r), this.productForm.element.setAttribute(hl, a);
                    })
                    .catch((t) => console.log("error: ", t));
            }
            equalizeImageOptionContainers() {
                if (this.variantOptionImages.length <= 1) return;
                const t = [...this.variantOptionImages].map((t) => Math.floor(t.offsetHeight)),
                    e = [...this.variantOptionImages].map((t) => Math.floor(t.offsetWidth)),
                    i = Math.max(...e),
                    s = Math.max(...t);
                this.variantButtonsContainer.style.setProperty("--option-image-width", i + "px"), this.variantButtonsContainer.style.setProperty("--option-image-height", s + "px");
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.container.querySelectorAll(Ia).forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            const e = t.target.value.toString(),
                                i = this.container.querySelector(`[${Ha}="${e}"]`),
                                s = this.container.querySelectorAll(`[${Ha}]`);
                            if (i) {
                                i.classList.remove(Ga);
                                const t = i.querySelector('[name="selling_plan"]');
                                (t.checked = !0), t.dispatchEvent(new Event("change"));
                            }
                            s.forEach((t) => {
                                if (t !== i) {
                                    t.classList.add(Ga);
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        (t.checked = !1), t.dispatchEvent(new Event("change"));
                                    });
                                }
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(Ga);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || "sale";
                const e = t.variant;
                if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(Ga);
            }
            updateSaleTextSubscription(t) {
                const e = t.variant,
                    s = this.productForm.product.selling_plan_groups.find((t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id),
                    o = t.plan ? t.plan.detail.price_adjustments[0] : s.selling_plans[0].price_adjustments[0],
                    n = o.value || 0,
                    r = "percentage" === o.value_type ? `${n}%` : i.formatMoney(e.price - n, theme.moneyFormat);
                (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), (this.priceOffAmount.innerHTML = r), this.priceOffWrap.classList.remove(Ga);
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(Ga))
                    : this.planDecription && this.planDecription.classList.add(Ga);
            }
            updateProductPrices(t) {
                const e = t.variant,
                    s = t.plan;
                this.container.querySelectorAll(ya).forEach((t) => {
                    const o = t.querySelector(ha),
                        n = t.querySelector(Aa);
                    let r = "",
                        a = "";
                    if ((this.productState.available && ((r = e.compare_at_price), (a = e.price)), this.productState.hasPlan)) {
                        a = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                    }
                    if (this.productState.planSale) {
                        const t = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                        (r = s ? s.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price), (a = t);
                    }
                    if (
                        (o &&
                            (this.productState.onSale || this.productState.planSale ? (o.classList.remove(Ga), n.classList.add(Ya)) : (o.classList.add(Ga), n.classList.remove(Ya)),
                            (o.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(r, theme.moneyWithCurrencyFormat) : i.formatMoney(r, theme.moneyFormat))),
                        n)
                    ) {
                        if (t.hasAttribute(ll)) {
                            a *= this.productForm.quantity();
                        }
                        n.innerHTML = 0 === a ? window.theme.strings.free : theme.settings.currency_code_enable ? i.formatMoney(a, theme.moneyWithCurrencyFormat) : i.formatMoney(a, theme.moneyFormat);
                    }
                }),
                    this.hasUnitPricing && this.updateProductUnits(t);
            }
            updateProductUnits(t) {
                const e = t.variant,
                    s = t.plan;
                let o = null;
                if (
                    (((e && e.unit_price) || (!s && !e.requires_selling_plan)) && (o = e.unit_price),
                    s && (null == s ? void 0 : s.allocation) && (null == s ? void 0 : s.allocation.unit_price) && (o = s.allocation.unit_price),
                    !s && e.requires_selling_plan && e.selling_plan_allocations && e.selling_plan_allocations.length > 0)
                ) {
                    o = e.selling_plan_allocations[0].unit_price;
                }
                if (o) {
                    const t = this.getBaseUnit(e),
                        s = 0 === o ? window.theme.strings.free : i.formatMoney(o, theme.moneyFormat);
                    (this.container.querySelector(Ca).innerHTML = s), (this.container.querySelector(qa).innerHTML = t), Br(this.container.querySelector(Ta));
                } else zr(this.container.querySelector(Ta));
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
                if (e) {
                    const t = e.requires_selling_plan || !1;
                    e.available || (s.soldOut = !0),
                        e.compare_at_price > e.price && (s.onSale = !0),
                        e.unit_price && (s.showUnitPrice = !0),
                        this.product && this.product.requires_selling_plan && (s.requiresPlan = !0),
                        i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0)),
                        !i && t && ((s.hasPlan = !0), e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price && (s.planPerDelivery = !0), e.price > e.selling_plan_allocations[0].price && (s.planSale = !0));
                } else s.available = !1;
                return s;
            }
            updateProductImage(t) {
                const i = t.dataset.variant;
                if (!i || !(null == i ? void 0 : i.featured_media)) return;
                const s = this.container.querySelector(`${Ea}[${sl}="${i.featured_media.id}"]`),
                    o = null == s ? void 0 : s.closest(Sa);
                if (o) {
                    const t = parseInt([...o.parentElement.children].indexOf(o)),
                        n = this.container.querySelector(La),
                        r = e.data(n);
                    if (r && r.isActive) {
                        const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
                        if (t) {
                            const e = parseInt([...t.parentNode.children].indexOf(t));
                            r.select(e);
                        }
                        return;
                    }
                    if (this.tallLayout) {
                        const e = s.getBoundingClientRect().top;
                        if (0 === t && e + window.scrollY > window.pageYOffset) return;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })), _r(e);
                    }
                }
            }
            observeSwatch(t) {
                const e = this.swatchesContainer.querySelector(`[${al}*="${t.variant.id}"]`);
                this.swatchesContainer.closest(Wa).classList.remove(il),
                    new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                0 == t.intersectionRatio && this.swatchesContainer.closest(Wa).classList.add(il);
                            });
                        },
                        { root: this.container, threshold: [0.95, 1] }
                    ).observe(e);
            }
            scrollToForm(t) {
                var e;
                const i = null === (e = document.querySelector(ua)) || void 0 === e ? void 0 : e.dataset.height;
                visibilityHelper.isElementPartiallyVisible(t) ||
                    visibilityHelper.isElementTotallyVisible(t) ||
                    setTimeout(() => {
                        const e = t.getBoundingClientRect().top - i;
                        window.scrollTo({ top: e, left: 0, behavior: "smooth" });
                    }, 400);
            }
            onUnload() {
                this.productForm && this.productForm.destroy(),
                    this.hasVariantOptionWithImage && window.removeEventListener("theme:resize:width", this.onResizeCallback),
                    document.removeEventListener("theme:cart:close", this.checkLiveCartInfoCallback);
            }
            constructor(t) {
                if (
                    ((this.container = t),
                    (this.product = this.container.querySelector(na)),
                    (this.productForm = this.container.querySelector(ra)),
                    (this.tallLayout = "true" === this.container.getAttribute(ol)),
                    (this.addToCartButton = this.container.querySelector(aa)),
                    (this.variantOptionImages = this.container.querySelectorAll(ja)),
                    (this.hasVariantOptionWithImage = this.variantOptionImages.length > 0),
                    !this.product || !this.productForm)
                ) {
                    return void new ni(this.container).init();
                }
                (this.storeAvailabilityContainer = this.container.querySelector(Ba)),
                    (this.enableHistoryState = "true" === this.container.getAttribute(nl)),
                    (this.hasUnitPricing = this.container.querySelector(Ta)),
                    (this.subSelectors = this.container.querySelector(xa)),
                    (this.subPrices = this.container.querySelector(Pa)),
                    (this.priceOffWrap = this.container.querySelector(va)),
                    (this.priceOffAmount = this.container.querySelector(wa)),
                    (this.priceOffType = this.container.querySelector(ba)),
                    (this.planDecription = this.container.querySelector(Fa)),
                    (this.swatchesContainer = this.container.querySelector(Ra)),
                    (this.latestVariantId = ""),
                    (this.latestVariantName = ""),
                    (this.latestVariantTitle = ""),
                    (this.sellout = null),
                    (this.sessionStorage = window.sessionStorage),
                    (this.remainingWrapper = this.container.querySelector(Da)),
                    this.remainingWrapper &&
                        ((this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10)),
                        (this.remainingCount = this.container.querySelector(Ma)),
                        (this.remainingJSONWrapper = this.container.querySelector(Oa)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML && (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))),
                    this.storeAvailabilityContainer &&
                        (this.storeAvailability = new (class {
                            updateContent(t, e) {
                                this._fetchStoreAvailabilities(t, e);
                            }
                            clearContent() {
                                this.container.innerHTML = "";
                            }
                            _initModal() {
                                return new (class {
                                    init() {
                                        this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this));
                                    }
                                    open(t) {
                                        let e = !1;
                                        if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e)) return void this.closeModal();
                                        this.modal.classList.add(this.config.openClass),
                                            this.nodes.parents.forEach((t) => {
                                                t.classList.add(this.config.openBodyClass);
                                            }),
                                            (this.modalIsOpen = !0);
                                        const i = document.querySelector($r);
                                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })),
                                            this.config.scrollIntoView && this.scrollIntoView(),
                                            this.bindEvents(),
                                            this.a11y.trapFocus({ container: this.modal });
                                    }
                                    closeModal() {
                                        if (this.modalIsOpen) {
                                            document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                                            var t = this;
                                            this.nodes.parents.forEach(function (e) {
                                                e.classList.remove(t.config.openBodyClass);
                                            }),
                                                (this.modalIsOpen = !1),
                                                this.openElement.focus(),
                                                this.unbindEvents(),
                                                this.a11y.removeTrapFocus({ container: this.modal }),
                                                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 }));
                                        }
                                    }
                                    bindEvents() {
                                        (this.keyupHandler = this.keyupHandler.bind(this)),
                                            (this.clickHandler = this.clickHandler.bind(this)),
                                            document.body.addEventListener("keyup", this.keyupHandler),
                                            document.body.addEventListener("click", this.clickHandler);
                                    }
                                    unbindEvents() {
                                        document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler);
                                    }
                                    keyupHandler(t) {
                                        t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                                    }
                                    clickHandler(t) {
                                        !this.config.closeModalOnClick || this.modal.contains(t.target) || t.target.matches(this.config.open) || this.closeModal();
                                    }
                                    scrollIntoView() {
                                        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                                    }
                                    constructor(t, e) {
                                        if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
                                        (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                                            (this.config = Object.assign(Vr, e)),
                                            (this.modalIsOpen = !1),
                                            (this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal),
                                            (this.openElement = document.querySelector(this.config.open)),
                                            (this.a11y = ri),
                                            this.init();
                                    }
                                })("StoreAvailabilityModal", { close: Ur, open: Wr, closeModalOnClick: !0, openClass: Gr, scrollIntoView: !1 });
                            }
                            _fetchStoreAvailabilities(t, e) {
                                const i = "/variants/" + t + "/?section_id=store-availability";
                                this.clearContent();
                                const s = this;
                                fetch(i)
                                    .then(function (t) {
                                        return t.text();
                                    })
                                    .then(function (t) {
                                        const i = document.querySelector(Rr);
                                        let o = i.querySelector(Nr);
                                        o && o.remove(),
                                            (s.container.innerHTML = t),
                                            (s.container.innerHTML = s.container.firstElementChild.innerHTML),
                                            "" !== s.container.firstElementChild.innerHTML.trim()
                                                ? s.container.querySelector(Wr) && ((s.modal = s._initModal()), s._updateProductTitle(e), (o = s.container.querySelector(Nr)), o && i.appendChild(o))
                                                : s.clearContent();
                                    });
                            }
                            _updateProductTitle(t) {
                                this.container.querySelector(jr).textContent = t;
                            }
                            constructor(t) {
                                this.container = t;
                            }
                        })(this.storeAvailabilityContainer));
                new ni(this.container).init(), this.init(), this.hasVariantOptionWithImage && ((this.onResizeCallback = () => this.resizeEvents()), window.addEventListener("theme:resize:width", this.onResizeCallback));
            }
        };
    const ml = {
            onLoad() {
                ul[this.id] = new pl(this.container);
            },
            onUnload() {
                ul[this.id].onUnload();
            },
        },
        gl = "form",
        fl = "[data-selector-wrapper]",
        yl = "[data-popout]",
        vl = "[data-popout-list]",
        bl = "[data-popout-toggle]",
        wl = "[data-popout-input]",
        Sl = "[data-popout-option]",
        El = "[data-popout-text]",
        Ll = "[aria-current]",
        kl = "[data-product-image]",
        Al = "[data-product-grid-item]",
        Cl = "[data-quick-view-item]",
        ql = "[data-quick-view-foot]",
        Tl = "selector-wrapper--open",
        Pl = "select-popout__list--top",
        xl = "select-popout__list--visible",
        Il = "select-popout--alt",
        Hl = "--current",
        Fl = "is-visible",
        Ml = "aria-current",
        Dl = "aria-expanded",
        Ol = "data-value",
        Bl = "data-popout-prevent",
        zl = "data-quantity-field",
        _l = "data-quick-view-inner",
        $l = "data-popout-initialized";
    let Vl = {},
        Rl = class {
            unload() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent), t.removeEventListener("click", this._connectOptionsDispatchEvent);
                    }),
                    this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent),
                    this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
                    document.body.removeEventListener("click", this.bodyClick);
            }
            popupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(Dl);
                if (this.popoutList.closest(Al)) {
                    const t = this.popoutList.closest(Al).querySelector(kl);
                    t && t.classList.toggle(Fl, !e);
                }
                t.currentTarget.setAttribute(Dl, !e), this.popoutList.classList.toggle(xl), this.toggleListPosition(), this.popupListSetDimensions();
            }
            popupToggleFocusout(t) {
                const e = "true" === this.popoutToggle.getAttribute(Dl);
                if (!t.relatedTarget) return;
                const i = this.popout.contains(t.relatedTarget),
                    s = t.relatedTarget.hasAttribute(_l);
                i || s || !e || this._hideList();
            }
            popupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(xl) && !e && this._hideList();
            }
            calc(t = "shouldBeOnTop") {
                const { headerHeight: e, stickyHeaderHeight: i, announcementBarHeight: s } = N(),
                    o = this.popout.closest(Cl);
                let n = Math.floor(this.popout.getBoundingClientRect().top),
                    r = e || 0,
                    a = 0;
                0 !== s && window.scrollY < s && (a = s), window.scrollY > a + e && (r = i);
                let l = window.innerHeight,
                    c = r + a;
                if (o) {
                    const t = o.querySelector(ql),
                        e = (null == t ? void 0 : t.offsetHeight) || 0,
                        i = Math.floor(o.getBoundingClientRect().top);
                    (n -= i), (l -= e), (c = i), we() && (l = o.offsetHeight - e);
                }
                let h = l - c;
                if ((o && we() && (h = l), "shouldBeOnTop" === t)) return h / 2 < n;
                if ("availableHeightAbove" === t) {
                    const t = Math.floor(this.popoutToggle.getBoundingClientRect().top - 1);
                    return (c += 10), `${parseInt(t - c)}px`;
                }
                if ("availableHeightBelow" === t) {
                    const t = Math.floor(this.popoutList.getBoundingClientRect().top - 1);
                    return (c = 10), `${parseInt(l - t - c)}px`;
                }
            }
            toggleListPosition() {
                const t = "true" === this.popoutToggle.getAttribute(Dl),
                    e = () => {
                        var t;
                        null === (t = this.selectorWrapper) || void 0 === t || t.classList.remove(Tl), this.popoutList.classList.remove(Pl), (this.popoutTop = !1), this.popoutList.removeEventListener("transitionend", e);
                    };
                var i;
                t
                    ? (null === (i = this.selectorWrapper) || void 0 === i || i.classList.add(Tl), this.calc("shouldBeOnTop") && (this.popoutList.classList.add(Pl), (this.popoutTop = !0)))
                    : this.popoutList.addEventListener("transitionend", e);
            }
            popupListSetDimensions() {
                this.popoutList.style.setProperty("--max-height", "100vh"),
                    requestAnimationFrame(() => {
                        this.popoutTop ? this.popoutList.style.setProperty("--max-height", this.calc("availableHeightAbove")) : this.popoutList.style.setProperty("--max-height", this.calc("availableHeightBelow"));
                    });
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(Sl).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if ((t.currentTarget.getAttribute(Ol) && (e = t.currentTarget.getAttribute(Ol)), (this.popoutInput.value = e), this.popoutPrevent)) {
                        this.popoutInput.dispatchEvent(new Event("change")), this.switchQuantityInputBehavior(t.detail.preventTrigger);
                        const i = this.popoutList.querySelector(`[class*="${Hl}"]`);
                        let s = Hl;
                        if (i && i.classList.length)
                            for (const t of i.classList)
                                if (t.includes(Hl)) {
                                    s = t;
                                    break;
                                }
                        const o = this.popoutList.querySelector(`.${s}`);
                        o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                        const n = this.popoutList.querySelector(Ll);
                        n && (n.removeAttribute(Ml), t.currentTarget.setAttribute(Ml, "true")), "" !== e && (this.popoutText.textContent = e), this.popupToggleFocusout(t), this.popupListFocusout(t);
                    } else this._submitForm(e);
                }
            }
            switchQuantityInputBehavior(t = !0) {
                var e;
                if (t || !this.popoutInput.hasAttribute(zl)) return;
                const i = this.popoutList.querySelector(`[${Ol}="${this.popoutInput.value}"]`);
                i && (i.parentElement.nextSibling || (this.popout.classList.add(Il), null === (e = this.selectorWrapper) || void 0 === e || e.classList.remove(Tl)));
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(t) {
                const e = this.popout.contains(t.target);
                this.popoutList.classList.contains(xl) && !e && this._hideList();
            }
            _connectToggle() {
                this.popout.setAttribute($l, ""), this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.addEventListener("theme:popout:click", this.popupOptionsClickEvent), t.addEventListener("click", this._connectOptionsDispatchEvent);
                    });
            }
            _connectOptionsDispatch(t) {
                const e = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
                t.target.dispatchEvent(e) || t.preventDefault();
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.addEventListener("keyup", this.popoutKeyupEvent),
                    document.body.addEventListener("click", this.bodyClick);
            }
            _submitForm() {
                const t = this.popout.closest(gl);
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(xl), this.popoutToggle.setAttribute(Dl, !1), this.toggleListPosition();
            }
            constructor(t) {
                (this.popout = t),
                    (this.selectorWrapper = this.popout.closest(fl)),
                    (this.popoutList = this.popout.querySelector(vl)),
                    (this.popoutToggle = this.popout.querySelector(bl)),
                    (this.popoutText = this.popout.querySelector(El)),
                    (this.popoutInput = this.popout.querySelector(wl)),
                    (this.popoutOptions = this.popout.querySelectorAll(Sl)),
                    (this.popoutPrevent = "true" === this.popout.getAttribute(Bl)),
                    (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
                    (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
                    (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
                    (this._connectOptionsDispatchEvent = (t) => this._connectOptionsDispatch(t)),
                    (this.bodyClick = this.bodyClick.bind(this)),
                    (this.popoutTop = !1),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popupListSetDimensions();
            }
        };
    const Nl = {
            onLoad() {
                Vl[this.id] = [];
                this.container.querySelectorAll(yl).forEach((t) => {
                    t.hasAttribute($l) || Vl[this.id].push(new Rl(t));
                });
            },
            onUnload() {
                Vl[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Wl = "[data-add-to-cart]",
        Ul = "[data-deferred-media]",
        jl = "[data-deferred-media-button]",
        Gl = "[data-popup-close]",
        Kl = "[data-popout]",
        Ql = "[data-quick-view-inner]",
        Yl = "[data-quick-view-item-holder]",
        Xl = "[data-product]",
        Jl = "[data-product-form]",
        Zl = "[data-product-single-media-slider]",
        tc = "[data-product-single-media-wrapper]",
        ec = "[data-model]",
        ic = "[data-product-json]",
        sc = "[data-quick-view-foot-inner]",
        oc = "[data-shop-the-look-thumb]",
        nc = "[data-tooltip]",
        rc = "[data-drawer-toggle]",
        ac = "[data-quick-view-focus]",
        lc = "has-media-active",
        cc = "is-active",
        hc = "is-loading",
        dc = "media--hidden",
        uc = "no-outline",
        pc = "notification-popup-visible",
        mc = "popup-quick-view--animate-in",
        gc = "popup-quick-view--animate-out",
        fc = "popup-quick-view--animated",
        yc = "popup-quick-view",
        vc = "js-quick-view-visible",
        bc = "js-quick-view-from-cart",
        wc = "js-drawer-open",
        Sc = "id",
        Ec = "data-media-id",
        Lc = "data-section-id",
        kc = "loaded",
        Ac = "data-quick-view-onboarding",
        Cc = "data-hotspot",
        qc = "data-hotspot-ref",
        Tc = "AddToCartForm--",
        Pc = "AddToCart--";
    const xc = 400,
        Ic = ".pswp",
        Hc = ".pswp__custom-close",
        Fc = "iframe, video",
        Mc = ".pswp__custom-iframe",
        Dc = ".pswp__thumbs",
        Oc = ".pswp__button, .pswp__caption-close",
        Bc = "is-current",
        zc = "pswp--custom-loader",
        _c = "pswp--custom-opening",
        $c = "pswp__loader",
        Vc = "pswp--open",
        Rc = "pswp__button--close",
        Nc = "pswp--notification",
        Wc = "popup-quick-view",
        Uc = "js-drawer-open-cart",
        jc = "popup-quick-view--animate-out",
        Gc = "data-pswp-option-classes",
        Kc = "data-video-type",
        Qc = `<div class="${$c}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    let Yc = class {
        init() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.pswpElement.classList.add(_c),
                this.initLoader(),
                li({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(zc) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Gc, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = Qc), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(Gc, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.remove(_c),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
                this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
                this.popup.listen("imageLoadComplete", this.loadingStateCallback),
                this.popup.listen("beforeChange", this.setCurrentThumbCallback),
                this.popup.listen("close", this.onCloseCallback),
                this.popup.init(),
                this.initPopupCallback();
        }
        loadingState(t) {
            t === this.options.index && this.pswpElement.classList.contains(zc) && this.pswpElement.classList.remove(zc);
        }
        initPopupCallback() {
            this.isVideo && this.hideUnusedButtons(),
                this.initVideo(),
                this.thumbsActions(),
                this.a11y.trapFocus({ container: this.pswpElement }),
                this.pswpElement.classList.contains(Wc) &&
                    new (class {
                        initTooltips() {
                            (this.tooltips = this.pswpElement.querySelectorAll(nc)),
                                this.tooltips.forEach((t) => {
                                    new hs(t);
                                });
                        }
                        initPopouts() {
                            var t;
                            (this.popoutElements = this.pswpElement.querySelectorAll(Kl)),
                                (this.popouts = {}),
                                null === (t = this.popoutElements) ||
                                    void 0 === t ||
                                    t.forEach((t, e) => {
                                        this.popouts[e] = new Rl(t);
                                    });
                        }
                        handleDraggable(t, e) {
                            t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
                        }
                        initItems(t, e) {
                            this.addFormSuffix(t), this.initProductSlider(t, e), this.initProductVideo(t), this.initProductModel(t), this.initShopifyXrLaunch(t), co(t), this.pswpElement.querySelectorAll(rc).length && new Dr(t), pt(t);
                            const i = new pl(t.parentNode);
                            this.productForms.push(i), Shopify.PaymentButton && Shopify.PaymentButton.init(), t.classList.remove(hc);
                        }
                        init() {
                            document.addEventListener("submit", this.prevent3dModelSubmitEvent),
                                this.popupCloseButtons.forEach((t) => {
                                    t.addEventListener("keyup", (t) => {
                                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER && t.code !== theme.keyboardKeys.SPACE) || this.closePopup(t);
                                    }),
                                        t.addEventListener("click", (t) => {
                                            this.closePopup(t);
                                        });
                                }),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                document.dispatchEvent(new CustomEvent("theme:popup:open", { bubbles: !0 })),
                                this.popup.listen("preventDragEvent", (t, e, i) => {
                                    i.prevent = !1;
                                }),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                }),
                                this.popup.listen("initialZoomInEnd", () => {
                                    document.body.classList.add(vc);
                                    const t = this.quickViewItemHolders.length > 0,
                                        e = this.quickViewInner.querySelector(ac),
                                        i = this.quickViewInner.querySelector(`${Yl}.${cc}`),
                                        s = t ? i.querySelector(ac) : e;
                                    this.a11y.trapFocus({ container: s });
                                }),
                                this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent),
                                this.popup.listen("destroy", () => {
                                    this.flkty.length > 0 &&
                                        requestAnimationFrame(() => {
                                            this.flkty.forEach((t) => t.pausePlayer());
                                        }),
                                        document.body.classList.remove(vc),
                                        document.removeEventListener("keyup", this.closeOnEscapeEvent),
                                        document.addEventListener("keyup", this.closeOnEscapeEvent),
                                        this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                                        this.pswpElement.removeEventListener("animationend", this.closeOnAnimationEndEvent),
                                        document.removeEventListener("submit", this.prevent3dModelSubmitEvent),
                                        this.deferredMedias.forEach((t) => {
                                            t.removeAttribute(kc);
                                            const e = t.closest(tc);
                                            e.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), e.classList.add(dc);
                                        });
                                }),
                                document.addEventListener("keyup", this.closeOnEscapeEvent),
                                document.addEventListener("theme:cart:added", () => {
                                    this.pswpElement.classList.contains(yc) && this.pswpElement.classList.add(gc);
                                }),
                                this.animateInQuickview(),
                                this.initShopTheLookListeners();
                        }
                        initShopTheLookListeners() {
                            var t;
                            null === (t = this.buttonsShopTheLookThumb) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        const e = t.target.matches(oc) ? t.target : t.target.closest(oc),
                                            i = this.pswpElement.querySelector(`[${Cc}="${e.getAttribute(qc)}"]`),
                                            s = i.querySelector(ac);
                                        !e.classList.contains(cc) &&
                                            i &&
                                            (this.flkty.length > 0 &&
                                                requestAnimationFrame(() => {
                                                    this.flkty.forEach((t) => {
                                                        t.resize();
                                                        const e = this.quickViewInner.querySelectorAll(tc);
                                                        e.length &&
                                                            e.forEach((t) => {
                                                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(dc);
                                                            });
                                                    });
                                                }),
                                            i.classList.add(cc),
                                            this.quickViewItemHolders.forEach((t) => {
                                                t !== i && t.classList.remove(cc);
                                            }),
                                            this.a11y.trapFocus({ container: s }));
                                    });
                                });
                        }
                        prevent3dModelSubmit(t) {
                            t.submitter.closest(Ul) && t.submitter.closest(Jl) && t.preventDefault();
                        }
                        closeQuickviewOnMobile() {
                            window.innerWidth < window.theme.sizes.large && document.body.classList.contains(vc) && this.popup.close();
                        }
                        animateInQuickview() {
                            this.pswpElement.classList.add(mc),
                                this.quickViewFoot.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t);
                                }),
                                this.pswpElement.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t, !0);
                                });
                        }
                        handleAnimatedState(t, e = !1) {
                            if ("quickViewAnimateInUp" == t.animationName) {
                                if (e && window.innerWidth >= window.theme.sizes.small) return;
                                this.pswpElement.classList.add(fc), this.pswpElement.classList.remove(mc), document.body.classList.remove(bc), ft(this.pswpElement);
                            }
                        }
                        closePopup(t) {
                            null == t || t.preventDefault(),
                                document.body.classList.contains(wc) && document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 })),
                                this.pswpElement.classList.add(gc),
                                this.swatchesContainer.onUnload();
                        }
                        closeOnAnimationEnd(t) {
                            ("quickViewAnimateOutRight" != t.animationName && "quickViewAnimateOutDown" != t.animationName) ||
                                (this.popup.template.classList.remove(gc, fc), this.popup.close(), this.productForms.length > 0 && this.productForms.forEach((t) => t.onUnload()));
                        }
                        closeOnEscape(t) {
                            const e = document.body.classList.contains(vc),
                                i = document.body.classList.contains(pc);
                            t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t);
                        }
                        initProductSlider(t, i) {
                            const s = t.querySelector(Zl),
                                o = t.querySelectorAll(tc);
                            if (o.length > 1) {
                                const n = new e(s, {
                                    wrapAround: !0,
                                    cellAlign: "left",
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    adaptiveHeight: !1,
                                    pauseAutoPlayOnHover: !1,
                                    selectedAttraction: 0.2,
                                    friction: 1,
                                    autoPlay: !1,
                                    on: {
                                        ready: () => {
                                            requestAnimationFrame(() => {
                                                n.resize();
                                            });
                                        },
                                        settle: () => {
                                            const e = n.selectedElement.getAttribute(Ec);
                                            this.switchMedia(t, e);
                                        },
                                    },
                                });
                                this.flkty.push(n),
                                    o.length &&
                                        o.forEach((t) => {
                                            t.addEventListener("theme:media:play", () => {
                                                this.handleDraggable(this.flkty[i], !1), t.closest(Zl).classList.add(lc);
                                            }),
                                                t.addEventListener("theme:media:pause", () => {
                                                    this.handleDraggable(this.flkty[i], !0), t.closest(Zl).classList.remove(lc);
                                                });
                                        }),
                                    xi(s);
                            }
                        }
                        switchMedia(t, e) {
                            const i = this.quickViewInner.querySelectorAll(tc),
                                s = t.querySelector(`${tc}[${Ec}="${e}"]`),
                                o = !document.body.classList.contains(uc);
                            i.length &&
                                i.forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(dc);
                                }),
                                o && s.focus(),
                                s.closest(Zl).classList.remove(lc),
                                s.classList.remove(dc),
                                s.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                            const n = s.querySelector(Ul);
                            n && "true" !== n.getAttribute(kc) && s.querySelector(jl).dispatchEvent(new Event("click"));
                        }
                        initProductVideo(t) {
                            const e = new Wi(t);
                            this.videos.push(e);
                        }
                        initProductModel(t) {
                            const e = t.getAttribute(Lc),
                                i = t.querySelectorAll(ec);
                            i.length &&
                                i.forEach((t) => {
                                    theme.ProductModel.init(t, e);
                                });
                        }
                        initShopifyXrLaunch(t) {
                            document.addEventListener("shopify_xr_launch", () => {
                                t.querySelector(`${ec}:not(.${dc})`).dispatchEvent(new CustomEvent("xrLaunch"));
                            });
                        }
                        addFormSuffix(t) {
                            const e = `${t.getAttribute(Lc)}-${JSON.parse(t.querySelector(ic).innerHTML).handle}`,
                                i = t.querySelector(Jl),
                                s = t.querySelector(Wl);
                            i.setAttribute(Sc, Tc + e), s.setAttribute(Sc, Pc + e);
                        }
                        constructor(t, e) {
                            (this.popup = t),
                                (this.pswpElement = e),
                                (this.quickViewFoot = this.pswpElement.querySelector(sc)),
                                (this.quickViewInner = this.pswpElement.querySelector(Ql)),
                                (this.product = this.pswpElement.querySelectorAll(Xl)),
                                (this.flkty = []),
                                (this.videos = []),
                                (this.productForms = []),
                                (this.deferredMedias = this.pswpElement.querySelectorAll(Ul)),
                                (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(oc)),
                                (this.quickViewItemHolders = this.pswpElement.querySelectorAll(Yl)),
                                (this.popupCloseButtons = this.quickViewInner.querySelectorAll(Gl)),
                                (this.a11y = ri),
                                (this.prevent3dModelSubmitEvent = (t) => this.prevent3dModelSubmit(t)),
                                (this.closeOnAnimationEndEvent = (t) => this.closeOnAnimationEnd(t)),
                                (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                                (this.outerCloseEvent = (t) => {
                                    if (!this.quickViewInner.contains(t.target)) {
                                        const e = this.quickViewInner.nextElementSibling;
                                        if (e && e.contains(t.target)) return;
                                        this.closePopup(t);
                                    }
                                }),
                                this.product.forEach((t, e) => {
                                    t.hasAttribute(Ac) || this.initItems(t, e);
                                }),
                                this.init(),
                                this.initTooltips(),
                                this.initPopouts(),
                                (this.swatchesContainer = new lo(this.pswpElement));
                        }
                    })(this.popup, this.pswpElement),
                this.pswpElement.classList.contains(Nc) &&
                    new (class {
                        init() {
                            this.popup.listen("preventDragEvent", (t, e, i) => {
                                i.prevent = !1;
                            });
                            const t = -1 !== window.location.search.indexOf("?contact_posted=true");
                            this.notificationForm = this.pswpElement.querySelector(Ai);
                            const e = this.pswpElement.querySelector(qi);
                            document.body.classList.add(Pi),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                }),
                                t && this.pswpElement.classList.add(Ti),
                                this.notificationForm.addEventListener("submit", (t) => this.notificationSubmitEvent(t)),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                e.addEventListener("click", () => {
                                    this.popup.close();
                                }),
                                this.popup.listen("destroy", () => {
                                    this.notificationRemoveStorage(), this.pswpElement.removeEventListener("click", this.outerCloseEvent), document.body.classList.remove(Pi);
                                });
                        }
                        notificationSubmitEvent(t) {
                            this.notificationStopSubmit && (t.preventDefault(), this.notificationRemoveStorage(), this.notificationWriteStorage(), (this.notificationStopSubmit = !1), this.notificationForm.submit());
                        }
                        notificationWriteStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
                        }
                        notificationRemoveStorage() {
                            this.sessionStorage.removeItem("notification_form_id");
                        }
                        constructor(t, e) {
                            (this.popup = t), (this.pswpElement = e), (this.notificationForm = null), (this.notificationStopSubmit = !0), (this.sessionStorage = window.sessionStorage);
                            const i = this.pswpElement.querySelector(Ci);
                            (this.outerCloseEvent = (t) => {
                                i.contains(t.target) || this.popup.close();
                            }),
                                this.init();
                        }
                    })(this.popup, this.pswpElement),
                (this.closePopup = () => {
                    this.pswpElement.classList.contains(Wc) ? this.pswpElement.classList.add(jc) : this.popup.close();
                }),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
                document.addEventListener("theme:cart:added", this.closePopup);
        }
        dispatchPopupInitEvent() {
            this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", { bubbles: !0 }));
        }
        initVideo() {
            const t = this.pswpElement.querySelector(Mc);
            if (t) {
                const e = t.getAttribute(Kc);
                (this.isVideo = !0),
                    "youtube" == e
                        ? new (class {
                              init() {
                                  window.isYoutubeAPILoaded ? this.loadYoutubePlayer() : li({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadYoutubePlayer());
                              }
                              loadYoutubePlayer() {
                                  const t = {
                                      height: "720",
                                      width: "1280",
                                      playerVars: this.videoOptionsVars,
                                      events: {
                                          onReady: (t) => {
                                              const e = t.target.getIframe().id;
                                              "true" === document.querySelector(`#${e}`).getAttribute(bi) ? t.target.unMute() : t.target.mute(),
                                                  t.target.playVideo(),
                                                  this.checkPlayerVisibilityFlag &&
                                                      (this.checkPlayerVisibility(e),
                                                      window.addEventListener(
                                                          "scroll",
                                                          ze(() => {
                                                              this.checkPlayerVisibility(e);
                                                          }, 150)
                                                      ));
                                          },
                                          onStateChange: (t) => {
                                              0 == t.data && t.target.playVideo(), 1 == t.data && t.target.getIframe().parentElement.classList.add(Li);
                                          },
                                      },
                                  };
                                  (t.videoId = this.videoID),
                                      this.videoID.length &&
                                          YT.ready(() => {
                                              ki[this.playerID] = new YT.Player(this.playerID, t);
                                          }),
                                      (window.isYoutubeAPILoaded = !0);
                              }
                              checkPlayerVisibility(t) {
                                  let e;
                                  if ("string" == typeof t) e = t;
                                  else {
                                      if (null == t.data) return;
                                      e = t.data.id;
                                  }
                                  const i = document.getElementById(e + "-container");
                                  if (!i) return;
                                  const s = ki[e],
                                      o = i.getBoundingClientRect();
                                  let n = visibilityHelper.isElementPartiallyVisible(i) || visibilityHelper.isElementTotallyVisible(i);
                                  o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0), n && s && "function" == typeof s.playVideo ? s.playVideo() : !n && s && "function" == typeof s.pauseVideo && s.pauseVideo();
                              }
                              onUnload() {
                                  const t = "youtube-" + this.container.getAttribute(vi);
                                  ki[t] && ki[t].destroy();
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(yi.videoIframe)),
                                      this.player &&
                                          ((this.videoOptionsVars = {}),
                                          (this.videoID = this.player.getAttribute(Si)),
                                          (this.videoType = this.player.getAttribute(Ei)),
                                          "youtube" == this.videoType &&
                                              ((this.checkPlayerVisibilityFlag = "true" === this.player.getAttribute(wi)),
                                              (this.playerID = this.player.querySelector(yi.youtubeWrapper) ? this.player.querySelector(yi.youtubeWrapper).id : this.player.id),
                                              this.player.hasAttribute(yi.dataHideOptions) &&
                                                  (this.videoOptionsVars = { cc_load_policy: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, autohide: 0, controls: 0, branding: 0, showinfo: 0, rel: 0, fs: 0, wmode: "opaque" }),
                                              this.init(),
                                              this.container.addEventListener(
                                                  "touchstart",
                                                  function (t) {
                                                      if (t.target.matches(yi.videoWrapper) || t.target.closest(yi.videoWrapper)) {
                                                          const e = t.target.querySelector(yi.videoIframe).id;
                                                          ki[e].playVideo();
                                                      }
                                                  },
                                                  { passive: !0 }
                                              )));
                              }
                          })(t.parentElement)
                        : "vimeo" == e &&
                          new (class {
                              init() {
                                  this.loadVimeoPlayer();
                              }
                              loadVimeoPlayer() {
                                  const t = "https://vimeo.com/" + this.videoID;
                                  let e = "";
                                  const i = this.player,
                                      s = { url: t, background: this.enableBackground, muted: this.disableSound, autoplay: this.enableAutoplay, loop: this.enableLoop };
                                  for (let t in s) e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]) + "&";
                                  fetch(`https://vimeo.com/api/oembed.json?${e}`)
                                      .then((t) => t.json())
                                      .then(function (t) {
                                          (i.innerHTML = t.html),
                                              setTimeout(function () {
                                                  i.parentElement.classList.add(hi);
                                              }, 1e3);
                                      })
                                      .catch(function () {
                                          console.log("error");
                                      });
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(ci)),
                                      this.player &&
                                          ((this.videoID = this.player.getAttribute(gi)),
                                          (this.videoType = this.player.getAttribute(fi)),
                                          (this.enableBackground = "true" === this.player.getAttribute(ui)),
                                          (this.disableSound = "false" === this.player.getAttribute(di)),
                                          (this.enableAutoplay = "false" !== this.player.getAttribute(pi)),
                                          (this.enableLoop = "false" !== this.player.getAttribute(mi)),
                                          "vimeo" == this.videoType && this.init());
                              }
                          })(t.parentElement);
            }
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${Dc} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(), t.parentElement.querySelector(`.${Bc}`).classList.remove(Bc), t.classList.add(Bc), this.popup.goTo(e);
                    });
                }));
        }
        hideUnusedButtons() {
            this.pswpElement.querySelectorAll(Oc).forEach((t) => {
                t.classList.contains(Rc) || (t.style.display = "none");
            });
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(Fc);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; ) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Gc, "");
            const e = this.pswpElement.querySelector(`.${$c}`);
            e && this.pswpElement.removeChild(e),
                document.body.classList.contains(Uc) || this.a11y.removeTrapFocus(),
                document.removeEventListener("theme:cart:added", this.closePopup),
                setTimeout(() => {
                    const t = this.recentlyOpenedPopupsCount(),
                        e = document.body.classList.contains(Uc);
                    0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }, xc);
        }
        recentlyOpenedPopupsCount() {
            let t = 0;
            return (
                this.pswpElements.forEach((e) => {
                    e.classList.contains(Vc) && (t += 1);
                }),
                t
            );
        }
        setCurrentThumb() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
            const t = this.pswpElement.querySelector(`${Dc} > .${Bc}`);
            if ((t && t.classList.remove(Bc), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Bc), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "", i = 0, s = null) {
            (this.items = t),
                (this.triggerBtn = s),
                (this.pswpElements = document.querySelectorAll(Ic)),
                (this.pswpElement = this.pswpElements[i]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(Dc)),
                (this.closeBtn = this.pswpElement.querySelector(Hc));
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
                (this.onCloseCallback = () => this.onClose()),
                (this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent()),
                (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
                (this.loadingStateCallback = (t) => this.loadingState(t)),
                (this.a11y = ri),
                this.init();
        }
    };
    const Xc = 0,
        Jc = "[data-button-quick-view]",
        Zc = "[data-quick-view-items-template]",
        th = "[data-cart-drawer]",
        eh = "[data-shop-the-look-quick-view-button]",
        ih = "[data-shop-the-look-thumb]",
        sh = "[data-quick-view-item-holder]",
        oh = "is-loading",
        nh = "is-active",
        rh = "js-quick-view-from-cart",
        ah = "popup-quick-view pswp--not-close-btn",
        lh = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
        ch = "data-handle",
        hh = "data-variant-id",
        dh = "data-shop-the-look-quick-view",
        uh = "data-hotspot",
        ph = "data-initialized",
        mh = { history: !1, focus: !1, mainClass: ah, showHideOpacity: !1, closeOnVerticalDrag: !1, closeOnScroll: !1, modal: !1, escKey: !1 };
    let gh = class {
        popupInit(t) {
            var e, i;
            const s = this.loadPhotoswipe.pswpElement.querySelector(`[${uh}="${t.getAttribute(uh)}"]`),
                o = this.loadPhotoswipe.pswpElement.querySelectorAll(sh);
            s.classList.add(nh),
                o.forEach((t) => {
                    t !== s && t.classList.remove(nh);
                }),
                this.toggleQuickViewButtonsLoadingClasses(!0),
                this.toggleQuickViewThumbsLoadingClasses(!0);
            const n = (t) => {
                "quickViewAnimateInUp" === t.animationName &&
                    requestAnimationFrame(() => {
                        this.toggleQuickViewThumbsLoadingClasses(!1);
                    }),
                    "quickViewAnimateOutDown" === t.animationName && this.loadPhotoswipe.pswpElement.removeEventListener("animationend", n);
            };
            this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
                null === (e = this.loadPhotoswipe) ||
                    void 0 === e ||
                    null === (i = e.popup) ||
                    void 0 === i ||
                    i.listen("destroy", () => {
                        this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1);
                    });
        }
        toggleQuickViewButtonsLoadingClasses(t = !0) {
            var e, i;
            t
                ? null === (i = this.buttonsQuickView) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.add(oh);
                  })
                : null === (e = this.buttonsQuickView) ||
                  void 0 === e ||
                  e.forEach((t) => {
                      t.classList.remove(oh);
                  });
        }
        toggleQuickViewThumbsLoadingClasses(t = !0) {
            var e, i, s;
            ((this.buttonsShopTheLookThumb = null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll(ih)), t)
                ? null === (s = this.buttonsShopTheLookThumb) ||
                  void 0 === s ||
                  s.forEach((t) => {
                      t.classList.add(oh);
                  })
                : null === (i = this.buttonsShopTheLookThumb) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.remove(oh);
                  });
        }
        initPhotoswipe(t) {
            t.preventDefault();
            const e = t.target.matches(Jc) ? t.target : t.target.closest(Jc),
                i = window.innerWidth < theme.sizes.small;
            let s = "",
                o = !1;
            if (e.hasAttribute(dh)) {
                if (!i) return;
                o = !0;
            }
            (mh.mainClass = ah),
                e.classList.add(oh),
                e.closest(th) && document.body.classList.add(rh),
                (this.a11y.state.trigger = e),
                (this.a11y.state.mainTrigger = this.a11y.state.trigger),
                e.hasAttribute(hh) && (s = `&variant=${e.getAttribute(hh)}`);
            const n = `${theme.routes.root}products/${e.getAttribute(ch)}?section_id=api-quickview${s}`;
            if (o) {
                (mh.mainClass = lh),
                    this.buttonsQuickView.forEach((t) => {
                        t.classList.add(oh);
                    });
                const t = new XMLSerializer(),
                    i = this.container.querySelector(Zc).content.firstElementChild.cloneNode(!0),
                    s = t.serializeToString(i);
                this.loadPhotoswipeWithTemplate(s, e);
            } else this.loadPhotoswipeFromFetch(n, e);
        }
        loadPhotoswipeWithTemplate(t, e) {
            const i = [{ html: t }];
            this.loadPhotoswipe = new Yc(i, mh, Xc, e);
        }
        loadPhotoswipeFromFetch(t, e) {
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const i = [{ html: t }];
                    this.loadPhotoswipe = new Yc(i, mh, Xc, e);
                })
                .catch((t) => console.log("error: ", t));
        }
        constructor(t) {
            var e, i;
            (this.container = t),
                (this.a11y = ri),
                (this.buttonsQuickView = this.container.querySelectorAll(Jc)),
                (this.buttonsShopTheLookQuickView = this.container.querySelectorAll(eh)),
                (this.popupInitCallback = (t) => this.popupInit(t)),
                null === (e = this.buttonsQuickView) ||
                    void 0 === e ||
                    e.forEach((t) => {
                        t.hasAttribute(ph) ||
                            (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
                            t.addEventListener("theme:popup:init", () => {
                                t.classList.remove(oh), t.hasAttribute(dh) && this.popupInitCallback(t);
                            }),
                            t.setAttribute(ph, ""));
                    }),
                null === (i = this.buttonsShopTheLookQuickView) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        t.addEventListener("click", () => {
                            const t = [...this.buttonsQuickView].find((t) => t.hasAttribute(dh));
                            null == t || t.dispatchEvent(new Event("click"));
                        });
                    });
        }
    };
    const fh = { cartDrawerEnabled: "drawer" === window.theme.settings.cartType, timers: { addProductTimeout: 1e3 }, animations: { data: "data-aos", method: "fade-up" } },
        yh = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            emptyMessageBottom: "[data-empty-message-bottom]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            cartNoteHolder: "[data-cart-notes-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productItem: "[data-product-block]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form], [data-product-form-upsell]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled",
            noscript: "noscript",
        },
        vh = "hidden",
        bh = "is-hidden",
        wh = "js-drawer-open-cart",
        Sh = "is-open",
        Eh = "is-visible",
        Lh = "is-expanded",
        kh = "is-loading",
        Ah = "is-disabled",
        Ch = "is-success",
        qh = "cart__toggle--has-items",
        Th = "variant--soldout",
        Ph = "is-removed",
        xh = "aos-animate",
        Ih = "is-updated",
        Hh = "no-outline",
        Fh = "product-grid-item__image--error",
        Mh = "cv-h",
        Dh = "data-limit",
        Oh = "data-cart-message",
        Bh = "data-cart-total",
        zh = "aria-expanded",
        _h = "disabled",
        $h = "name",
        Vh = "value",
        Rh = "data-id",
        Nh = "data-item",
        Wh = "data-item-index",
        Uh = "data-item-title",
        jh = "data-atc-trigger",
        Gh = "data-notification-popup",
        Kh = "data-recipient-errors",
        Qh = "data-max-inventory-reached",
        Yh = "data-error-message-position",
        Xh = "data-variant-title";
    let Jh = {},
        Zh = class {
            init() {
                var t;
                (this.cartToggleButtons = document.querySelectorAll(yh.cartDrawerToggle)),
                    (this.cartPage = document.querySelector(yh.cartPage)),
                    (this.cartDrawer = document.querySelector(yh.cartDrawer)),
                    (this.cart = this.cartDrawer || this.cartPage),
                    (this.cartCount = this.getCartItemCount()),
                    this.assignArguments(),
                    (this.recipientErrors = "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(Kh))),
                    (this.flktyUpsell = null),
                    (this.form = null),
                    (this.variantTitle = null),
                    (this.collapsible = null),
                    (this.a11y = ri),
                    (this.build = this.build.bind(this)),
                    (this.addToCart = this.addToCart.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.formSubmitHandler = ze(this.formSubmitHandler.bind(this), 50)),
                    (this.closeCartError = () => {
                        this.cartErrorHolder.classList.remove(Lh);
                    }),
                    (this.cartDrawerCloseEvent = null),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
                    (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = 0),
                    (this.isCartDrawerOpen = !1),
                    (this.isCartDrawerLoaded = !1),
                    (this.cartDiscounts = 0),
                    (this.cartDrawerEnabled = fh.cartDrawerEnabled),
                    (this.cartUpdateFailed = !1),
                    (this.showCannotAddMoreInCart = !1),
                    this.cartEvents(),
                    this.cartAddEvent(),
                    this.cartDrawerToggleEvents(),
                    this.initQuantity(),
                    this.buttonHolder && (this.collapsible = new Ye(this.buttonHolder)),
                    this.isCartPage && this.renderPairProducts(),
                    document.addEventListener("theme:popup:open", this.closeCartDrawer);
            }
            assignArguments() {
                var t;
                (this.outerSection = null === (t = this.cart) || void 0 === t ? void 0 : t.closest(yh.outerSection)),
                    (this.cartDrawerBody = document.querySelector(yh.cartDrawerBody)),
                    (this.emptyMessage = document.querySelector(yh.emptyMessage)),
                    (this.emptyMessageBottom = document.querySelector(yh.emptyMessageBottom)),
                    (this.buttonHolder = document.querySelector(yh.buttonHolder)),
                    (this.itemsHolder = document.querySelector(yh.itemsHolder)),
                    (this.cartItemsQty = document.querySelector(yh.cartItemsQty)),
                    (this.itemsWrapper = document.querySelector(yh.itemsWrapper)),
                    (this.items = document.querySelectorAll(yh.item)),
                    (this.cartTotal = document.querySelector(yh.cartTotal)),
                    (this.cartTotalPrice = document.querySelector(yh.cartTotalPrice)),
                    (this.cartMessage = document.querySelectorAll(yh.cartMessage)),
                    (this.cartOriginalTotal = document.querySelector(yh.cartOriginalTotal)),
                    (this.cartErrorHolder = document.querySelector(yh.cartErrors)),
                    (this.cartCloseErrorMessage = document.querySelector(yh.cartCloseError)),
                    (this.pairProductsHolder = document.querySelector(yh.pairProductsHolder)),
                    (this.cartNoteHolder = document.querySelector(yh.cartNoteHolder)),
                    (this.pairProducts = document.querySelector(yh.pairProducts)),
                    (this.priceHolder = document.querySelector(yh.priceHolder)),
                    (this.upsellHolders = document.querySelectorAll(yh.upsellHolder)),
                    (this.cartTermsCheckbox = document.querySelector(yh.cartTermsCheckbox)),
                    (this.cartCheckoutButtonWrapper = document.querySelector(yh.cartCheckoutButtonWrapper)),
                    (this.cartCheckoutButton = document.querySelector(yh.cartCheckoutButton)),
                    (this.cartForm = document.querySelector(yh.cartForm)),
                    (this.cartItemCount = 0),
                    (this.subtotal = window.theme.subtotal),
                    (this.button = null);
                const { headerInitialHeight: e, announcementBarHeight: i } = N();
                (this.headerInitialHeight = e),
                    (this.announcementBarHeight = i),
                    this.cartMessage.length > 0 && (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(Dh)) * window.Shopify.currency.rate),
                    this.updateProgress();
            }
            initQuantity() {
                var t;
                (this.items = document.querySelectorAll(yh.item)),
                    null === (t = this.items) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new ni(t, !0).init(), this.cartUpdateEvent(t);
                        });
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e) => {
                    this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                });
            }
            cartEvents() {
                const t = document.querySelectorAll(yh.cartItemRemove);
                (this.totalItems = t.length),
                    null == t ||
                        t.forEach((t) => {
                            const e = t.closest(yh.item);
                            t.addEventListener("click", (i) => {
                                i.preventDefault(), t.classList.contains(Ah) || this.updateCart({ id: e.getAttribute(Rh), quantity: 0 }, e);
                            });
                        }),
                    this.cartCloseErrorMessage && (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError), this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)),
                    this.cartTermsCheckbox &&
                        (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                        this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                        this.cartForm.addEventListener("submit", this.formSubmitHandler));
            }
            cartAddEvent() {
                document.addEventListener("click", (t) => {
                    const e = t.target,
                        i = null == e ? void 0 : e.matches(yh.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(yh.buttonAddToCart);
                    if (i || s) {
                        var o, n, r;
                        t.preventDefault(),
                            (this.button = i ? e : s),
                            (this.form = e.closest("form")),
                            (this.recipientErrors = "true" === (null === (o = this.form) || void 0 === o ? void 0 : o.getAttribute(Kh))),
                            (this.formWrapper = this.button.closest(yh.formWrapper));
                        const a = null === (n = this.formWrapper) || void 0 === n ? void 0 : n.classList.contains(Th),
                            l = this.button.hasAttribute(_h),
                            c = this.button.closest(yh.quickViewOnboarding),
                            h = this.button.hasAttribute(jh),
                            d = this.button.hasAttribute(Gh),
                            u = null === (r = this.form) || void 0 === r ? void 0 : r.querySelector('[type="file"]');
                        if (l || u || c) return;
                        if (a && d) return void new oa(this.button);
                        h && (this.a11y.state.trigger = this.button);
                        let p = new FormData(this.form);
                        [...this.form.elements].some((t) => t.closest(yh.noscript)) && (p = this.handleFormDataDuplicates([...this.form.elements], p));
                        const m = this.form.getAttribute(Qh),
                            g = this.form.getAttribute(Yh);
                        (this.variantTitle = this.form.getAttribute(Xh)),
                            (this.showCannotAddMoreInCart = !1),
                            "true" === m && "cart" === g && (this.showCannotAddMoreInCart = !0),
                            this.addToCart(p),
                            document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: e } }));
                    }
                });
            }
            handleFormDataDuplicates(t, e) {
                return t.length && "object" == typeof e
                    ? (t.forEach((t) => {
                          if (t.closest(yh.noscript)) {
                              const i = t.getAttribute($h),
                                  s = t.value;
                              if (i) {
                                  const t = e.getAll(i);
                                  t.length > 1 && t.splice(t.indexOf(s), 1), e.delete(i), e.set(i, t[0]);
                              }
                          }
                      }),
                      e)
                    : e;
            }
            getCart() {
                if (this.cartDrawer && !this.isCartDrawerLoaded) {
                    const t = !1;
                    this.renderCartDrawer(t);
                }
                fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(yh.apiContent);
                        this.build(i);
                    })
                    .catch((t) => console.log(t));
            }
            addToCart(t) {
                this.cartDrawerEnabled && this.button && (this.button.classList.add(kh), this.button.setAttribute(_h, !0)),
                    fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: t })
                        .then((t) => t.json())
                        .then((t) => {
                            (this.button.disabled = !0),
                                this.addLoadingClass(),
                                (t.status && (this.addToCartError(t), this.removeLoadingClass(), !this.showCannotAddMoreInCart)) ||
                                    (this.hideAddToCartErrorMessage(),
                                    this.cartDrawerEnabled ? (this.getCart(), this.showCannotAddMoreInCart && this.updateErrorText(this.variantTitle), this.scrollToCartTop()) : (window.location = theme.routes.cart_url));
                        })
                        .catch((t) => console.log(t));
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                null !== e && (i ? e.classList.add(kh) : e.classList.add(Ph)), this.disableCartButtons(), this.addLoadingClass();
                const s = this.cart.querySelector(`[${Nh}="${t.id}"]`) || e,
                    o = (null == s ? void 0 : s.hasAttribute(Wh)) ? parseInt(s.getAttribute(Wh)) : 0,
                    n = (null == s ? void 0 : s.hasAttribute(Uh)) ? s.getAttribute(Uh) : null;
                if (0 === o) return;
                const r = { line: o, quantity: i };
                fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(r) })
                    .then((t) => {
                        if (400 === t.status) {
                            const e = new Error(t.status);
                            throw (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e);
                        }
                        return t.text();
                    })
                    .then((t) => {
                        if (JSON.parse(t).errors)
                            return (this.cartUpdateFailed = !0), this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), this.enableCartButtons(), this.removeLoadingClass(), void this.scrollToCartTop();
                        this.getCart();
                    })
                    .catch((t) => {
                        console.log(t), this.enableCartButtons(), this.removeLoadingClass();
                    });
            }
            resetLineItem(t) {
                const e = t.querySelector(yh.qtyInput),
                    i = e.getAttribute("value");
                (e.value = i), t.classList.remove(kh);
            }
            disableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${yh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.add(Ah), t.blur(), (t.disabled = !0);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.setAttribute(_h, !0);
                        });
            }
            enableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${yh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.remove(Ah), (t.disabled = !1);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.removeAttribute(_h);
                        });
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(yh.errorMessage).innerText = t;
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if ((this.cartErrorHolder.classList.toggle(Lh, this.cartUpdateFailed || this.showCannotAddMoreInCart), this.cartUpdateFailed)) {
                        const t = this.cartErrorHolder.querySelector(yh.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t);
                    }
                    (this.showCannotAddMoreInCart = !1), (this.cartUpdateFailed = !1);
                }
            }
            handleErrors(t) {
                return t.ok
                    ? t
                    : t.json().then(function (e) {
                          throw new _e({ status: t.statusText, headers: t.headers, json: e });
                      });
            }
            addToCartError(t) {
                const e = this.button.closest(yh.quickBuyForm),
                    i = this.button.closest(yh.upsellHolder),
                    s = !document.body.classList.contains(Hh);
                let o = (this.button.closest(yh.productForm) ? this.button.closest(yh.productForm) : this.button.closest(yh.upsellHolder)).querySelector(yh.formErrorsContainer);
                i && (o = i.querySelector(yh.formErrorsContainer)),
                    this.cartDrawerEnabled && this.button && null !== this.button.closest(yh.cartDrawer) && !this.button.closest(yh.cartDrawer) && this.closeCartDrawer(),
                    this.button.classList.remove(kh),
                    this.button.removeAttribute(_h);
                const n = e ? "" : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
                let r = `${t.message}: ${t.description}`;
                if (
                    (t.message === t.description && (r = t.message),
                    this.recipientErrors &&
                        t.description &&
                        "object" == typeof t.description &&
                        (r = Object.entries(t.description)
                            .map(([t, e]) => `${e}`)
                            .join("<br>")),
                    (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
                    e)
                ) {
                    const t = o.closest(yh.productItem);
                    if (!t) return;
                    const e = t.querySelector(yh.productMediaContainer);
                    if (!e) return;
                    e.classList.add(Fh),
                        o.querySelector(yh.error).addEventListener("animationend", () => {
                            e.classList.remove(Fh), (o.innerHTML = ""), s || document.activeElement.blur();
                        });
                } else
                    o.classList.add(Eh),
                        o.addEventListener("transitionend", () => {
                            this.resizeSliders(o), o.scrollIntoView({ behavior: "smooth", block: "end" });
                        }),
                        this.handleCloseErrorMessages(o);
            }
            handleCloseErrorMessages(t) {
                const e = t.querySelector(yh.formCloseError);
                null == e ||
                    e.addEventListener("click", (e) => {
                        const i = e.target;
                        (i.matches(yh.formCloseError) || i.closest(yh.formCloseError)) &&
                            (e.preventDefault(),
                            t.classList.remove(Eh),
                            t.querySelector(yh.error).addEventListener("transitionend", () => {
                                (t.innerHTML = ""), this.resizeSliders(i);
                            }));
                    }),
                    this.focusOnErrorMessage(t, e);
            }
            focusOnErrorMessage(t, e) {
                !document.body.classList.contains(Hh) &&
                    t.addEventListener("transitionend", () => {
                        requestAnimationFrame(() => (null == e ? void 0 : e.focus({ focusVisible: !0 })));
                    });
            }
            hideAddToCartErrorMessage() {
                const t = this.button.closest(yh.upsellHolder) ? this.button.closest(yh.upsellHolder) : this.button.closest(yh.productForm),
                    e = null == t ? void 0 : t.querySelector(yh.formErrorsContainer);
                null == e || e.classList.remove(Eh);
            }
            resizeSliders(t) {
                const i = t.closest(yh.flickityEnabled);
                if (!i) return;
                const s = e.data(i);
                requestAnimationFrame(() => s.resize());
            }
            renderCartDrawer(t = !0) {
                const e = document.querySelector(yh.cartDrawerTemplate);
                e &&
                    ((this.cartDrawer.innerHTML = e.innerHTML),
                    this.assignArguments(),
                    this.initQuantity(),
                    this.cartEvents(),
                    this.cartDrawerBody && (this.collapsible = new Ye(this.cartDrawerBody)),
                    (this.cartDrawerToggle = this.cartDrawer.querySelector(yh.cartDrawerToggle)),
                    this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent),
                    (this.isCartDrawerLoaded = !0),
                    this.renderPairProducts(),
                    document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
                    t && this.openCartDrawer());
            }
            openCartDrawer() {
                this.isCartDrawerOpen ||
                    (this.isCartDrawerLoaded
                        ? (document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody })),
                          this.scrollToCartTop(),
                          document.body.classList.add(wh),
                          this.cartDrawer.classList.add(Sh),
                          this.cartDrawer.classList.remove(Mh),
                          requestAnimationFrame(() => this.animateCartItems("in")),
                          this.cartToggleButtons.forEach((t) => {
                              t.setAttribute(zh, !0);
                          }),
                          this.a11y.trapFocus({ container: this.cartDrawer }),
                          this.observeAdditionalCheckoutButtons(),
                          (this.isCartDrawerOpen = !0))
                        : this.renderCartDrawer());
            }
            animateCartItems(t = "in") {
                const e = this.cart.querySelectorAll(yh.aos);
                "in" === t && e.forEach((t) => requestAnimationFrame(() => t.classList.add(xh))), "out" === t && e.forEach((t) => t.classList.remove(xh));
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                    this.cartErrorHolder.classList.remove(Lh),
                    this.a11y.removeTrapFocus(),
                    this.cartToggleButtons.forEach((t) => {
                        t.setAttribute(zh, !1);
                    }),
                    document.body.classList.remove(wh),
                    this.cartDrawer.classList.remove(Sh),
                    this.itemsHolder.classList.remove(Ih);
                const t = (e) => {
                    e.target === this.cartDrawer && (this.animateCartItems("out"), this.cartDrawer.removeEventListener("transitionend", t));
                };
                this.cartDrawer.addEventListener("transitionend", t);
                !document.body.classList.contains(Hh) ||
                    requestAnimationFrame(() => {
                        document.activeElement.blur();
                    });
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })), (this.isCartDrawerOpen = !1);
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
            }
            cartDrawerToggleEvents() {
                this.cartDrawer &&
                    (this.cartDrawer.addEventListener("keyup", (t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    }),
                    (this.cartDrawerToggleClickEvent = (t) => {
                        t.preventDefault();
                        const e = t.target;
                        "false" === e.getAttribute(zh) && (this.a11y.state.trigger = e), this.toggleCartDrawer();
                    }),
                    (this.cartDrawerCloseEvent = (t) => {
                        const e = t.target.matches(yh.cartDrawerToggle),
                            i = document.querySelector(yh.cartDrawer).contains(t.target),
                            s = t.target.closest(yh.popupQuickView);
                        e || i || s || this.closeCartDrawer();
                    }),
                    this.cartToggleButtons.forEach((t) => {
                        t.addEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.addEventListener("mousedown", this.cartDrawerCloseEvent));
            }
            toggleClassesOnContainers() {
                const t = this;
                this.isCartPage
                    ? this.buttonHolder.classList.toggle(vh, !t.hasItemsInCart())
                    : (this.pairProductsHolder.classList.toggle(vh, !t.hasItemsInCart()),
                      this.cartForm.classList.toggle(vh, !t.hasItemsInCart()),
                      this.emptyMessageBottom.classList.toggle(vh, t.hasItemsInCart()),
                      this.cartNoteHolder.classList.toggle(vh, !t.hasItemsInCart())),
                    this.emptyMessage.classList.toggle(vh, t.hasItemsInCart()),
                    this.itemsHolder.classList.toggle(vh, !t.hasItemsInCart()),
                    this.cartItemsQty.classList.toggle(vh, !t.hasItemsInCart());
            }
            build(t) {
                const e = t.querySelector(yh.apiLineItems),
                    s = t.querySelector(yh.apiUpsellItems),
                    o = Boolean(null === e && null === s),
                    n = t.querySelector(yh.apiCartPrice),
                    r = t.querySelector(yh.cartTotal);
                if (
                    (this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
                    this.animateCartItems("out"),
                    o
                        ? ((this.itemsHolder.innerHTML = ""), this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
                        : ((this.itemsHolder.innerHTML = e.innerHTML), this.pairProductsHolder && (this.pairProductsHolder.innerHTML = s.innerHTML), this.renderPairProducts()),
                    (this.newTotalItems = e && e.querySelectorAll(yh.item).length ? e.querySelectorAll(yh.item).length : 0),
                    (this.subtotal = r && r.hasAttribute(Bh) ? parseInt(r.getAttribute(Bh)) : 0),
                    (this.cartCount = this.getCartItemCount()),
                    this.cartMessage.length > 0 && this.updateProgress(),
                    this.cartToggleButtons.forEach((t) => {
                        t.classList.remove(qh), this.newTotalItems > 0 && t.classList.add(qh);
                    }),
                    this.toggleErrorMessage(),
                    this.updateItemsQuantity(this.cartCount),
                    (this.cartTotalPrice.innerHTML = 0 === this.subtotal ? window.theme.strings.free : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                    this.totalItems !== this.newTotalItems && ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                    (this.isCartDrawerOpen || this.isCartPage) && this.itemsHolder.classList.add(Ih),
                    this.cartEvents(),
                    this.initQuantity(),
                    this.enableCartButtons(),
                    this.resetButtonClasses(),
                    this.removeLoadingClass(),
                    document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: !0 })),
                    this.cartDrawer)
                ) {
                    this.openCartDrawer();
                    const t = (e) => {
                        e.target === this.cartDrawer && (this.animateCartItems("in"), this.cartDrawer.removeEventListener("transitionend", t));
                    };
                    this.cartDrawer.addEventListener("transitionend", t);
                }
                requestAnimationFrame(() => this.animateCartItems("in"));
            }
            getCartItemCount() {
                return this.cart ? Array.from(this.cart.querySelectorAll(yh.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0) : 0;
            }
            hasItemsInCart() {
                return this.totalItems > 0;
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(yh.cartMessage).forEach((e) => {
                        const i = e.hasAttribute(Oh) && "true" === e.getAttribute(Oh) && 0 !== t,
                            s = e.querySelector(yh.cartMessageDefault);
                        e.classList.toggle(Ch, t >= this.cartFreeLimitShipping && i), e.classList.toggle(bh, 0 === t), s && s.classList.toggle(bh, t >= this.cartFreeLimitShipping);
                    });
            }
            updateProgress() {
                const t = (this.subtotal / this.cartFreeLimitShipping) * 100;
                let e = i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
                (e.endsWith(".00") || e.endsWith(",00")) && (e = e.slice(0, -3)),
                    theme.settings.currency_code_enable && (e += ` ${theme.current_iso_code}`),
                    this.cartMessage.length > 0 &&
                        document.querySelectorAll(yh.cartMessage).forEach((i) => {
                            const s = i.querySelectorAll(yh.cartProgress),
                                o = i.querySelector(yh.leftToSpend);
                            o && (o.innerHTML = e),
                                s.length &&
                                    s.forEach((e, i) => {
                                        e.classList.toggle(bh, this.subtotal / this.cartFreeLimitShipping >= 1), e.style.setProperty("--progress-width", `${t}%`), 0 === i && e.setAttribute(Vh, t);
                                    }),
                                this.freeShippingMessageHandle(this.subtotal);
                        });
            }
            renderPairProducts() {
                if (
                    ((this.flktyUpsell = null),
                    (this.pairProductsHolder = document.querySelector(yh.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(yh.pairProducts)),
                    (this.upsellHolders = document.querySelectorAll(yh.upsellHolder)),
                    null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
                )
                    return;
                const t = this;
                this.upsellHolders.length > 1
                    ? (this.flktyUpsell = new e(this.pairProducts, {
                          wrapAround: !0,
                          pageDots: !0,
                          adaptiveHeight: !0,
                          prevNextButtons: !1,
                          on: {
                              ready: function () {
                                  new gh(t.cart), this.reloadCells(), requestAnimationFrame(() => this.resize());
                              },
                          },
                      }))
                    : new gh(this.cart);
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                (e = e.split("}}")[1]), (i = i.split("}}")[1]), this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`);
            }
            observeAdditionalCheckoutButtons() {
                const t = this.cart.querySelector(yh.additionalCheckoutButtons);
                if (t) {
                    const e = new MutationObserver(() => {
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus({ container: this.cart }), e.disconnect();
                    });
                    e.observe(t, { subtree: !0, childList: !0 });
                }
            }
            formSubmitHandler() {
                const t = document.querySelector(yh.cartTermsCheckbox).checked,
                    e = document.querySelector(yh.termsErrorMessage);
                if (t) e.classList.remove(Lh), this.cartCheckoutButton.removeAttribute(_h);
                else {
                    if (document.querySelector(yh.termsErrorMessage).length > 0) return;
                    (e.innerText = theme.strings.cart_acceptance_error), this.cartCheckoutButton.setAttribute(_h, !0), e.classList.add(Lh);
                }
            }
            resetButtonClasses() {
                const t = document.querySelectorAll(yh.buttonAddToCart);
                t &&
                    t.forEach((t) => {
                        t.classList.contains(kh) &&
                            (t.classList.remove(kh),
                            t.classList.add(Ch),
                            setTimeout(() => {
                                t.removeAttribute(_h), t.classList.remove(Ch);
                            }, fh.timers.addProductTimeout));
                    });
            }
            addLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.add(kh) : this.itemsWrapper && this.itemsWrapper.classList.add(kh);
            }
            removeLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.remove(kh) : this.itemsWrapper && this.itemsWrapper.classList.remove(kh);
            }
            scrollToCartTop() {
                var t;
                this.cartDrawer
                    ? this.cartDrawerBody.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    : window.scrollTo({ top: (null === (t = this.outerSection) || void 0 === t ? void 0 : t.offsetTop) - this.headerInitialHeight - this.announcementBarHeight, left: 0, behavior: "smooth" });
            }
            unload() {
                this.cartDrawerToggle && this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent),
                    this.cartToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
                    null !== this.collapsible && this.collapsible.onUnload();
            }
            constructor() {
                "/password" !== window.location.pathname && this.init();
            }
        };
    I("cart-template", {
        onLoad() {
            Jh[this.id] = new Zh();
        },
        onUnload() {
            "function" == typeof Jh[this.id].unload && Jh[this.id].unload();
        },
    });
    const td = "is-visible",
        ed = document.querySelector("[data-scroll-top-button]");
    ed &&
        (ed.addEventListener("click", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener(
            "scroll",
            ze(() => {
                ed.classList.toggle(td, window.pageYOffset > window.innerHeight);
            }, 150)
        ));
    const id = "details",
        sd = "[data-popdown-body]",
        od = "[data-popdown-close]",
        nd = "[data-popdown-toggle]",
        rd = "[data-search-form-inner]",
        ad = "[data-popular-searches-link]",
        ld = "[data-site-header]",
        cd = "[data-nav]",
        hd = "[data-nav-items-compress]",
        dd = "[data-nav-icons]",
        ud = "[data-mobile-menu]",
        pd = "predictive-search",
        md = "search-form",
        gd = "data-popdown-in-header",
        fd = "data-popdown-in-page",
        yd = "aria-activedescendant",
        vd = "aria-expanded",
        bd = "open",
        wd = "role",
        Sd = "search-opened",
        Ed = "site-header--menu-opened",
        Ld = "site-header--compress",
        kd = "is-open";
    let Ad = class extends HTMLElement {
        connectedCallback() {
            var t;
            (this.isPopdownInHeader &&
                (this.searchFormInner.addEventListener("transitionend", this.popdownTransitionCallbackEvent),
                this.details.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                this.details.addEventListener("toggle", this.detailsToggleCallbackEvent),
                this.popdownClose.addEventListener("click", (t) => this.close(t)),
                this.popdownToggle.addEventListener("click", (t) => this.onPopdownToggleClick(t)),
                this.popdownToggle.setAttribute(wd, "button")),
            this.isPopdownInPage) &&
                (this.popdownClose.addEventListener("click", () => this.triggerPopdownClose()),
                this.searchFormWrapper.addEventListener("focusout", () => this.onFocusOut()),
                null === (t = this.searchFormWrapper.input) || void 0 === t || t.addEventListener("click", (t) => this.triggerPopdownOpen(t)));
            this.popularSearchesLink.forEach((t) => {
                t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const e = t.target.textContent;
                    (this.searchFormWrapper.input.value = e), this.searchFormWrapper.submit();
                });
            });
        }
        onPopdownToggleClick(t) {
            const e = navigator.userAgent.includes("Chrome"),
                i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            e && !i && t.target.closest(id).setAttribute(bd, ""), t.target.closest(id).hasAttribute(bd) && (t.preventDefault(), this.close());
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute(bd) && this.open();
        }
        popdownTransitionCallback(t) {
            t.target === this.searchFormInner && (this.details.classList.contains(kd) ? "transform" === t.propertyName && this.a11y.trapFocus({ container: this.searchFormInner }) : this.onClose());
        }
        onBodyClick(t) {
            var e;
            const i = this.contains(t.target);
            (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains(Ed)) || i || i || this.close();
        }
        onFocusOut() {
            this.predictiveSearch &&
                requestAnimationFrame(() => {
                    this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close();
                });
        }
        triggerPopdownOpen(t) {
            let e = matchMedia("(pointer:coarse)").matches;
            const i = window.innerWidth < theme.sizes.small,
                s = e || i;
            if ((i && window.Shopify.designMode && (e = !0), this.nav && this.mobileMenu && s)) {
                t.preventDefault();
                const i = this.header.classList.contains(Ld);
                let s = this.mobileMenu.querySelector(nd);
                e || (s = i ? this.nav.querySelector(`${hd} ${nd}`) : this.nav.querySelector(`${dd} ${nd}`)),
                    setTimeout(() => {
                        null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
                    }, 300);
            }
        }
        open() {
            (this.onBodyClickEvent = (t) => this.onBodyClick(t)),
                this.searchFormWrapper.input.setAttribute(vd, !0),
                document.body.classList.add(Sd),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                requestAnimationFrame(() => {
                    this.details.classList.add(kd);
                });
        }
        close(t) {
            const e = this.searchFormWrapper.input.getAttribute(yd);
            (t && t.target === this.popdownClose && e && "" !== e) ||
                (this.a11y.removeTrapFocus(), this.details.classList.remove(kd), this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.handleFocusableDescendants(!0));
        }
        triggerPopdownClose() {
            this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.popularSearches && requestAnimationFrame(() => document.activeElement.blur());
        }
        onClose() {
            this.details.removeAttribute(bd),
                document.dispatchEvent(new CustomEvent("theme:search:close", { bubbles: !0 })),
                document.body.classList.remove(Sd),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        ensureClosingOnResize() {
            null === this.offsetParent && this.onClose();
        }
        constructor() {
            var t, e, i;
            super(),
                (this.isPopdownInHeader = this.hasAttribute(gd)),
                (this.isPopdownInPage = this.hasAttribute(fd)),
                (this.popdownBody = this.querySelector(sd)),
                (this.popdownClose = this.querySelector(od)),
                (this.searchFormInner = this.querySelector(rd)),
                (this.popularSearchesLink = this.querySelectorAll(ad)),
                (this.searchFormWrapper = this.querySelector(md) ? this.querySelector(md) : this.querySelector(pd)),
                (this.predictiveSearch = this.searchFormWrapper.matches(pd)),
                (this.header = document.querySelector(ld)),
                (this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
                (this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector(cd)),
                (this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector(ud)),
                (this.a11y = ri),
                (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
                (this.popdownTransitionCallbackEvent = (t) => this.popdownTransitionCallback(t)),
                (this.detailsToggleCallbackEvent = (t) => this.detailsToggleCallback(t)),
                this.isPopdownInHeader && ((this.details = this.querySelector(id)), (this.popdownToggle = this.querySelector(nd)));
        }
    };
    customElements.define("search-popdown", Ad),
        (Shopify.Products = (function () {
            const t = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, onComplete: null };
            let e = [],
                i = null,
                s = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: { expires: n.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 },
                    name: "shopify_recently_viewed",
                    write: function (t) {
                        const e = t.join(" ");
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                    },
                    read: function () {
                        let t = [],
                            e = null;
                        return (
                            -1 !== document.cookie.indexOf("; ") &&
                                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                                (e = document.cookie
                                    .split("; ")
                                    .find((t) => t.startsWith(this.name))
                                    .split("=")[1]),
                            null !== e && (t = e.split(" ")),
                            t
                        );
                    },
                    destroy: function () {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                    },
                    remove: function (t) {
                        const e = this.read(),
                            i = e.indexOf(t);
                        -1 !== i && (e.splice(i, 1), this.write(e));
                    },
                },
                a = (e, i, o, n) => {
                    i.length && e < t.howManyToShow
                        ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`)
                              .then((t) => t.text())
                              .then((t) => {
                                  const s = 150 * e,
                                      l = o.id ? `#${o.id}` : "",
                                      c = document.createElement("div");
                                  let h = t;
                                  if (h.includes("data-unpublished")) return r.remove(i[0]), i.shift(), void a(e, i, o, n);
                                  (h = h.includes("||itemAosDelay||") ? h.replaceAll("||itemAosDelay||", s) : h),
                                      (h = h.includes("||itemAosAnchor||") ? h.replaceAll("||itemAosAnchor||", l) : h),
                                      (c.innerHTML = h),
                                      (o.innerHTML += c.querySelector("[data-api-content]").innerHTML),
                                      i.shift(),
                                      e++,
                                      a(e, i, o, n);
                              })
                              .catch(() => {
                                  r.remove(i[0]), i.shift(), a(e, i, o, n);
                              })
                        : ((e, i) => {
                              Br(e, !0);
                              const o = r.read().length;
                              if (Shopify.recentlyViewed && s && o && o < s && e.children.length) {
                                  let t = [],
                                      i = [],
                                      s = 0;
                                  for (const e in Shopify.recentlyViewed) {
                                      s += 1;
                                      const o = Shopify.recentlyViewed[e].split(" "),
                                          n = parseInt(e.split("_")[1]);
                                      (t = [...t, ...o]), (r.read().length === n || (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) && (i = [...i, ...o]);
                                  }
                                  for (let s = 0; s < e.children.length; s++) {
                                      const o = e.children[s];
                                      t.length && o.classList.remove(...t), i.length && o.classList.add(...i);
                                  }
                              }
                              if (t.onComplete)
                                  try {
                                      t.onComplete(e, i);
                                  } catch (t) {
                                      console.log(t);
                                  }
                          })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    const n = o || {};
                    Object.assign(t, n), (e = r.read()), (i = document.querySelector(`#${t.wrapperId}`)), (s = t.howManyToShow), (t.howManyToShow = Math.min(e.length, t.howManyToShow)), t.howManyToShow && i && a(0, e, i, t.section);
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const i = e || {};
                    Object.assign(t, i);
                    let s = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const i = s.indexOf(e);
                        -1 === i ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory))) : (s.splice(i, 1), s.unshift(e)), r.write(s);
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })()),
        (theme.ProductModel = (function () {
            let t = {},
                e = {},
                i = {};
            const s = {
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaGroup: "[data-product-single-media-group]",
                    productXr: "[data-shopify-xr]",
                    mediaId: "data-media-id",
                    model3d: "data-shopify-model3d-id",
                    modelViewer: "model-viewer",
                    modelJson: "#ModelJson-",
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                },
                o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
            function n(t, n) {
                if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
                t.classList.add(o.isLoading);
                const l = document.createElement("div");
                l.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
                const c = l.querySelector("model-viewer"),
                    h = t.querySelector(s.deferredMedia);
                h.appendChild(c), h.setAttribute("loaded", !0);
                const d = t.dataset.mediaId,
                    u = c.dataset.modelId,
                    p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
                (i[n] = { element: p, defaultId: u }),
                    (e[d] = { modelId: u, mediaId: d, sectionId: n, container: t, element: c }),
                    window.ShopifyXR
                        ? a()
                        : window.Shopify.loadFeatures([
                              { name: "shopify-xr", version: "1.0", onLoad: r },
                              { name: "model-viewer-ui", version: "1.0", onLoad: a },
                          ]);
            }
            function r(e) {
                if (e) console.warn(e);
                else if (window.ShopifyXR) {
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            const i = t[e];
                            if (i.loaded) continue;
                            const o = document.querySelector(`${s.modelJson}${e}`);
                            o && (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (i.loaded = !0));
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        r();
                    });
            }
            function a(t) {
                if (t) console.warn(t);
                else
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            const i = e[t];
                            i.modelViewerUi || ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i));
                        }
            }
            function l(t) {
                const e = i[t.sectionId];
                t.container.addEventListener("theme:media:visible", function () {
                    e.element.setAttribute(s.model3d, t.modelId), window.theme.touch || (t.modelViewerUi.play(), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
                }),
                    t.container.addEventListener("theme:media:hidden", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.element.addEventListener("load", () => {
                        e.element.setAttribute(s.model3d, t.modelId), t.container.classList.remove(o.isLoading), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                        c(t.mediaId),
                            setTimeout(() => {
                                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                            }, 50);
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                        t.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                    }),
                    c(t.mediaId);
            }
            function c(t) {
                const e = `[${s.mediaId}="${t}"]`,
                    i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
                i.length &&
                    i.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(o.mediaHidden);
                    });
            }
            return {
                init: function (e, i) {
                    t[i] = { loaded: !1 };
                    const o = e.querySelector(s.deferredMediaButton);
                    o && o.addEventListener("click", n.bind(this, e, i));
                },
                loadContent: n,
                removeSectionModels: function (i) {
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            e[t].sectionId === i && delete e[t];
                        }
                    delete t[i], delete theme.mediaInstances[i];
                },
            };
        })()),
        I("collection-template", Bn);
    const Cd = ".template-customers-addresses",
        qd = "[data-form]",
        Td = "[data-form-new]",
        Pd = "[data-button-new]",
        xd = "[data-button-edit]",
        Id = "[data-button-delete]",
        Hd = "[data-button-cancel]",
        Fd = "data-form-edit",
        Md = "AddressCountryNew",
        Dd = "AddressProvinceNew",
        Od = "AddressProvinceContainerNew",
        Bd = "[data-country-option]",
        zd = "AddressCountry",
        _d = "AddressProvince",
        $d = "AddressProvinceContainer",
        Vd = 'input[type="text"]:not(.optional)',
        Rd = "data-form-id",
        Nd = "is-hidden",
        Wd = "validation--showup";
    const Ud = document.querySelector(Cd);
    Ud &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    const i = t.querySelectorAll(Pd);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function (i) {
                                i.preventDefault(), t.classList.add(Nd), e.classList.remove(Nd);
                            });
                        });
                    const s = t.querySelectorAll(xd);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault();
                                const i = this.getAttribute(Rd);
                                t.querySelector(`[${Fd}="${i}"]`).classList.toggle(Nd);
                            });
                        });
                    const o = t.querySelectorAll(Id);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault();
                                const e = this.getAttribute(Rd);
                                confirm(theme.strings.delete_confirm) && Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
                            });
                        });
                    const n = t.querySelectorAll(Hd);
                    n.length &&
                        n.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault(), this.closest(qd).classList.add(Nd), document.querySelector(Pd).classList.remove(Nd);
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(Md, Dd, { hideElement: Od }),
                    this.section.querySelectorAll(Bd).forEach((t) => {
                        const e = t.getAttribute(Rd),
                            i = `${zd}_${e}`,
                            s = `${_d}_${e}`,
                            o = `${$d}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    });
            }
            validate() {
                this.accountForms.forEach((t) => {
                    const e = t.querySelector("form"),
                        i = e.querySelectorAll(Vd);
                    e.addEventListener("submit", (t) => {
                        let e = !1;
                        i.forEach((t) => {
                            t.value ? t.nextElementSibling.classList.remove(Wd) : (t.nextElementSibling.classList.add(Wd), (e = !0));
                        }),
                            e && t.preventDefault();
                    });
                });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector(Td)), (this.accountForms = this.section.querySelectorAll(qd)), this.init(), this.validate();
            }
        })(Ud);
    const jd = "[data-account-form]",
        Gd = "[data-show-reset]",
        Kd = "[data-hide-reset]",
        Qd = "[data-recover-password]",
        Yd = "[data-login-form]",
        Xd = "[data-recover-success]",
        Jd = "[data-recover-success-text]",
        Zd = "#recover",
        tu = "is-hidden";
    const eu = document.querySelector(jd);
    eu &&
        new (class {
            init() {
                window.location.hash == Zd ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                    this.success && this.successText.classList.remove(tu),
                    this.showButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        },
                        !1
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        },
                        !1
                    );
            }
            showRecoverPasswordForm() {
                return this.recover.classList.remove(tu), this.login.classList.add(tu), (window.location.hash = Zd), !1;
            }
            hideRecoverPasswordForm() {
                return this.login.classList.remove(tu), this.recover.classList.add(tu), (window.location.hash = ""), !1;
            }
            constructor(t) {
                (this.form = t),
                    (this.showButton = t.querySelector(Gd)),
                    (this.hideButton = t.querySelector(Kd)),
                    (this.recover = t.querySelector(Qd)),
                    (this.login = t.querySelector(Yd)),
                    (this.success = t.querySelector(Xd)),
                    (this.successText = t.querySelector(Jd)),
                    this.init();
            }
        })(eu),
        I("search-template", [Bn, yr]);
    const iu = "[data-ticker-scale]",
        su = "[data-ticker-text]",
        ou = "data-clone",
        nu = "data-marquee-speed",
        ru = "ticker--animated",
        au = "ticker--unloaded",
        lu = "ticker__comparitor",
        cu = 1.63,
        hu = 100;
    const du = "[data-parallax]",
        uu = ".shopify-section",
        pu = "[data-main]",
        mu = "is-disabled",
        gu = "main-content",
        fu = "shopify-section",
        yu = "section-footer--visible",
        vu = "card-scrolling-hidden",
        bu = "sticky-top-zero",
        wu = "data-parallax",
        Su = "data-parallax-intensity",
        Eu = "data-parallax-static",
        Lu = "data-parallax-single",
        ku = "data-parallax-disable-on-mobile",
        Au = "data-parallax-rounded-corners",
        Cu = "data-parallax-rounded-corners-large",
        qu = {};
    let Tu = class {
        assignFooterArguments() {
            this.animations.includes("footer") &&
                ((this.shopifySection = this.container.closest(uu)),
                (this.footerPrevSectionOffset = 0),
                this.container.hasAttribute(Au) && ((this.footerPrevSectionOffset = 8), this.container.hasAttribute(Cu) && (this.footerPrevSectionOffset = 34)),
                (this.prevSection = this.container.parentNode.previousElementSibling),
                !this.prevSection || this.prevSection.classList.contains(fu) || this.prevSection.classList.contains(gu) || (this.prevSection = this.main),
                requestAnimationFrame(() => {
                    (this.containerHeight = this.container.offsetHeight), (this.footerOffset = 0.15 * this.containerHeight), (this.cachedPosition = this.footerOffset), (this.cachedPercentage = 0);
                }));
        }
        assignCardScrollingArguments() {
            if (!this.animations.includes("card-scrolling")) return;
            let { stickyHeaderHeight: t } = N();
            if (
                ((this.headerHeight = t || 0),
                (this.shopifySection = this.container.closest(uu)),
                (this.nextSection = this.shopifySection.nextElementSibling),
                (this.cardScrollingStickyTop = this.headerHeight || 0),
                (this.cardScrollingMarginTop = this.nextSection ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top")) : 0),
                (this.after = !1),
                (this.prevSection = this.shopifySection.previousElementSibling),
                this.prevSection)
            ) {
                const t = this.firstSection.id,
                    e = this.prevSection.matches(`#${t}`),
                    i = this.prevSection.offsetHeight;
                this.shopifySection.classList.toggle(bu, e && i <= 2 * this.headerHeight);
            }
            this.opacityValue = (t) => (t ? (Boolean(t <= 0) ? 0 : Boolean(t > 0 && t <= 100) ? Number(t / 100).toFixed(4) : Boolean(t > 100) ? 1 : void 0) : 0);
        }
        init() {
            this.updateParallax(), document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:parallax:refresh", this.refreshEvent);
        }
        updateParallax() {
            this.container.classList.contains(mu) ||
                (this.disableOnMobile && we()) ||
                ((this.scrollTop = Math.round(window.scrollY)),
                (this.scrollBottom = this.scrollTop + this.viewportHeight),
                (this.elementOffsetTopPoint = Math.round(this.container.getBoundingClientRect().top + this.scrollTop)),
                window.Shopify.designMode && (this.assignCardScrollingArguments(), (this.containerHeight = this.container.offsetHeight)),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                this.adjustCalculations(),
                this.toggleVisibility(),
                this.isInView &&
                    ((this.scrollProgress = this.scrollBottom - this.elementOffsetTopPoint),
                    (this.percentage = (100 * (this.scrollProgress - this.containerHeight / 2)) / this.viewportHeight),
                    (this.percentageFull = Number(this.scrollProgress / this.containerHeight).toFixed(2)),
                    (this.percentageVisible = Number((100 * this.scrollProgress) / (this.viewportHeight + this.containerHeight)).toFixed(2)),
                    this.animations.includes("circle") && this.animateCircleText(),
                    (this.animations.includes("horizontal") || this.animations.includes("vertical") || this.animations.includes("diagonal")) && this.animateOverlappingImages(),
                    (this.animations.includes("offset-ltr") || this.animations.includes("offset-rtl")) && this.offsetX(),
                    this.animations.includes("card-scrolling") && this.cardScrollingEffect(),
                    this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
                    this.animations.includes("footer") && this.animateFooter()));
        }
        adjustCalculations() {
            var t;
            (this.animations.includes("card-scrolling") &&
                ((this.currentSectionTop = this.shopifySection.getBoundingClientRect().top),
                this.nextSection
                    ? ((this.nextSectionTop = this.nextSection.getBoundingClientRect().top), (this.offsetTop = this.nextSectionTop - this.containerHeight - this.cardScrollingMarginTop))
                    : ((this.nextSectionTop = this.currentSectionTop + this.containerHeight), (this.offsetTop = this.currentSectionTop)),
                (this.distance = Math.floor(this.currentSectionTop - this.headerHeight)),
                (this.after = Boolean(Math.round(this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop + 0.1 * this.viewportHeight) < 0)),
                (this.isInView = this.isTopOfElementReached && !this.after)),
            this.animations.includes("footer")) &&
                ((this.elementOffsetTopPoint = Math.round((null === (t = this.prevSection) || void 0 === t ? void 0 : t.getBoundingClientRect().bottom) - this.footerPrevSectionOffset + this.scrollTop)),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                (this.isApproaching = Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) < this.scrollBottom));
        }
        toggleVisibility() {
            this.animations.includes("card-scrolling") && this.shopifySection.classList.toggle(vu, this.after),
                this.animations.includes("footer") && (Boolean(this.isApproaching || this.isInView) ? this.shopifySection.classList.add(yu) : this.shopifySection.classList.remove(yu));
        }
        cardScrollingEffect() {
            const t = (this.offsetTop / this.containerHeight) * -100;
            this.container.style.setProperty("--card-scrolling-overlay", this.opacityValue(t));
        }
        zoomInOut() {
            if (this.animations.includes("card-scrolling") && this.nextSection) {
                const t = this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop - this.containerHeight,
                    e = Math.round(t + this.scrollTop),
                    i = this.scrollBottom - e;
                this.percentageVisible = Number((100 * i) / (this.viewportHeight + this.containerHeight + this.cardScrollingMarginTop)).toFixed(2);
            }
            const t = (0.2 * this.percentageVisible) / 100;
            let e = Number(1 + t).toFixed(4);
            (e = e > 1 ? e : 1), this.container.style.setProperty("--scale", e);
        }
        offsetX() {
            const t = this.container.hasAttribute(Eu),
                e = this.container.getAttribute(Su) || 100;
            let i = this.animations.includes("offset-ltr") ? e : 0;
            t && (i = e / 2);
            const s = this.animations.includes("offset-ltr") ? 1 : -1,
                o = (e * this.percentageVisible) / 100 - i,
                n = Number(o * s).toFixed(2);
            this.container.style.setProperty("--offsetX", `${n}%`);
        }
        updateHeight() {
            if (this.animations.includes("card-scrolling")) {
                let { stickyHeaderHeight: t } = N();
                if (
                    ((this.headerHeight = t || 0),
                    (this.cardScrollingStickyTop = this.headerHeight || 0),
                    (this.cardScrollingMarginTop = this.nextSection ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top")) : 0),
                    (this.containerHeight = this.container.offsetHeight),
                    (this.prevSection = this.shopifySection.previousElementSibling),
                    this.prevSection)
                ) {
                    const t = this.firstSection.id,
                        e = this.prevSection.matches(`#${t}`),
                        i = this.prevSection.offsetHeight;
                    this.shopifySection.classList.toggle(bu, e && i <= 2 * this.headerHeight);
                }
            }
            const t = matchMedia("(min-width: 1024px)").matches;
            (this.orientation !== Y() || t) && ((this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0))), (this.containerHeight = this.container.offsetHeight), (this.orientation = Y()));
        }
        animateCircleText() {
            const t = ((70 * this.percentage) / 100) * -1;
            this.percentage > 0 && this.container.style.setProperty("--rotate", `${35 + t}deg`);
        }
        animateOverlappingImages() {
            const t = 0.25 * this.container.getAttribute(Su),
                e = t / 2,
                i = this.container.hasAttribute(Lu),
                s = (t * this.percentage) / 100;
            let o = 0,
                n = 0,
                r = 0,
                a = 0;
            (this.animations.includes("horizontal") || this.animations.includes("diagonal")) && ((o = -1 * e + s), (r = e - s)),
                (this.animations.includes("vertical") || this.animations.includes("diagonal")) && ((n = e - s), (a = -1 * e + s)),
                this.container.style.setProperty("--transformX-primary", `${o}%`),
                this.container.style.setProperty("--transformY-primary", `${n}%`),
                i || (this.container.style.setProperty("--transformX-secondary", `${r}%`), this.container.style.setProperty("--transformY-secondary", `${a}%`));
        }
        animateFooter() {
            const t = this.footerOffset * this.percentageFull,
                e = Number((t / this.footerOffset) * 100).toFixed(2),
                i = new WebKitCSSMatrix(window.getComputedStyle(this.container).transform),
                s = Number(i.m42).toFixed(2);
            let o = Number(this.footerOffset - t).toFixed(2);
            this.percentageFull >= 1 && (o = 0), s !== o && this.cachedPercentage !== e && (this.container.style.setProperty("--transformY", `${o}`), (this.cachedPercentage = e), (this.cachedPosition = o));
        }
        unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:parallax:refresh", this.refreshEvent);
        }
        refresh() {
            this.assignFooterArguments(), this.assignCardScrollingArguments(), this.updateParallax();
        }
        constructor(t) {
            (this.container = t),
                (this.percentage = 0),
                (this.percentageFull = 0),
                (this.animation = this.container.getAttribute(wu)),
                (this.animations = this.animation.split(",")),
                (this.disableOnMobile = this.container.hasAttribute(ku)),
                (this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                (this.containerHeight = this.container.offsetHeight),
                (this.main = document.querySelector(pu)),
                (this.firstSection = this.main.children[0]),
                (this.orientation = Y()),
                (this.scrollEvent = () => this.updateParallax()),
                (this.resizeEvent = () => this.updateHeight()),
                (this.refreshEvent = () => this.refresh()),
                this.assignFooterArguments(),
                this.assignCardScrollingArguments(),
                requestAnimationFrame(() => this.init());
        }
    };
    const Pu = {
            onLoad() {
                qu[this.id] = [];
                this.container.querySelectorAll(du).forEach((t) => {
                    qu[this.id].push(new Tu(t));
                });
            },
            onUnload() {
                qu[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        xu = "[data-announcement]",
        Iu = "[data-announcement-slide]",
        Hu = "[data-ticker-frame]",
        Fu = "[data-slide]",
        Mu = "[data-slider]",
        Du = "[data-static]",
        Ou = "[data-ticker-scale]",
        Bu = "[data-ticker-text]",
        zu = "[data-parallax]",
        _u = "text-highlight",
        $u = "data-slide",
        Vu = "data-slider-speed",
        Ru = "data-slider-arrows",
        Nu = "data-stop",
        Wu = "style",
        Uu = "data-target-referrer",
        ju = "clip-path",
        Gu = "desktop",
        Ku = "mobile",
        Qu = "ticker--animated",
        Yu = "is-disabled",
        Xu = "clipPath",
        Ju = {};
    const Zu = {
        onLoad() {
            Ju[this.id] = [];
            const t = this.container.querySelector(xu);
            t &&
                Ju[this.id].push(
                    new (class {
                        init() {
                            this.removeAnnouncement(),
                                this.slider && (this.initSlider(), document.addEventListener("theme:resize:width", this.initSlider.bind(this))),
                                this.static && (this.initTickers(), this.tickerAnimationPause()),
                                this.slider || this.static || (this.initTickers(!0), this.tickerAnimationPause()),
                                this.updateSVGClipPathIDs();
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(Uu) && (-1 !== this.locationPath.indexOf(e.getAttribute(Uu)) || window.Shopify.designMode || e.parentNode.removeChild(e));
                            }
                        }
                        checkSlidesClasses(t, e) {
                            if (0 !== t.length) {
                                const i = e.querySelectorAll(`${Fu}.${Ku}`),
                                    s = e.querySelectorAll(`${Fu}.${Gu}`);
                                t.length === i.length ? e.parentNode.classList.add(Ku) : t.length === s.length && e.parentNode.classList.add(Gu);
                            }
                        }
                        initSlider() {
                            const t = this.slider.querySelectorAll(Fu),
                                i = this.slider.hasAttribute(Ru);
                            if ((this.checkSlidesClasses(t, this.barHolder), t)) {
                                let t = `${Fu}`;
                                (t = window.innerWidth < theme.sizes.small ? `${Fu}:not(.${Gu})` : `${Fu}:not(.${Ku})`),
                                    null != this.flkty && this.flkty.destroy(),
                                    (this.flkty = new e(this.slider, {
                                        cellSelector: t,
                                        pageDots: !1,
                                        prevNextButtons: i,
                                        wrapAround: !0,
                                        autoPlay: parseInt(this.slider.getAttribute(Vu), 10),
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slider.dispatchEvent(new CustomEvent("slider-is-loaded", { bubbles: !0, detail: { slider: this } }));
                                                }, 10);
                                            },
                                            change: (t) => {
                                                this.flkty.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(_u).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                                });
                                            },
                                        },
                                    })),
                                    this.flkty.reposition();
                            }
                            this.slider.addEventListener("slider-is-loaded", () => {
                                this.initTickers(), this.updateSVGClipPathIDs();
                            });
                        }
                        initTickers(t = !1) {
                            this.barHolder.querySelectorAll(Hu).forEach((e) => {
                                const i = new (class {
                                    listen() {
                                        document.addEventListener("theme:resize:width", this.resizeEvent), this.checkWidth();
                                    }
                                    checkWidth() {
                                        const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                                        if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                                            if (1 === this.scale.childElementCount) {
                                                if ((this.text.classList.add(ru), (this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(ou, ""), this.scale.appendChild(this.clone), this.stopClone))
                                                    for (let t = 0; t < 10; t++) {
                                                        const t = this.text.cloneNode(!0);
                                                        t.setAttribute(ou, ""), this.scale.appendChild(t);
                                                    }
                                                let t = this.frame.getAttribute(nu);
                                                null === t && (t = 100);
                                                const e = cu * (100 / parseInt(t, 10)),
                                                    i = (this.text.clientWidth / hu) * e;
                                                this.scale.style.setProperty("--animation-time", `${i}s`);
                                            }
                                        } else {
                                            this.text.classList.add(ru);
                                            let t = this.scale.querySelector(`[${ou}]`);
                                            t && this.scale.removeChild(t), this.text.classList.remove(ru);
                                        }
                                    }
                                    unload() {
                                        document.removeEventListener("theme:resize:width", this.resizeEvent);
                                    }
                                    constructor(t, e = !1) {
                                        (this.frame = t),
                                            (this.stopClone = e),
                                            (this.scale = this.frame.querySelector(iu)),
                                            (this.text = this.frame.querySelector(su)),
                                            (this.comparitor = this.text.cloneNode(!0)),
                                            this.comparitor.classList.add(lu),
                                            this.frame.appendChild(this.comparitor),
                                            this.scale.classList.remove(au),
                                            (this.resizeEvent = o(() => this.checkWidth(), 100)),
                                            this.listen();
                                    }
                                })(e, t);
                                this.tickers.push(i);
                                const s = e.querySelectorAll(Fu);
                                this.checkSlidesClasses(s, this.barHolder);
                            });
                        }
                        toggleTicker(t, e) {
                            const i = t.target.closest(Ou),
                                s = document.querySelector(`[${$u}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                (i.setAttribute(Nu, ""),
                                i.querySelectorAll(Bu).forEach((t) => {
                                    t.classList.remove(Qu), (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    (i.querySelectorAll(Bu).forEach((t) => {
                                        t.classList.add(Qu), t.removeAttribute(Wu);
                                    }),
                                    i.removeAttribute(Nu),
                                    this.static && document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })));
                        }
                        tickerAnimationPause() {
                            let t = 0,
                                e = !1;
                            const i = this.barHolder.querySelector(Iu);
                            i.addEventListener("mouseenter", () => {
                                (e = !0),
                                    (t = setTimeout(() => {
                                        e &&
                                            i.querySelectorAll(Bu).forEach((t) => {
                                                t.style.animationPlayState = "paused";
                                            }),
                                            clearTimeout(t);
                                    }, 500));
                            }),
                                i.addEventListener("mouseleave", () => {
                                    (e = !1),
                                        i.querySelectorAll(Bu).forEach((t) => {
                                            t.style.animationPlayState = "running";
                                        });
                                });
                        }
                        updateSVGClipPathIDs() {
                            this.barHolder.querySelectorAll(Fu).forEach((t, e) => {
                                const i = t.querySelector(Xu);
                                if (i) {
                                    const s = `${i.id}_${e}`;
                                    i.id = s;
                                    const o = t.querySelector(`g[${ju}]`);
                                    o && o.setAttribute(ju, `url(#${s})`);
                                }
                            });
                        }
                        onBlockSelect(t) {
                            const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                            this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()),
                                this.slider || this.toggleTicker(t, !0),
                                this.parallax && (this.parallax.style.setProperty("--offsetX", "0%"), this.parallax.classList.add(Yu));
                        }
                        onBlockDeselect(t) {
                            this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                                this.slider || this.toggleTicker(t, !1),
                                this.parallax && (this.parallax.classList.remove(Yu), document.dispatchEvent(new CustomEvent("theme:scroll")));
                        }
                        onUnload() {
                            document.removeEventListener("theme:resize:width", this.initSlider.bind(this)),
                                this.tickers.length > 0 &&
                                    this.tickers.forEach((t) => {
                                        t.unload();
                                    });
                        }
                        constructor(t) {
                            (this.barHolder = t),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(Fu)),
                                (this.slider = this.barHolder.querySelector(Mu)),
                                (this.static = this.barHolder.querySelector(Du)),
                                (this.parallax = this.barHolder.querySelector(zu)),
                                (this.tickers = []),
                                (this.flkty = null),
                                this.init();
                        }
                    })(t)
                );
        },
        onBlockSelect(t) {
            Ju[this.id].length &&
                Ju[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
        },
        onBlockDeselect(t) {
            Ju[this.id].length &&
                Ju[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
        },
        onUnload() {
            Ju[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    I("announcement-bar", Zu), I("marquee", [Zu, Pu]);
    const tp = "[data-hover-disclosure]",
        ep = "[data-site-header]",
        ip = "[data-top-link]",
        sp = "[data-header-background]",
        op = "[data-nav-item]",
        np = "is-visible",
        rp = "grandparent",
        ap = "site-header--menu-opened",
        lp = "has-scrolled",
        cp = "site-header--hovered",
        hp = "megamenu-opened",
        dp = "data-hover-disclosure-toggle",
        up = "aria-haspopup",
        pp = "aria-expanded",
        mp = "aria-controls";
    let gp = {};
    const fp = {
            onLoad() {
                gp[this.id] = [];
                this.container.querySelectorAll(tp).forEach((t) => {
                    gp[this.id].push(
                        new (class {
                            setBackgroundHeight() {
                                (this.hasScrolled = this.body.classList.contains(lp)),
                                    (this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                                    this.grandparent ? ((this.dropdown.style.height = "auto"), (this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight)) : (this.dropdownHeight = this.headerHeight),
                                    this.background.style.setProperty("--header-background-height", `${this.dropdownHeight}px`),
                                    window.innerWidth < theme.sizes.small && this.hideDisclosure();
                            }
                            showDisclosure() {
                                this.setBackgroundHeight(),
                                    document.addEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.setAttribute(pp, !0),
                                    this.trigger.classList.add(np),
                                    this.header.classList.add(ap),
                                    this.trigger.classList.contains(rp) && this.body.classList.add(hp),
                                    this.updateHeaderHover();
                            }
                            hideDisclosure() {
                                this.background.style.removeProperty("--header-background-height"),
                                    document.removeEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.classList.remove(np),
                                    this.trigger.setAttribute(pp, !1),
                                    this.header.classList.remove(ap),
                                    this.body.classList.remove(hp);
                            }
                            updateHeaderHover() {
                                requestAnimationFrame(() => {
                                    const t = this.header.matches(":hover"),
                                        e = this.header.classList.contains(cp);
                                    t && !e && this.header.classList.add(cp);
                                });
                            }
                            handleTablets() {
                                this.trigger.addEventListener("touchstart", (t) => {
                                    if (!this.trigger.classList.contains(np)) {
                                        t.preventDefault();
                                        const e = this.header.querySelectorAll(`.${np}${op}`);
                                        if (e.length > 0)
                                            return void e.forEach((t) => {
                                                if (t !== this.trigger) {
                                                    t.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                                                    const e = () => {
                                                        requestAnimationFrame(() => {
                                                            this.showDisclosure();
                                                        }),
                                                            t.removeEventListener("transitionend", e);
                                                    };
                                                    t.addEventListener("transitionend", e);
                                                }
                                            });
                                        this.showDisclosure();
                                    }
                                });
                            }
                            connectHoverToggle() {
                                this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
                                    this.link.addEventListener("focus", () => this.showDisclosure()),
                                    this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                    this.trigger.addEventListener("focusout", (t) => {
                                        this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                    }),
                                    this.disclosure.addEventListener("keyup", (t) => {
                                        t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                    });
                            }
                            onBlockSelect(t) {
                                this.disclosure.contains(t.target) && this.showDisclosure(t);
                            }
                            onBlockDeselect(t) {
                                this.disclosure.contains(t.target) && this.hideDisclosure();
                            }
                            constructor(t) {
                                (this.disclosure = t),
                                    (this.body = document.body),
                                    (this.header = t.closest(ep)),
                                    (this.key = this.disclosure.id),
                                    (this.trigger = document.querySelector(`[${dp}='${this.key}']`)),
                                    (this.link = this.trigger.querySelector(ip)),
                                    (this.grandparent = this.trigger.classList.contains(rp)),
                                    (this.background = document.querySelector(sp)),
                                    this.trigger.setAttribute(up, !0),
                                    this.trigger.setAttribute(pp, !1),
                                    this.trigger.setAttribute(mp, this.key),
                                    (this.dropdown = this.trigger.querySelector(tp)),
                                    (this.setBackgroundHeightEvent = () => this.setBackgroundHeight()),
                                    this.connectHoverToggle(),
                                    this.handleTablets();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                gp[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                gp[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        yp = "[data-site-header]",
        vp = "[data-announcement-wrapper]",
        bp = "[data-collection-filters]",
        wp = "[data-logo-text-link]",
        Sp = "[data-collapsible-trigger]",
        Ep = "#nav-drawer",
        Lp = "[data-drawer]",
        kp = "[data-drawer-toggle]",
        Ap = "[data-popdown-toggle]",
        Cp = "[data-mobile-menu]",
        qp = "[data-nav]",
        Tp = "[data-nav-icons]",
        Pp = "[data-nav-item]",
        xp = "[data-nav-link-mobile]",
        Ip = "[data-nav-search-open]",
        Hp = "[data-wrapper]",
        Fp = "[data-header-background]",
        Mp = "[data-cart-page]",
        Dp = "[data-takes-space]",
        Op = {
            jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart", "js-quick-view-visible", "js-quick-view-from-cart"],
            headerTransparent: "site-header--transparent",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hasStickyHeader: "has-sticky-header",
            hideHeader: "hide-header",
            headerCompress: "site-header--compress",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone",
        },
        Bp = "data-nav-alignment",
        zp = "data-header-sticky",
        _p = {};
    const $p = {
        onLoad() {
            _p[this.id] = new (class {
                updateHeaderHover() {
                    requestAnimationFrame(() => {
                        const t = this.header.matches(":hover"),
                            e = this.header.classList.contains(Op.headerHovered);
                        t && !e && this.header.classList.add(Op.headerHovered);
                    });
                }
                handleTouchstart(t) {
                    const e = this.header.contains(t.target),
                        i = this.header.querySelector(`.${Op.isVisible}${Pp}`);
                    !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                }
                handleTextLinkLogos() {
                    if (null === this.logoTextLink) return;
                    const t = this.header.offsetHeight;
                    document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                }
                initStickyHeader() {
                    if (
                        ((this.headerSticky = this.header.hasAttribute(zp)),
                        CSS.supports("(selector(:has(*)))") || document.body.classList.toggle(Op.hasStickyHeader, this.headerSticky),
                        (this.hasScrolled = !1),
                        (this.hasCollectionFilters = document.querySelector(bp)),
                        (this.position = this.header.dataset.position),
                        "fixed" === this.position && !this.hasCollectionFilters)
                    )
                        return this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent);
                    document.body.classList.remove(Op.hasScrolled), window.isHeaderTransparent && this.header.classList.add(Op.headerTransparent);
                }
                headerState(t) {
                    const e = parseInt(this.header.dataset.height || this.header.offsetHeight),
                        i = document.querySelector(vp),
                        s = e + (i ? i.offsetHeight : 0),
                        o = window.pageYOffset || document.documentElement.scrollTop,
                        n = t && t.detail && t.detail.up;
                    (this.hasScrolled = o > s), document.body.classList.toggle(Op.hasScrolled, this.hasScrolled);
                    const r = o < s + window.stickyHeaderHeight && n;
                    if ((document.body.classList.toggle(Op.hideHeader, r), window.isHeaderTransparent)) {
                        const t = !this.hasScrolled || r;
                        this.header.classList.toggle(Op.headerTransparent, t);
                    }
                    if (this.header.classList.contains(Op.headerHovered)) {
                        const t = this.hasScrolled ? window.stickyHeaderHeight : e;
                        this.background.style.setProperty("--header-background-height", `${t}px`);
                        const i = this.header.querySelector(`.${Op.isVisible}${Pp}`);
                        i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
                    }
                }
                handleBackgroundEvents() {
                    this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent),
                        this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent),
                        this.header.addEventListener("focusout", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent);
                }
                updateBackgroundHeight(t) {
                    const e = matchMedia("(pointer:fine)").matches,
                        i = !document.body.classList.contains(Op.noOutline),
                        s = e && !i;
                    if (!t) return;
                    let o = Op.jsDrawerOpenAll.some((t) => document.body.classList.contains(t));
                    ("mouseenter" === t.type || o) &&
                        ((this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                        this.header.classList.add(Op.headerHovered),
                        this.header.classList.contains(Op.headerMenuOpened) || this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`)),
                        "mouseenter" !== t.type &&
                            requestAnimationFrame(() => {
                                if (((o = Op.jsDrawerOpenAll.some((t) => document.body.classList.contains(t))), o)) return;
                                if ("focusout" === t.type && !e) return;
                                if ("theme:search:close" === t.type && !s) return;
                                if (this.hasScrolled) return;
                                const n = null === document.activeElement.closest(yp),
                                    r = document.body.classList.contains(Op.searchOpened),
                                    a = this.header.classList.contains(Op.headerMenuOpened);
                                r || a || (("focusout" !== t.type || n) && (this.header.classList.remove(Op.headerHovered), this.background.style.setProperty("--header-background-height", "0px"), i || document.activeElement.blur()));
                            });
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth();
                }
                checkWidth() {
                    window.innerWidth < this.minWidth ? this.header.classList.add(Op.headerCompress) : this.header.classList.remove(Op.headerCompress);
                }
                getMinWidth() {
                    const t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
                        e = 2 * parseInt(t.paddingLeft),
                        i = this.header.cloneNode(!0);
                    i.classList.add(Op.cloneClass), document.body.appendChild(i);
                    const s = i.querySelectorAll(Dp),
                        o = (function (t, e) {
                            let i = [];
                            t.forEach((t) => {
                                i.push(t.clientWidth);
                            });
                            let [s, o, n] = i;
                            if ("left" === e) {
                                const t = s;
                                (s = o), (o = t);
                            }
                            return "right" !== e && (s > n ? (n = s) : (s = n)), s + o + n;
                        })(s, this.header.getAttribute(Bp));
                    return document.body.removeChild(i), o + 20 * s.length + e;
                }
                initMobileNav() {
                    var t;
                    if (
                        ((this.mobileMenu = this.headerSection.querySelector(Cp)),
                        (this.navDrawer = this.headerSection.querySelector(Ep)),
                        (this.drawerToggle = this.navDrawer.querySelector(kp)),
                        (this.navSearchOpen = this.navDrawer.querySelectorAll(Ip)),
                        null === (t = this.navSearchOpen) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                    const e = this.drawerToggle.closest(`${Lp}.${Op.isOpen}`),
                                        i = matchMedia("(pointer:coarse)").matches ? this.mobileMenu.querySelector(Ap) : this.nav.querySelector(Ap);
                                    this.drawerToggle.dispatchEvent(new Event("click", { bubbles: !0 }));
                                    const s = (t) => {
                                        t.target === e && (requestAnimationFrame(() => i.dispatchEvent(new Event("click", { bubbles: !0 }))), e.removeEventListener("transitionend", s));
                                    };
                                    e.addEventListener("transitionend", s);
                                });
                            }),
                        "link" === theme.settings.mobileMenuBehaviour)
                    )
                        return;
                    const e = this.headerSection.querySelectorAll(xp);
                    e.length &&
                        e.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                const i = t.parentNode.querySelectorAll(Sp).length,
                                    s = t.nextElementSibling;
                                i && (e.preventDefault(), s.dispatchEvent(new Event("click"), { bubbles: !0 }));
                            });
                        });
                }
                onUnload() {
                    document.documentElement.style.removeProperty("--header-height"),
                        document.documentElement.style.removeProperty("--header-sticky-height"),
                        this.initStickyHeader(),
                        document.body.classList.remove(...Op.jsDrawerOpenAll),
                        document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize", this.checkWidthEvent),
                        document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent),
                        document.body.removeEventListener("touchstart", this.handleTouchstartEvent),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                        "function" == typeof window.cart.unload && window.cart.unload();
                }
                constructor(t) {
                    (this.container = t),
                        (this.background = document.querySelector(Fp)),
                        (this.header = t),
                        (this.headerSection = t.parentNode),
                        (this.headerWrapper = t.querySelector(Hp)),
                        (this.logoTextLink = t.querySelector(wp)),
                        (this.nav = t.querySelector(qp)),
                        (this.navIcons = t.querySelector(Tp)),
                        (this.headerStateEvent = (t) => this.headerState(t)),
                        (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
                        (this.updateBackgroundHeightEvent = (t) => this.updateBackgroundHeight(t)),
                        p(),
                        (this.minWidth = this.getMinWidth()),
                        (this.checkWidthEvent = () => this.checkWidth()),
                        this.listenWidth(),
                        this.initMobileNav(),
                        this.handleTextLinkLogos(),
                        this.initStickyHeader(),
                        this.handleBackgroundEvents(),
                        document.querySelector(Mp) || (window.cart = new Zh()),
                        document.body.addEventListener("touchstart", this.handleTouchstartEvent, { passive: !0 }),
                        this.updateHeaderHover();
                }
            })(this.container);
        },
        onUnload() {
            _p[this.id].onUnload();
        },
    };
    I("header", [$p, fp, Or]);
    const Vp = "[data-collapsible-trigger]",
        Rp = "is-expanded";
    I("accordions", [
        {
            onBlockSelect(t) {
                const e = t.target.querySelector(Vp);
                requestAnimationFrame(() => {
                    e.classList.contains(Rp) || e.dispatchEvent(new Event("click"));
                });
            },
        },
        Xe,
    ]);
    const Np = "[data-share-button]",
        Wp = "[data-share-button-tooltip]",
        Up = "is-visible",
        jp = "is-hiding",
        Gp = {};
    const Kp = {
        onLoad() {
            Gp[this.id] = new (class {
                init() {
                    this.button &&
                        this.button.addEventListener("click", () => {
                            let t = window.location.href;
                            this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
                                this.tooltip.classList.contains(Up) ||
                                    navigator.clipboard.writeText(t).then(() => {
                                        this.tooltip.classList.add(Up),
                                            setTimeout(() => {
                                                this.tooltip.classList.add(jp),
                                                    this.tooltip.classList.remove(Up),
                                                    this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                                                    (this.hideTransitionTimeout = setTimeout(() => {
                                                        this.tooltip.classList.remove(jp);
                                                    }, this.transitionSpeed));
                                            }, 1500);
                                    });
                        });
                }
                constructor(t) {
                    (this.container = t), (this.button = this.container.querySelector(Np)), (this.tooltip = this.container.querySelector(Wp)), (this.transitionSpeed = 200), (this.hideTransitionTimeout = 0), this.init();
                }
            })(this.container);
        },
    };
    I("article", [Kp]);
    const Qp = "[data-video-play]",
        Yp = "data-video-play";
    const Xp = {
            onLoad() {
                new (class {
                    init() {
                        this.videoPlay.length &&
                            this.videoPlay.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.hasAttribute(Yp) && "" !== t.getAttribute(Yp).trim()) {
                                        e.preventDefault();
                                        const i = [{ html: t.getAttribute(Yp) }],
                                            s = { mainClass: "pswp--video" };
                                        (this.a11y.state.trigger = t), new Yc(i, s);
                                    }
                                });
                            });
                    }
                    constructor(t) {
                        (this.container = t), (this.videoPlay = this.container.querySelectorAll(Qp)), (this.a11y = ri), this.init();
                    }
                })(this.container);
            },
        },
        Jp = "[data-banner-image]",
        Zp = "[data-banner-title]",
        tm = ".lazy-image",
        em = '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        im = ".text-reveal__cropper",
        sm = "[data-aos]",
        om = "banner--no-cached-images",
        nm = "banner--img-loaded",
        rm = "img-in",
        am = "overflow-hidden",
        lm = "text-highlight-wrapper",
        cm = {};
    I("banner-image", [
        {
            onLoad() {
                cm[this.id] = new (class {
                    init() {
                        if ((this.handleImageAnimation(!0), this.container.matches(em) && (this.parallax = new Tu(this.container)), this.title && !this.title.classList.contains(lm))) {
                            const t = this.title.querySelector(sm);
                            if (!t) return;
                            const e = t.closest(im);
                            null == e || e.classList.add(am),
                                Ct(t).then(() => {
                                    null == e || e.classList.remove(am);
                                });
                        }
                    }
                    handleImageAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(om), void this.container.classList.remove(nm);
                        const e = this.container.querySelector(Jp).querySelectorAll(tm),
                            i = this.container.classList.contains(rm);
                        if (e.length && !i) {
                            this.container.classList.add(om);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add(nm)), e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    onReorder() {
                        this.handleImageAnimation(!1);
                    }
                    onUnload() {
                        this.handleImageAnimation(!1), this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container), (this.title = this.container.querySelector(Zp)), (this.parallax = null), this.init();
                    }
                })(this);
            },
            onReorder(t) {
                cm[this.id].onReorder(t);
            },
            onUnload(t) {
                cm[this.id].onUnload(t);
            },
        },
        Xp,
    ]);
    const hm = "[data-scroll-spy]",
        dm = "is-selected",
        um = "is-full-height",
        pm = "data-scroll-spy",
        mm = "data-scroll-spy-prevent",
        gm = "data-scroll-spy-mobile",
        fm = "data-scroll-spy-desktop",
        ym = {};
    const vm = {
            onLoad() {
                ym[this.id] = [];
                this.container.querySelectorAll(hm).forEach((t) => {
                    const e = this.container.querySelector(t.getAttribute(pm));
                    ym[this.id].push(
                        new (class {
                            init() {
                                this.onScroll(), document.addEventListener("theme:scroll", this.scrollCallback), document.addEventListener("theme:resize:width", this.scrollCallback);
                            }
                            isEligible() {
                                return !this.container.hasAttribute(mm) && ((we() && this.anchor.hasAttribute(gm)) || (be() && this.anchor.hasAttribute(fm)) || (!this.anchor.hasAttribute(fm) && !this.anchor.hasAttribute(gm)));
                            }
                            onScroll() {
                                if (!this.isEligible()) return;
                                (this.top = this.element.getBoundingClientRect().top), (this.bottom = this.element.getBoundingClientRect().bottom);
                                const t = Math.round(window.innerHeight),
                                    e = Math.round(window.scrollY),
                                    i = e + t,
                                    s = Math.round(this.top + e),
                                    o = this.element.offsetHeight;
                                if (!(s < i) || s + o < e) return;
                                this.anchor.parentNode.offsetHeight <= o ? this.container.style.setProperty("--sticky-position", window.innerHeight / 2 - o / 2 + "px") : this.container.classList.add(um),
                                    (this.anchorTop = this.anchor.getBoundingClientRect().top),
                                    (this.anchorBottom = this.anchor.getBoundingClientRect().bottom);
                                const n = this.top < this.anchorTop,
                                    r = this.bottom < this.anchorBottom;
                                n &&
                                    !r &&
                                    (this.anchors.forEach((t) => {
                                        t.matches(this.anchorSelector) || t.classList.remove(dm);
                                    }),
                                    this.anchor.classList.add(dm));
                            }
                            onUnload() {
                                document.removeEventListener("theme:scroll", this.scrollCallback), document.removeEventListener("theme:resize:width", this.scrollCallback);
                            }
                            constructor(t, e) {
                                (this.container = t),
                                    (this.element = e),
                                    this.element &&
                                        ((this.anchorSelector = `[${pm}="#${this.element.id}"]`),
                                        (this.anchor = this.container.querySelector(this.anchorSelector)),
                                        (this.anchors = this.container.querySelectorAll(`[${pm}]`)),
                                        this.anchor && ((this.scrollCallback = () => this.onScroll()), this.init()));
                            }
                        })(this.container, e)
                    );
                });
            },
            onUnload() {
                ym[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        bm = "[data-banner]",
        wm = "[data-slider-content]",
        Sm = "[data-slider-media]",
        Em = "a, button",
        Lm = "data-index",
        km = "tabindex",
        Am = "data-slider-single-image",
        Cm = "data-scroll-spy-prevent",
        qm = "is-selected",
        Tm = "row",
        Pm = "columns";
    let xm = {};
    I("banner-with-text-columns", [
        {
            onLoad() {
                xm[this.id] = new (class {
                    listen() {
                        document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.links.forEach((t) => {
                                t.addEventListener("focus", () => {
                                    const e = Number(t.closest(bm).getAttribute(Lm));
                                    window.innerWidth >= theme.sizes.small && this.sync(e);
                                });
                            }),
                            this.banners.forEach((t) => {
                                t.addEventListener("mouseenter", () => {
                                    const e = Number(t.getAttribute(Lm));
                                    window.innerWidth >= theme.sizes.small && !window.theme.touch && this.sync(e);
                                }),
                                    t.addEventListener("pointerup", () => {
                                        const e = Number(t.getAttribute(Lm));
                                        window.innerWidth >= theme.sizes.small && window.theme.touch && this.sync(e);
                                    });
                            });
                    }
                    handleColumnsLayout() {
                        if (this.sliderContent.children.length <= 1) return;
                        let t = window.innerWidth < window.theme.sizes.small;
                        this.sliderMedia.children.length > 1 &&
                            ((this.flktyMedia = new e(this.sliderMedia, {
                                draggable: !1,
                                wrapAround: !1,
                                fade: !0,
                                prevNextButtons: !1,
                                adaptiveHeight: !1,
                                pageDots: !1,
                                setGallerySize: !1,
                                on: {
                                    change: (t) => {
                                        this.handleGroupItemsNavigation(t, this.flktyContent);
                                    },
                                },
                            })),
                            xi(this.sliderMedia)),
                            (this.flktyContent = new e(this.sliderContent, {
                                draggable: t,
                                prevNextButtons: !1,
                                pageDots: !0,
                                cellAlign: "left",
                                adaptiveHeight: !1,
                                imagesLoaded: !0,
                                on: {
                                    ready: () => {
                                        this.listen(), this.slidesTabIndex();
                                    },
                                    change: (t) => {
                                        window.innerWidth < theme.sizes.small && !this.singleImageEnabled && this.flktyMedia.select(t), this.slidesTabIndex(), this.handleGroupItemsNavigation(t, this.flktyMedia);
                                    },
                                },
                            })),
                            xi(this.sliderContent);
                    }
                    handleRowLayout() {
                        if (this.sliderMedia.children.length <= 1 || we()) return this.updateState(0), void this.listen();
                        this.initMediaSlider();
                    }
                    initMediaSlider() {
                        (this.flktyMedia = new e(this.sliderMedia, {
                            draggable: !0,
                            wrapAround: !1,
                            fade: !0,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            setGallerySize: !1,
                            on: {
                                ready: () => {
                                    this.updateState(0), this.listen();
                                },
                                change: (t) => {
                                    this.updateState(t);
                                },
                            },
                        })),
                            xi(this.sliderMedia);
                    }
                    handleGroupItemsNavigation(t, e = null) {
                        null !== e &&
                            requestAnimationFrame(() => {
                                t !== e.selectedIndex && e.select(t);
                            });
                    }
                    slidesTabIndex() {
                        this.sliderContent &&
                            e.data(this.sliderContent).cells.forEach((t) => {
                                let e = "-1";
                                t.element.classList.contains(qm) && (e = "0"),
                                    t.element.querySelectorAll(Em).forEach((t) => {
                                        t.setAttribute(km, e);
                                    });
                            });
                    }
                    sync(t = 0) {
                        this.appearance === Pm ? this.flktyContent.selectCell(t) : this.updateState(t), this.flktyMedia && this.flktyMedia.selectCell(t);
                    }
                    updateState(t = 0) {
                        this.banners.forEach((e) => {
                            const i = Number(e.getAttribute(Lm));
                            e.classList.toggle(qm, i === t);
                        });
                    }
                    handleSlidersOnResize() {
                        if (this.appearance === Tm) {
                            if (we() && this.flktyMedia) return this.flktyMedia.destroy(), void (this.flktyMedia = null);
                            if (be() && !this.flktyMedia) return void this.initMediaSlider();
                        }
                        this.flktyContent && (this.flktyContent.resize(), this.toggleDraggable()), this.flktyMedia && this.flktyMedia.resize();
                    }
                    toggleDraggable() {
                        (this.flktyContent.options.draggable = window.innerWidth < window.theme.sizes.small), this.flktyContent.updateDraggable();
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        if ((this.sync(e), this.appearance === Tm)) {
                            const t = this.sliderMedia.children[e],
                                i = Math.round(t.getBoundingClientRect().top);
                            this.container.setAttribute(Cm, ""), setTimeout(() => _r(i), 400), setTimeout(() => this.container.removeAttribute(Cm), 1e3);
                        }
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    constructor(t) {
                        var e;
                        (this.container = t.container),
                            (this.sliderContent = this.container.querySelector(wm)),
                            (this.singleImageEnabled = null === (e = this.sliderContent) || void 0 === e ? void 0 : e.hasAttribute(Am)),
                            (this.banners = this.container.querySelectorAll(bm)),
                            (this.links = this.container.querySelectorAll("a")),
                            (this.sliderMedia = this.container.querySelector(Sm)),
                            (this.flktyContent = null),
                            (this.flktyMedia = null),
                            (this.onResizeCallback = () => this.handleSlidersOnResize()),
                            (this.appearance = this.container.dataset.appearance),
                            this.appearance === Pm ? this.handleColumnsLayout() : this.handleRowLayout();
                    }
                })(this);
            },
            onBlockSelect(t) {
                xm[this.id].onBlockSelect(t);
            },
        },
        vm,
    ]),
        I("blog-posts", Oo);
    const Im = "[data-slider]",
        Hm = "[data-slider-item]",
        Fm = "[data-media-container]",
        Mm = "a, button",
        Dm = ".flickity-button",
        Om = "carousel--inactive",
        Bm = "carousel--resize",
        zm = "tabindex",
        _m = {};
    const $m = {
        onLoad() {
            _m[this.id] = new (class {
                initSlider() {
                    this.slider.classList.remove(Om),
                        (this.flkty = new e(this.slider, {
                            pageDots: !1,
                            cellAlign: "left",
                            groupCells: !0,
                            contain: !0,
                            on: {
                                ready: () => {
                                    this.setSliderArrowsPosition(this.slider),
                                        setTimeout(() => {
                                            this.changeTabIndex(), this.flkty.resize();
                                        }, 0);
                                },
                                change: () => {
                                    this.changeTabIndex();
                                },
                            },
                        })),
                        (e.prototype._createResizeClass = function () {
                            this.element.classList.add(Bm);
                        }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(Bm), t.call(this), this.element.classList.add(Bm);
                    };
                }
                destroySlider() {
                    this.slider.classList.add(Om), null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(Hm).currentStyle || window.getComputedStyle(this.container.querySelector(Hm));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                changeTabIndex() {
                    const t = this.flkty.selectedIndex;
                    this.flkty.slides.forEach((e, i) => {
                        e.cells.forEach((e) => {
                            e.element.querySelectorAll(Mm).forEach((e) => {
                                e.setAttribute(zm, t === i ? "0" : "-1");
                            });
                        });
                    });
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Hm);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize));
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(Dm),
                        i = t.querySelector(Fm);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(Im)), (this.flkty = null), (this.gutter = 0), (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()), this.listen();
                }
            })(this);
        },
        onUnload(t) {
            _m[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            _m[this.id].onBlockSelect(t);
        },
    };
    I("columns-with-image", [$m, Xp]);
    const Vm = "[data-form-message-close]",
        Rm = "[data-form-message]",
        Nm = "hide-down",
        Wm = "notification-visible";
    let Um = {};
    I("contact-form", {
        onLoad() {
            Um[this.id] = new (class {
                hidePopups() {
                    document.body.classList.add(Wm);
                }
                showPopups() {
                    document.body.classList.remove(Wm);
                }
                closeFormMessage() {
                    this.closeButton.addEventListener("click", this.closeMessage.bind(this));
                }
                closeMessage(t) {
                    t.preventDefault(), this.messageWrapper.classList.add(Nm), this.showPopups();
                }
                autoHideMessage() {
                    setTimeout(() => {
                        this.messageWrapper.classList.add(Nm), this.showPopups();
                    }, 1e4);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.closeButton = this.container.querySelector(Vm)),
                        (this.messageWrapper = this.container.querySelector(Rm)),
                        this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
                }
            })(this);
        },
    });
    const jm = "time",
        Gm = "[data-days]",
        Km = "[data-hours]",
        Qm = "[data-minutes]",
        Ym = "[data-seconds]",
        Xm = "[data-section-type]",
        Jm = ".shopify-section",
        Zm = "[data-aos]",
        tg = "countdown-timer--show-message",
        eg = "aos-animate",
        ig = "countdown",
        sg = "data-expiration-behavior",
        og = "data-leading-zero",
        ng = "hide",
        rg = "show-message";
    let ag = class extends HTMLElement {
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        init() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.section.classList.contains(ig) && this.onLoad(!0), (this.interval = setInterval(this.update, 1e3)));
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= s * this.minutesInMs;
            return { days: e, hours: i, minutes: s, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }
        formatDigits(t) {
            return t < 10 && this.leadingZero && (t = "0" + t), t;
        }
        render(t) {
            (this.days.textContent = t.days), (this.hours.textContent = t.hours), (this.minutes.textContent = t.minutes), (this.seconds.textContent = t.seconds);
        }
        onComplete() {
            this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                this.shouldHideOnComplete && !window.Shopify.designMode && (this.shopifySection.remove(), document.dispatchEvent(new CustomEvent("theme:parallax:refresh"))),
                this.shouldShowMessage && this.classList.add(tg);
        }
        triggerAnimations() {
            "false" != theme.settings.animations &&
                this.section.querySelectorAll(Zm).forEach((t) => {
                    this.isAnimated && t.classList.add(eg);
                });
        }
        removeAnimations() {
            this.section.querySelectorAll(Zm).forEach((t) => {
                requestAnimationFrame(() => {
                    t.classList.contains(eg) && (t.classList.remove(eg), (this.isAnimated = !0));
                });
            });
        }
        onLoad(t) {
            t ? this.removeAnimations() : ((this.isLoading = !1), this.triggerAnimations());
        }
        update() {
            const t = Date.now(),
                e = this.endDate - t;
            if (e <= 0) return this.stopTimer(), void this.onComplete();
            const i = this.convertTime(e);
            this.render(i), this.isLoading && this.onLoad(!1);
        }
        constructor() {
            super(),
                (this.section = this.closest(Xm)),
                (this.shopifySection = this.closest(Jm)),
                (this.expirationBehavior = this.getAttribute(sg)),
                (this.leadingZero = this.hasAttribute(og)),
                (this.time = this.querySelector(jm)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.days = this.querySelector(Gm)),
                (this.hours = this.querySelector(Km)),
                (this.minutes = this.querySelector(Qm)),
                (this.seconds = this.querySelector(Ym)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.isLoading = !0),
                (this.shouldHideOnComplete = this.expirationBehavior === ng),
                (this.shouldShowMessage = this.expirationBehavior === rg),
                (this.isAnimated = !1),
                (this.update = this.update.bind(this));
        }
    };
    I("countdown", [Xp, Pu]), customElements.get("countdown-timer") || customElements.define("countdown-timer", ag);
    const lg = "[data-video-id]",
        cg = "[data-video-player]",
        hg = "[data-video-template]",
        dg = "[data-video-autoplay]",
        ug = "[data-video-wrapper]",
        pg = "[data-video-bg-play]",
        mg = "is-loading",
        gg = "is-paused",
        fg = {};
    const yg = {
        onLoad() {
            fg[this.id] = [];
            this.container.querySelectorAll(ug).forEach((t) => {
                fg[this.id].push(
                    new (class {
                        init() {
                            this.videoId &&
                                (new IntersectionObserver(
                                    (t, e) => {
                                        t.forEach((t) => {
                                            if (t.isIntersecting) {
                                                const i = this.videoTemplate.innerHTML;
                                                (this.videoPlayer.innerHTML = i),
                                                    (this.video = this.container.querySelector(dg)),
                                                    this.videoPlayer.classList.remove(mg),
                                                    this.container.classList.add(gg),
                                                    this.listen(),
                                                    e.unobserve(t.target);
                                            }
                                        });
                                    },
                                    { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                                ).observe(this.videoPlayer),
                                this.videoPlayButton.addEventListener("click", (t) => {
                                    var e;
                                    t.preventDefault(), null === (e = this.video) || void 0 === e || e.play();
                                }));
                        }
                        listen() {
                            this.video.addEventListener("play", () => {
                                this.container.classList.remove(gg);
                            }),
                                this.container.addEventListener(
                                    "touchstart",
                                    () => {
                                        this.video.play();
                                    },
                                    { passive: !0 }
                                );
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.videoId = this.container.querySelector(lg)),
                                (this.videoPlayer = this.container.querySelector(cg)),
                                (this.videoTemplate = this.container.querySelector(hg)),
                                (this.videoPlayButton = this.container.querySelector(pg)),
                                this.init();
                        }
                    })(t)
                );
            });
        },
    };
    let vg = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        constructor(t, e) {
            (this.configuration = { expires: null, path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = t), (this.value = e);
        }
    };
    const bg = "[data-newsletter-form]",
        wg = "[data-popup]",
        Sg = "section",
        Eg = "footer",
        Lg = ".shopify-section",
        kg = "has-success",
        Ag = "has-error",
        Cg = "section-footer--parallax",
        qg = "newsletter_form_id",
        Tg = {};
    const Pg = {
            onLoad() {
                Tg[this.id] = [];
                this.container.querySelectorAll(bg).forEach((t) => {
                    Tg[this.id].push(
                        new (class {
                            init() {
                                this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                            }
                            newsletterSubmitEvent(t) {
                                this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                            }
                            checkForChallengePage() {
                                this.isChallengePage = window.location.pathname === theme.routes.root + "challenge";
                            }
                            writeStorage() {
                                void 0 !== this.sessionStorage && this.sessionStorage.setItem(qg, this.newsletter.id);
                            }
                            readStorage() {
                                this.formID = this.sessionStorage.getItem(qg);
                            }
                            removeStorage() {
                                this.sessionStorage.removeItem(qg);
                            }
                            showMessage() {
                                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                    const t = document.getElementById(this.formID),
                                        e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                        i = -1 !== window.location.search.indexOf("accepts_marketing");
                                    e
                                        ? (t.classList.remove(Ag), t.classList.add(kg), this.popup && ((this.cookie = new vg(this.popup.dataset.cookieName, "user_has_closed")), this.cookie.write()))
                                        : i && (t.classList.remove(kg), t.classList.add(Ag)),
                                        (e || i) && this.scrollToForm(t);
                                }
                            }
                            scrollToForm(t) {
                                let { stickyHeaderHeight: e } = N();
                                const i = e || 0,
                                    s = t.closest(Sg),
                                    o = t.closest(Eg);
                                visibilityHelper.isElementPartiallyVisible(t) ||
                                    visibilityHelper.isElementTotallyVisible(t) ||
                                    setTimeout(() => {
                                        let e = window.scrollY,
                                            n = t.getBoundingClientRect().top;
                                        s ? (n = s.getBoundingClientRect().top) : o && o.closest(Lg).classList.contains(Cg) && ((n = document.body.scrollHeight), (e = 0));
                                        const r = n - i + e;
                                        window.scrollTo({ top: r, left: 0, behavior: "smooth" });
                                    }, 400);
                            }
                            onUnload() {
                                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                            }
                            constructor(t) {
                                (this.newsletter = t),
                                    (this.sessionStorage = window.sessionStorage),
                                    (this.popup = this.newsletter.closest(wg)),
                                    (this.stopSubmit = !0),
                                    (this.isChallengePage = !1),
                                    (this.formID = null),
                                    (this.formIdSuccess = null),
                                    this.checkForChallengePage(),
                                    (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                    this.isChallengePage || this.init();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                Tg[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        xg = "[data-product]",
        Ig = "[data-slider]",
        Hg = "[data-slide]",
        Fg = "[data-product-media-container]",
        Mg = ".flickity-button",
        Dg = "a, button",
        Og = "tabindex",
        Bg = {};
    const zg = {
        onLoad() {
            Bg[this.id] = new (class {
                checkSlider() {
                    window.innerWidth >= theme.sizes.small
                        ? this.productSlider.forEach((t) => {
                              this.initProductSlider(t);
                          })
                        : this.productSlider.forEach((t) => {
                              this.destroyProductSlider(t);
                          });
                }
                initProductSlider(t) {
                    const i = t.querySelectorAll(Hg).length,
                        s = t.dataset.slider;
                    i > 1 &&
                        (void 0 !== this.flkty[s] && this.flkty[s].isActive
                            ? this.setSliderArrowsPosition(t)
                            : (this.flkty[s] = new e(t, {
                                  prevNextButtons: !0,
                                  adaptiveHeight: !0,
                                  pageDots: !0,
                                  wrapAround: !0,
                                  on: {
                                      ready: () => {
                                          this.setSliderArrowsPosition(t);
                                      },
                                      change: (t) => {
                                          this.flkty[s].cells.forEach((e, i) => {
                                              e.element.querySelectorAll(Dg).forEach((e) => {
                                                  e.setAttribute(Og, i === t ? "0" : "-1");
                                              });
                                          });
                                      },
                                  },
                              })));
                }
                destroyProductSlider(t) {
                    const e = t.dataset.slider;
                    "object" == typeof this.flkty[e] && this.flkty[e].destroy();
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(Mg),
                        i = t.querySelector(Fg);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                listen() {
                    this.checkSlider(),
                        document.addEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                onUnload() {
                    if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                    document.removeEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                constructor(t) {
                    (this.container = t),
                        (this.product = this.container.querySelectorAll(xg)),
                        (this.productSlider = this.container.querySelectorAll(Ig)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.flkty = []),
                        (this.videoObj = []),
                        (this.quickViewObj = []),
                        this.listen();
                }
            })(this.container);
        },
        onUnload(t) {
            Bg[this.id].onUnload(t);
        },
    };
    I("custom-content", [zg, Pg, Xp, ds, yg, vo]);
    const _g = "[data-slider]",
        $g = "[data-slide]",
        Vg = "[data-product-media-container]",
        Rg = "a, button",
        Ng = ".flickity-button",
        Wg = "[data-promo]",
        Ug = "[data-product-block]",
        jg = "carousel",
        Gg = "carousel--inactive",
        Kg = "is-last-slide-visible",
        Qg = "featured-collection",
        Yg = "collection-promo--full",
        Xg = "collection-promo--two-columns",
        Jg = "data-slider-id",
        Zg = "data-slider-show-image",
        tf = "tabindex",
        ef = {};
    let sf = class {
        initSlider(t) {
            const i = t.getAttribute(Jg);
            t.classList.remove(Gg),
                void 0 !== this.flkty[i] && this.flkty[i].isActive
                    ? this.setSliderArrowsPosition(t)
                    : ((this.flkty[i] = new e(t, {
                          pageDots: !1,
                          cellSelector: $g,
                          cellAlign: "left",
                          groupCells: !0,
                          contain: !0,
                          wrapAround: !1,
                          adaptiveHeight: !1,
                          on: {
                              ready: () => {
                                  this.setSliderArrowsPosition(t),
                                      setTimeout(() => {
                                          this.changeTabIndex(t);
                                      }, 0);
                              },
                              change: () => {
                                  this.changeTabIndex(t);
                              },
                          },
                      })),
                      this.handleLastSlideOverlayOnTablet(t));
        }
        destroySlider(t) {
            const e = t.getAttribute(Jg);
            t.classList.contains(jg) && t.classList.add(Gg), "object" == typeof this.flkty[e] && this.flkty[e].destroy();
        }
        resetSlider(t) {
            const e = t.target,
                i = e.getAttribute(Jg);
            "object" == typeof this.flkty[i] ? this.flkty[i].select(0, !1, !0) : e.scrollTo({ left: 0, behavior: "instant" });
        }
        resizeSlider(t) {
            const i = t.target,
                s = e.data(i) || null;
            s && s.resize();
        }
        checkSlidesSize() {
            this.sliders.length &&
                this.sliders.forEach((t) => {
                    const e = this.columns,
                        i = window.innerWidth >= theme.sizes.large,
                        s = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
                    let o = t.querySelectorAll($g).length;
                    const n = t.querySelectorAll(Wg);
                    n.length &&
                        i &&
                        n.forEach((t) => {
                            t.classList.contains(Yg) ? (o += e - 1) : t.classList.contains(Xg) && (o += 1);
                        }),
                        t.hasAttribute(Zg) && (o += 1),
                        (i && o > e) || (s && o > 2) ? (this.initSlider(t), this.getTallestProductGridItem(t)) : this.destroySlider(t);
                });
        }
        changeTabIndex(t) {
            const e = t.getAttribute(Jg),
                i = this.flkty[e].selectedIndex;
            this.flkty[e].slides.forEach((t, e) => {
                t.cells.forEach((t) => {
                    t.element.querySelectorAll(Rg).forEach((t) => {
                        t.setAttribute(tf, i === e ? "0" : "-1");
                    });
                });
            });
        }
        setSliderArrowsPosition(t) {
            const e = t.querySelectorAll(Ng),
                i = t.querySelector(Vg);
            e.length &&
                i &&
                e.forEach((t) => {
                    t.style.top = i.offsetHeight / 2 + "px";
                });
        }
        handleLastSlideOverlayOnTablet(t) {
            const e = t.getAttribute(Jg);
            this.flkty[e].on("select", () => {
                if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
                const i = this.flkty[e].selectedIndex,
                    s = this.flkty[e].slides.length - 1 === i;
                t.parentNode.classList.toggle(Kg, s);
            });
        }
        getTallestProductGridItem(t) {
            if (t.querySelectorAll(Wg).length) {
                const e = t.querySelectorAll(Ug),
                    i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
                t.style.setProperty("--carousel-promo-height", `${i}px`);
            }
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach((t) => {
                t.addEventListener("scroll", (e) => {
                    if (!(window.innerWidth < theme.sizes.small)) return;
                    const i = e.target.offsetWidth,
                        s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
                    t.parentNode.classList.toggle(Kg, s);
                });
            });
        }
        listen() {
            this.sliders.length &&
                (this.checkSlidesSize(),
                document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.forEach((t) => {
                    t.addEventListener("theme:tab:change", this.resetSliderEvent), t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                }));
        }
        onBlockSelect(t) {
            const i = t.target.closest(_g),
                s = e.data(i) || null;
            if (!i) return;
            let o = t.target.parentNode,
                n = t.target;
            if ((this.container.classList.contains(Qg) && ((o = o.parentNode), (n = n.parentNode)), null !== s && s.isActive)) {
                const t = parseInt([...o.children].indexOf(n)),
                    e = parseInt(s.slides[0].cells.length),
                    i = Math.floor(t / e);
                s.select(i);
            } else {
                const t = i.currentStyle || window.getComputedStyle(i),
                    e = parseInt(t.paddingLeft),
                    s = n.offsetLeft - e;
                i.scrollTo({ top: 0, left: s, behavior: "smooth" });
            }
        }
        onUnload() {
            if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
            document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.length &&
                    this.sliders.forEach((t) => {
                        t.removeEventListener("theme:tab:change", this.resetSliderEvent), t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                    });
        }
        constructor(t) {
            (this.container = t),
                (this.columns = parseInt(this.container.dataset.columns)),
                (this.sliders = this.container.querySelectorAll(_g)),
                (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                (this.resetSliderEvent = (t) => this.resetSlider(t)),
                (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                (this.flkty = []),
                this.listen(),
                this.handleLastSlideOverlayOnMobile();
        }
    };
    const of = {
        onLoad() {
            ef[this.id] = [];
            this.container.querySelectorAll(_g).forEach((t) => {
                ef[this.id].push(new sf(this.container));
            });
        },
        onUnload() {
            ef[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            ef[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
    };
    I("featured-collection", [vo, ds, of]), I("featured-video", [Xp, yg]);
    const nf = "[data-shop-pay-wrapper]",
        rf = "shop-login-button",
        af = "shop-follow-button",
        lf = "follow-on-shop-button",
        cf = "heart-icon",
        hf = "shop-logo",
        df = {};
    const uf = {
            onLoad() {
                df[this.id] = new (class {
                    init() {
                        if (!this.shopLoginButton || !this.shopPayWrapper) return;
                        const t = this.shopPayWrapper.dataset.bg || "transparent",
                            e = this.shopPayWrapper.dataset.text || "#fff",
                            i = this.shopPayWrapper.dataset.hover || "#fff";
                        (this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
                            (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
                            customElements.whenDefined(rf).then((t) => {
                                requestAnimationFrame(() => {
                                    const t = this.shopLoginButton.shadowRoot,
                                        e = null == t ? void 0 : t.querySelector(af),
                                        i = null == e ? void 0 : e.shadowRoot,
                                        s = null == i ? void 0 : i.querySelector(lf),
                                        o = null == s ? void 0 : s.shadowRoot;
                                    o && this.overwriteStyles(o.host.shadowRoot, this.mainButtonStyles);
                                    const n = o.querySelector(cf),
                                        r = null == n ? void 0 : n.shadowRoot,
                                        a = o.querySelector(hf),
                                        l = null == a ? void 0 : a.shadowRoot;
                                    r && this.overwriteStyles(r.host.shadowRoot, this.svgIconsStyles), l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
                                });
                            });
                    }
                    overwriteStyles(t, e) {
                        let i = document.createElement("style");
                        (i.innerHTML = e), t.appendChild(i);
                    }
                    constructor(t) {
                        (this.container = t), (this.shopPayWrapper = document.querySelector(nf)), (this.shopLoginButton = document.querySelector(rf)), this.init();
                    }
                })(this.container);
            },
        },
        pf = ":scope > [data-wave]",
        mf = "[data-main]",
        gf = "[data-collapsible-trigger-mobile]",
        ff = '[data-parallax="footer"]',
        yf = "is-expanded",
        vf = "wavy",
        bf = "parallax-shadow",
        wf = "parallax-rounded-corners",
        Sf = "main-content--parallax",
        Ef = "section-footer--parallax",
        Lf = "section-footer--visible",
        kf = "main-content",
        Af = "shopify-section",
        Cf = "body--rounded-corners-large",
        qf = "--bg",
        Tf = "--footer-bg",
        Pf = "data-parallax",
        xf = "data-parallax-wavy",
        If = "data-parallax-rounded-corners",
        Hf = "data-parallax-rounded-corners-large",
        Ff = "data-parallax-disable-on-safari",
        Mf = {};
    I("footer", [
        Nl,
        Pg,
        Xe,
        {
            onLoad() {
                Mf[this.id] = new (class {
                    init() {
                        const t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && this.container.hasAttribute(Ff),
                            e = this.isViewportSmaller() || window.innerWidth < theme.sizes.small || t,
                            i = document.body;
                        i.classList.remove(Cf);
                        const s = getComputedStyle(this.container).getPropertyValue(qf);
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto");
                        let o = this.parentContainer.previousElementSibling;
                        if (o) {
                            if ((o.classList.contains(Af) || o.classList.contains(kf) || (o = this.main), this.wavyEnabled && !e)) {
                                [...o.querySelectorAll(pf)].map((t) => t.remove());
                                const t = this.container.querySelector(pf);
                                o.append(t.cloneNode(!0)), o.classList.add(vf), this.container.classList.remove(vf);
                            } else this.container.hasAttribute(If) && !this.wavyEnabled ? (o.classList.toggle(wf, !e), o.classList.toggle(bf, !e), this.container.hasAttribute(Hf) && i.classList.toggle(Cf, !e)) : e || o.classList.add(bf);
                            o.style.setProperty(Tf, s);
                        }
                        e ||
                            (this.main.classList.add(Sf),
                            this.parentContainer.classList.add(Ef),
                            this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`),
                            (this.footerParallax = new Tu(this.container)));
                    }
                    resize() {
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto"),
                            (this.isViewportSmaller() || window.innerWidth < theme.sizes.small || !this.footerParallax) && this.onUnload(!0),
                            this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`);
                    }
                    isViewportSmaller() {
                        const t = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                            e = this.container.clientHeight;
                        let i = 0;
                        return this.wavyEnabled && (i = 50), t < e + i;
                    }
                    onBlockSelect(t) {
                        const e = t.target.querySelector(gf);
                        requestAnimationFrame(() => {
                            e && !e.classList.contains(yf) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onBlockDeselect(t) {
                        const e = t.target.querySelector(gf);
                        requestAnimationFrame(() => {
                            e && e.classList.contains(yf) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onUnload(t = !1) {
                        document.removeEventListener("theme:resize", this.resizeEvent),
                            document.removeEventListener("theme:footer:unload", this.unloadEvent),
                            this.footerParallax && (this.footerParallax.unload(), t && A(this.parentContainer)),
                            (this.footerParallax || t) &&
                                setTimeout(() => {
                                    const t = Shopify.theme.sections.instances,
                                        e = document.querySelectorAll(ff),
                                        i = t.filter((t) => t.container === e[0]);
                                    this.main.classList.remove(Sf), this.parentContainer.classList.remove(Ef), this.parentContainer.classList.remove(Lf), i[0] && i[0].onLoad();
                                });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.main = document.querySelector(mf)),
                            (this.footerParallax = null),
                            (this.wavyEnabled = this.container.hasAttribute(xf)),
                            (this.parentContainer = this.container.parentNode),
                            (this.resizeEvent = () => this.resize()),
                            (this.unloadEvent = () => this.onUnload()),
                            requestIdleCallback(() => {
                                this.container.hasAttribute(Pf) &&
                                    !this.main.classList.contains(Sf) &&
                                    (this.init(), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:footer:unload", this.unloadEvent));
                            });
                    }
                })(this);
            },
            onBlockSelect(t) {
                Mf[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                Mf[this.id].onBlockDeselect(t);
            },
            onReorder() {
                Mf[this.id].onUnload();
            },
            onUnload() {
                Mf[this.id].onUnload();
            },
        },
        uf,
    ]);
    const Df = "[data-slider]";
    let Of = {};
    I("icons-row", {
        onLoad() {
            Of[this.id] = new (class {
                onBlockSelect(t) {
                    const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(Df));
                }
            })(this);
        },
        onBlockSelect(t) {
            Of[this.id].onBlockSelect(t);
        },
    });
    const Bf = "[data-accordion-item]",
        zf = "[data-accordion-button]",
        _f = "is-active",
        $f = "to-animate",
        Vf = "is-animating",
        Rf = {};
    I("image-accordions", {
        onLoad() {
            Rf[this.id] = new (class {
                init() {
                    this.triggerLoadingAnimation(),
                        this.imageAccordionsItems.forEach((t) => {
                            t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t));
                        }),
                        this.buttons.forEach((t) => {
                            t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
                        });
                }
                triggerLoadingAnimation() {
                    if ("false" == theme.settings.animationsEnabled || we()) return;
                    const t = (e) => {
                            "expandAccordion" === e.animationName &&
                                (this.accordionExpand(this.imageAccordionsItems[0]), this.container.classList.remove($f), this.container.classList.remove(Vf), this.container.removeEventListener("animationend", t));
                        },
                        e = (t) => {
                            requestAnimationFrame(() => {
                                t.target === this.container && (this.container.classList.add(Vf), this.container.removeEventListener("transitionend", e));
                            });
                        };
                    this.container.addEventListener("transitionend", e, { signal: this.controller.signal }), this.container.addEventListener("animationend", t, { signal: this.controller.signal });
                }
                accordionExpand(t) {
                    t.classList.contains(_f) ||
                        (this.imageAccordionsItems.forEach((t) => {
                            t.classList.remove(_f);
                        }),
                        t.classList.add(_f));
                }
                accordionFocus(t) {
                    t.closest(Bf).dispatchEvent(new Event("mouseenter"));
                }
                onBlockSelect(t) {
                    const e = t.target;
                    e && (this.controller.abort(), this.container.classList.remove($f, Vf), this.accordionExpand(e), we() && e.parentNode.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" }));
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.controller = new AbortController()),
                        (this.imageAccordionsItems = this.container.querySelectorAll(Bf)),
                        (this.buttons = this.container.querySelectorAll(zf)),
                        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
                        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
                        this.init();
                }
            })(this);
        },
        onBlockSelect(t) {
            Rf[this.id].onBlockSelect(t);
        },
    }),
        I("image-with-text", Xp),
        I("list-collections", of);
    const Nf = {},
        Wf = "[data-slider-gallery]",
        Uf = "[data-slider-info]",
        jf = "[data-slide-item]";
    I("locations", {
        onLoad() {
            Nf[this.id] = new (class {
                initSlider() {
                    const t = this.container.querySelectorAll(jf).length;
                    (this.flkty = e.data(this.slider)),
                        (this.flktyNav = e.data(this.sliderNav)),
                        t <= 1 ||
                            ((this.flkty = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !0, prevNextButtons: !1, pageDots: !1 })),
                            xi(this.slider),
                            (this.flktyNav = new e(this.sliderNav, { fade: !0, wrapAround: !0, imagesLoaded: !0, asNavFor: this.slider, prevNextButtons: !0, pageDots: !1 })),
                            this.enableAdaptiveHeight(),
                            document.addEventListener("theme:resize", this.resizeEvent),
                            this.flktyNav.on("change", () => {
                                if ((this.flkty.selectCell(this.flktyNav.selectedIndex), we())) {
                                    let { stickyHeaderHeight: t } = N();
                                    const e = t || 0,
                                        i = Math.round(window.scrollY),
                                        s = Math.round(this.container.getBoundingClientRect().top + i - e);
                                    window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                                }
                            }),
                            this.flkty.on("change", () => {
                                this.flktyNav.selectCell(this.flkty.selectedIndex);
                            }));
                }
                enableAdaptiveHeight() {
                    (this.flktyNav.options.adaptiveHeight = !1), we() && (this.flktyNav.options.adaptiveHeight = !0), this.flktyNav.resize();
                }
                onBlockSelect(t) {
                    const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== this.flkty && this.flkty.select(e), null !== this.flktyNav && this.flktyNav.select(e);
                }
                onUnload() {
                    document.removeEventListener("theme:resize", this.resizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(Wf)),
                        (this.sliderNav = this.container.querySelector(Uf)),
                        (this.flkty = null),
                        (this.flktyNav = null),
                        (this.resizeEvent = () => this.enableAdaptiveHeight()),
                        this.initSlider();
                }
            })(this);
        },
        onBlockSelect(t) {
            Nf[this.id].onBlockSelect(t);
        },
        onUnload() {
            Nf[this.id].onUnload();
        },
    });
    const Gf = {},
        Kf = "[data-slider]",
        Qf = "[data-slide-item]",
        Yf = "[data-stl-hotspots-item]",
        Xf = "[data-pointer]",
        Jf = "[data-pointer-bubble]",
        Zf = "[data-product-media-container]",
        ty = "[data-quick-view-item-holder]",
        ey = ".flickity-button",
        iy = "a, button",
        sy = "[data-tooltip]",
        oy = "data-products",
        ny = "data-pointer",
        ry = "data-hotspot",
        ay = "tabindex",
        ly = "product-grid-item__image--hovered",
        cy = "is-selected",
        hy = "is-active",
        dy = "on-hover",
        uy = "pswp--open";
    const py = {
        onLoad() {
            Gf[this.id] = new (class {
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.slider.addEventListener("theme:slider:resize", this.resizeSliderEvent)),
                        this.pointers.forEach((t) => {
                            t.addEventListener("click", this.pointersInit), t.addEventListener("mouseover", this.pointersOver), t.addEventListener("mouseleave", this.pointersOut);
                        }),
                        this.pointerBubbles.forEach((t, e) => {
                            t.addEventListener("click", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type))),
                                t.addEventListener("mouseover", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type))),
                                t.addEventListener("mouseleave", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type)));
                        });
                }
                checkSlidesSize() {
                    const t = window.innerWidth < theme.sizes.small,
                        e = window.innerWidth >= theme.sizes.large,
                        i = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large,
                        s = Boolean(e && this.slides.length > this.productOnRow),
                        o = Boolean(i && this.slides.length > 2);
                    this.initTooltips(), t ? this.destroySlider() : s || o ? this.initSlider() : (this.destroySlider(), this.slidesTabIndex());
                }
                initTooltips() {
                    (this.tooltips = this.container.querySelectorAll(sy)),
                        this.tooltips.forEach((t) => {
                            new hs(t);
                        });
                }
                initSlider() {
                    null !== this.flkty
                        ? this.setSliderArrowsPosition()
                        : (this.flkty = new e(this.slider, {
                              prevNextButtons: !0,
                              wrapAround: !0,
                              adaptiveHeight: !1,
                              cellAlign: "left",
                              groupCells: !1,
                              contain: !0,
                              on: {
                                  ready: () => {
                                      this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers();
                                  },
                                  change: () => {
                                      this.slidesTabIndex(), this.dotPointers();
                                  },
                              },
                          }));
                }
                setSliderArrowsPosition() {
                    if (!(window.innerWidth >= theme.sizes.small)) return;
                    const t = this.slider.querySelectorAll(ey),
                        e = this.slider.querySelector(Zf);
                    t.length &&
                        e &&
                        t.forEach((t) => {
                            t.style.top = e.offsetHeight / 2 + "px";
                        });
                }
                slidesTabIndex() {
                    this.slides.length < this.productOnRow + 1
                        ? this.slider.querySelectorAll(iy).forEach((t) => {
                              t.setAttribute(ay, "0");
                          })
                        : e.data(this.slider).cells.forEach((t) => {
                              let e = "-1";
                              t.element.classList.contains(cy) && (e = "0"),
                                  t.element.querySelectorAll(iy).forEach((t) => {
                                      t.setAttribute(ay, e);
                                  });
                          });
                }
                destroySlider() {
                    "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                dotPointers(t) {
                    if (0 === this.pointers.length) return;
                    if ((this.sTLHotspotsItems.forEach((t) => t.classList.remove(dy)), t)) {
                        var e;
                        const i = t.target.getAttribute(ny);
                        return void (null === (e = this.flkty) || void 0 === e || e.select(i));
                    }
                    const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
                    i >= 0 && this.sTLHotspotsItems[i].classList.add(dy);
                }
                dotPointerIn(t) {
                    const e = t.target.getAttribute(ny),
                        i = this.slides[e].querySelector(Zf),
                        s = matchMedia("(pointer:coarse)").matches;
                    window.innerWidth < theme.sizes.small || s || this.observeImage(i), this.pointers[e].style.setProperty("--target-animation", "none");
                }
                dotPointerOut(t) {
                    const e = t.target.getAttribute(ny),
                        i = this.slides[e].querySelector(Zf);
                    i.classList.remove(ly),
                        i.dispatchEvent(new Event("mouseleave")),
                        this.observer && this.observer.disconnect(),
                        this.pointers.forEach((t) => {
                            t.style.removeProperty("--target-animation");
                        });
                }
                observeImage(t) {
                    (this.observer = new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                const e = t.target;
                                0 == t.intersectionRatio || (e.dispatchEvent(new Event("mouseenter")), e.classList.add(ly));
                            });
                        },
                        { root: this.slider, threshold: [0.95, 1] }
                    )),
                        this.observer.observe(t);
                }
                triggerClick(t) {
                    requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
                }
                destroyQuickViewPopup() {
                    var t, e;
                    const i = null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement;
                    i && i.classList.contains(uy) && this.quickViewPopup.loadPhotoswipe.popup.close();
                }
                onBlockSelect(t) {
                    this.debouncedBlockSelectCallback(t);
                }
                debouncedBlockSelect(t) {
                    var e, i;
                    const s = null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i ? void 0 : i.pswpElement;
                    s
                        ? setTimeout(() => {
                              if (s.classList.contains(uy)) {
                                  const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${ry}="${t.target.getAttribute(ry)}"]`),
                                      i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(ty);
                                  e.classList.add(hy),
                                      i.forEach((t) => {
                                          t !== e && t.classList.remove(hy);
                                      });
                              } else this.triggerClick(t.target);
                          })
                        : setTimeout(() => this.triggerClick(t.target), 400);
                }
                onUnload() {
                    this.destroyQuickViewPopup(), document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.slider && this.slider.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                }
                onDeselect() {
                    this.destroyQuickViewPopup();
                }
                constructor(t) {
                    var e;
                    (this.container = t),
                        (this.slider = this.container.querySelector(Kf)),
                        (this.productOnRow = Number(null === (e = this.slider) || void 0 === e ? void 0 : e.getAttribute(oy)) || 3),
                        (this.slides = this.container.querySelectorAll(Qf)),
                        (this.sTLHotspotsItems = this.container.querySelectorAll(Yf)),
                        (this.pointers = this.container.querySelectorAll(Xf)),
                        (this.pointerBubbles = this.container.querySelectorAll(Jf)),
                        (this.flkty = null),
                        (this.observer = null),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.pointersInit = (t) => this.dotPointers(t)),
                        (this.pointersOver = (t) => this.dotPointerIn(t)),
                        (this.pointersOut = (t) => this.dotPointerOut(t)),
                        (this.debouncedBlockSelectCallback = o((t) => this.debouncedBlockSelect(t), 500)),
                        (this.quickViewPopup = new gh(this.container)),
                        this.listen();
                }
            })(this.container);
        },
        onUnload() {
            Gf[this.id].onUnload();
        },
        onBlockSelect(t) {
            Gf[this.id].onBlockSelect(t);
        },
        onDeselect() {
            Gf[this.id].onDeselect();
        },
    };
    I("look", [py]);
    const my = "[data-grid]",
        gy = "[data-item]",
        fy = "[data-item-content-inner]",
        yy = ".carousel--mobile",
        vy = "[data-aos], [data-aos-anchor]",
        by = "data-aos-anchor",
        wy = "data-aos-trigger",
        Sy = "data-slider-mobile",
        Ey = "aos-animate";
    let Ly = {};
    I("mosaic", {
        onLoad() {
            Ly[this.id] = new (class {
                onResize() {
                    this.updateAOSAnchors();
                }
                updateAOSAnchors() {
                    if ("false" != theme.settings.animationsEnabled && we() && this.hasSliderMobile && this.carouselMobile && this.items.length > 1) {
                        const t = this.items[0],
                            e = t.querySelector(fy),
                            i = t.id,
                            s = e ? e.id : i;
                        t.setAttribute(wy, `#${i}`),
                            null == e || e.setAttribute(wy, `#${s}`),
                            this.items.forEach((t) => {
                                const e = t.querySelectorAll(vy),
                                    o = t.querySelector(fy);
                                t.setAttribute(by, `#${i}`), null == o || o.setAttribute(by, `#${s}`), e.forEach((t) => t.setAttribute(by, `#${s}`));
                            });
                    }
                }
                triggerAOS(t) {
                    "false" != theme.settings.animationsEnabled &&
                        t &&
                        ([...t.querySelectorAll(vy)].some((t) => t.classList.contains(Ey)) ||
                            this.items.forEach((t) => {
                                const e = t.querySelectorAll(vy);
                                t.classList.add(Ey), e.forEach((t) => t.classList.add(Ey));
                            }));
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = e.closest(my),
                        s = i.currentStyle || window.getComputedStyle(i),
                        o = parseInt(s.paddingLeft),
                        n = e.offsetLeft - o,
                        r = this.items[0];
                    e.matches(`#${r.id}`) || this.triggerAOS(e),
                        setTimeout(() => {
                            i.scrollTo({ top: 0, left: n, behavior: "smooth" });
                        }, 500);
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.hasSliderMobile = this.container.hasAttribute(Sy)),
                        (this.carouselMobile = this.container.querySelector(yy)),
                        (this.items = this.container.querySelectorAll(gy)),
                        (this.onResizeCallback = () => this.onResize()),
                        this.updateAOSAnchors(),
                        document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
            })(this);
        },
        onUnload() {
            Ly[this.id].onUnload();
        },
        onBlockSelect(t) {
            Ly[this.id].onBlockSelect(t);
        },
    }),
        I("newsletter", Pg),
        I("overlapping-images", [Xp, Pu]);
    const ky = "[data-toggle-admin]",
        Ay = "[data-toggle-newsletter]",
        Cy = "[data-form-admin]",
        qy = "[data-form-newsletter]";
    let Ty = {};
    I("password-template", {
        onLoad() {
            Ty[this.id] = new (class {
                init() {
                    this.toggleAdmin.addEventListener("click", (t) => {
                        t.preventDefault(), this.showPasswordForm();
                    }),
                        this.toggleNewsletter.addEventListener("click", (t) => {
                            t.preventDefault(), this.hidePasswordForm();
                        }),
                        "#login" == window.location.hash || this.adminErrors ? this.showPasswordForm() : this.hidePasswordForm();
                }
                showPasswordForm() {
                    Br(this.adminForm), zr(this.newsletterForm), (window.location.hash = "#login");
                }
                hidePasswordForm() {
                    Br(this.newsletterForm), zr(this.adminForm), (window.location.hash = "");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.toggleAdmin = this.container.querySelector(ky)),
                        (this.toggleNewsletter = this.container.querySelector(Ay)),
                        (this.adminForm = this.container.querySelector(Cy)),
                        (this.newsletterForm = this.container.querySelector(qy)),
                        (this.adminErrors = this.adminForm.querySelector(".errors")),
                        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
                        this.init();
                }
            })(this);
        },
    });
    const Py = "[data-large-promo]",
        xy = "[data-large-promo-inner]",
        Iy = "[data-tracking-consent]",
        Hy = "[data-tracking-consent-inner]",
        Fy = "[data-confirm-cookies]",
        My = "[data-popup-bar]",
        Dy = "[data-popup-bar-holder]",
        Oy = "[data-popup-bar-toggle]",
        By = "[data-popup-body]",
        zy = "[data-popup-close]",
        _y = "[data-popup-underlay]",
        $y = "[data-newsletter-form]",
        Vy = "data-target-referrer",
        Ry = "data-prevent-scroll-lock",
        Ny = "has-success",
        Wy = "has-error",
        Uy = "selected",
        jy = "has-block-selected",
        Gy = "popup--expanded",
        Ky = "popup--visible",
        Qy = "mobile",
        Yy = "desktop",
        Xy = "popup--bar",
        Jy = "popup-bar-is-visible";
    let Zy = {},
        tv = 0,
        ev = 0,
        iv = [],
        sv = class {
            always() {
                this.showPopup();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.showPopup();
                }, 1e3 * t);
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            idle() {
                if (!(!0 === this.checkPopupTarget())) return;
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), this.showPopup();
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            showPopup() {
                const t = { id: this.popup.id, body: this.popupBody };
                iv.push(t);
                if (!0 === this.checkPopupTarget()) {
                    if (((ev += 1), this.popup.classList.add(Ky), this.popup.classList.contains(Xy) && document.body.classList.add(Jy), this.a11y.trapFocus({ container: this.popupBody }), this.popup.hasAttribute(Ry))) return !1;
                    this.scrollLock();
                }
            }
            checkPopupTarget() {
                const t = this.popup.parentNode.classList.contains(Qy),
                    e = this.popup.parentNode.classList.contains(Yy);
                return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
            }
            scrollLock() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e) {
                if (
                    ((this.popupContainer = t),
                    (this.popup = e),
                    (this.popupBody = e.querySelector(By)),
                    (this.delay = t.dataset.popupDelay),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.a11y = ri),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        ov = class {
            constructor(t) {
                if (((this.popupContainer = t), (this.locationPath = location.href), !this.popupContainer.hasAttribute(Vy))) return !1;
                -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(Vy)) || window.Shopify.designMode || this.popupContainer.parentNode.removeChild(this.popupContainer);
            }
        };
    I("popups", [
        {
            onLoad() {
                (Zy[this.id] = []), window.Shopify.designMode && (ev = 0);
                const t = this.container.querySelectorAll(Py);
                t.length &&
                    t.forEach((t) => {
                        Zy[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode ? this.showPopup() : new sv(this.popupContainer, this.popup),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(Ny) && (this.showPopupIfNoCookie(), (ev -= 1));
                                            }),
                                        this.initClosers());
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(Qy),
                                        e = this.popup.parentNode.classList.contains(Yy);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup();
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", this.closePopup.bind(this)),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t);
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.hidePopup(), this.cookie.write();
                                }
                                scrollLock() {
                                    this.resetScrollUnlock(), this.a11y.trapFocus({ container: this.popupBody }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (tv = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    tv && clearTimeout(tv);
                                }
                                showPopup() {
                                    const t = !0 === this.checkPopupTarget(),
                                        e = { id: this.popupId, body: this.popup };
                                    iv.push(e), t && ((ev += 1), this.popup.classList.add(Ky), this.scrollLock());
                                }
                                hidePopup() {
                                    this.popup.classList.remove(Ky);
                                    const t = iv.findIndex((t) => t.id === this.popupId);
                                    if (((ev -= 1), iv.splice(t, 1), 1 == ev && document.body.classList.contains(Jy))) this.scrollUnlock();
                                    else if (ev < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (iv.length > 0) {
                                        const t = iv[iv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && !this.popup.classList.contains(Ky) && (this.popup.classList.add(Uy), this.popupContainer.classList.add(jy), this.showPopup());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(Uy), this.popupContainer.classList.remove(jy), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(Uy), this.popupContainer.classList.remove(jy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(xy)),
                                        (this.popupBody = this.popup.querySelector(By)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(zy)),
                                        (this.underlay = this.popup.querySelector(_y)),
                                        (this.form = this.popup.querySelector($y)),
                                        (this.cookie = new vg(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.isTargeted = new ov(this.popupContainer)),
                                        (this.a11y = ri),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const e = this.container.querySelectorAll(My);
                e.length &&
                    e.forEach((t) => {
                        Zy[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode ? this.showPopup() : new sv(this.popupContainer, this.popup),
                                        this.initPopupToggleButton(),
                                        this.initClosers(),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(Ny) && this.showPopupIfNoCookie(), this.form.classList.contains(Wy) && this.toggle.dispatchEvent(new Event("click"));
                                            }));
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(Qy),
                                        e = this.popup.parentNode.classList.contains(Yy);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
                                }
                                initPopupToggleButton() {
                                    this.toggle.addEventListener("click", (t) => {
                                        t.preventDefault(), this.popup.classList.toggle(Gy), this.popup.classList.contains(Gy) ? this.scrollLock() : this.scrollUnlock();
                                    });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    iv.push(t), this.a11y.trapFocus({ container: this.popupBody }), !0 === this.checkPopupTarget() && ((ev += 1), document.body.classList.add(Jy), this.popup.classList.add(Ky));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(Ky), document.body.classList.remove(Jy);
                                    const t = iv.findIndex((t) => t.id === this.popupId);
                                    if ((iv.splice(t, 1), ev >= 1 && (ev -= 1), ev < 1)) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (iv.length > 0) {
                                        const t = iv[iv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", () => this.toggle.dispatchEvent(new Event("click"))),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && (this.popup.classList.remove(Gy), this.scrollUnlock());
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.cookie.write(), this.hidePopup();
                                }
                                scrollLock() {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (tv = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    tv && clearTimeout(tv);
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(Ky) &&
                                        (this.showPopup(), this.popup.classList.add(Gy), this.popup.classList.add(Uy), this.popup.parentNode.classList.add(jy), this.resetScrollUnlock(), this.scrollLock());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(Gy), this.popup.classList.remove(Uy), this.popup.parentNode.classList.remove(jy), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(Gy), this.popup.classList.remove(Uy), this.popup.parentNode.classList.remove(jy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Dy)),
                                        (this.popupBody = this.popup.querySelector(By)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(zy)),
                                        (this.underlay = this.popup.querySelector(_y)),
                                        (this.toggle = this.popup.querySelector(Oy)),
                                        (this.cookie = new vg(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.form = this.popup.querySelector($y)),
                                        (this.isTargeted = new ov(this.popupContainer)),
                                        (this.a11y = ri),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const i = this.container.querySelectorAll(Iy);
                i.length &&
                    i.forEach((t) => {
                        Zy[this.id].push(
                            new (class {
                                init() {
                                    this.enableTracking && this.showPopup(), this.clickEvents();
                                }
                                clickEvents() {
                                    this.close.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.hidePopup());
                                    }),
                                        this.acceptButton.addEventListener("click", (t) => {
                                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.hidePopup());
                                        }),
                                        document.addEventListener("trackingConsentAccepted", () => {
                                            console.log("trackingConsentAccepted event fired");
                                        });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    iv.push(t), this.popup.classList.add(Ky), this.a11y.trapFocus({ container: this.popup });
                                }
                                hidePopup() {
                                    this.popup.classList.remove(Ky);
                                    const t = iv.findIndex((t) => t.id === this.popupId);
                                    if ((iv.splice(t, 1), ev < 1)) this.a11y.removeTrapFocus();
                                    else if (iv.length > 0) {
                                        const t = iv[iv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && this.enableTracking && !this.popup.classList.contains(Ky) && (this.showPopup(), this.popup.classList.add(Uy), this.popup.parentNode.classList.add(jy));
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(Uy), this.popupContainer.classList.remove(jy), this.hidePopup());
                                }
                                onDeselect() {
                                    this.popup.classList.remove(Uy), this.popupContainer.classList.remove(jy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Hy)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(zy)),
                                        (this.acceptButton = this.popup.querySelector(Fy)),
                                        (this.enable = "true" === this.popupContainer.dataset.enable),
                                        (this.a11y = ri),
                                        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                            if (t) throw t;
                                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                                            (this.enableTracking = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.enableTracking = !0), this.init();
                                        });
                                }
                            })(t)
                        );
                    });
            },
            onDeselect() {
                Zy[this.id].forEach((t) => {
                    "function" == typeof t.onDeselect && t.onDeselect();
                });
            },
            onBlockSelect(t) {
                Zy[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Zy[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload(t) {
                Zy[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload(t);
                });
            },
        },
        Pg,
    ]);
    const nv = "[data-press-items]",
        rv = "[data-logo-slider]",
        av = "[data-logo-slide]",
        lv = "a, button",
        cv = "data-logo-index",
        hv = "tabindex";
    let dv = {};
    const uv = {
        onLoad() {
            dv[this.id] = new (class {
                checkSlides() {
                    const t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(av),
                        s = e.data(this.sliderNav) || null;
                    null !== s &&
                        ((s.options.draggable = !1),
                        (s.options.wrapAround = !1),
                        (s.options.contain = !0),
                        this.getSlidesWidth() > t && i.length > 2 && ((s.options.draggable = !0), (s.options.wrapAround = !0), (s.options.contain = !1)),
                        s.resize(),
                        s.updateDraggable());
                }
                getSlidesWidth() {
                    const t = this.container.querySelectorAll(av);
                    let e = 0;
                    return (
                        t.length &&
                            t.forEach((t) => {
                                e += t.offsetWidth;
                            }),
                        e
                    );
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null;
                    const s = parseInt(this.container.dataset.duration),
                        o = "true" === this.container.dataset.autoplay && s;
                    (t = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !1, prevNextButtons: !1, pageDots: !1, autoPlay: o })),
                        (i = new e(this.sliderNav, {
                            draggable: !1,
                            wrapAround: !1,
                            contain: !0,
                            imagesLoaded: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            on: {
                                ready: () => {
                                    this.container.querySelectorAll(av).forEach((e) => {
                                        e.addEventListener("keyup", (i) => {
                                            if (i.code === theme.keyboardKeys.ENTER || i.code === theme.keyboardKeys.NUMPADENTER || i.code === theme.keyboardKeys.SPACE) {
                                                const i = Number(e.getAttribute(cv));
                                                t.selectCell(i);
                                            }
                                        });
                                    });
                                },
                            },
                        })),
                        xi(this.slider),
                        xi(this.sliderNav),
                        i.on("change", (e) => {
                            t.selectCell(e);
                        }),
                        t.on("change", (e) => {
                            i.selectCell(e),
                                t.cells.forEach((t, i) => {
                                    t.element.querySelectorAll(lv).forEach((t) => {
                                        t.setAttribute(hv, i === e ? "0" : "-1");
                                    });
                                });
                        });
                }
                resizeSlider() {
                    const t = e.data(this.slider);
                    t && t.resize();
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && (i.select(o), i.pausePlayer()), null !== s && s.select(o);
                }
                onBlockDeselect() {
                    const t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay && null !== t && t.playPlayer();
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(nv)),
                        (this.sliderNav = this.container.querySelector(rv)),
                        (this.sliderResizeEvent = () => this.checkSlides()),
                        this.initSlider(),
                        this.checkSlides(),
                        window.addEventListener("load", this.resizeSlider.bind(this)),
                        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
                }
            })(this);
        },
        onUnload(t) {
            dv[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            dv[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            dv[this.id].onBlockDeselect();
        },
    };
    I("press", uv);
    const pv = "[data-product-single-media-slider]",
        mv = "[data-product-info]",
        gv = "[data-header-sticky]",
        fv = "[data-header-height]",
        yv = "is-sticky",
        vv = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const bv = {};
    const wv = {
            onLoad() {
                bv[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.productInfo.addEventListener("theme:form:sticky", (t) => {
                                this.removeAnimationFrame(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    scrollEvents(t) {
                        null !== t.detail && ((this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down)),
                            this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents() {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.large,
                            e = this.container.querySelector(mv);
                        if (e)
                            if (t) {
                                const t = this.container.querySelector(mv),
                                    i = this.container.querySelector(pv);
                                if (!t || !i) return;
                                t.offsetHeight < i.offsetHeight ? ((theme.variables.productPageSticky = !0), e.classList.add(yv)) : ((theme.variables.productPageSticky = !1), e.classList.remove(yv));
                            } else (theme.variables.productPageSticky = !1), e.classList.remove(yv);
                    }
                    calculateStickyPosition(t = null) {
                        const e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.productInfo.offsetHeight,
                            o = window.innerHeight - s - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n),
                            this.stickyFormLoad &&
                                (document.querySelector(gv) && document.querySelector(fv)
                                    ? (this.stickyDefaultTop = parseInt(document.querySelector(fv).getBoundingClientRect().height))
                                    : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                                (this.stickyScrollTop = this.stickyDefaultTop)),
                            (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop));
                        const r = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
                            this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (i && this.onChangeCounter <= 10) || (i && this.stickyFormLastHeight !== s) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.stickyFormLastHeight = s);
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(vv)),
                            (this.productInfo = this.container.querySelector(mv)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                bv[this.id].onUnload();
            },
        },
        Sv = "[data-product-single-media-group]",
        Ev = "[data-product-single-media-slider]",
        Lv = "[data-zoom-wrapper]",
        kv = "pswp-zoom-gallery",
        Av = "pswp-zoom-gallery--single",
        Cv = "is-moving",
        qv = "data-image-width",
        Tv = "data-image-height";
    const Pv = "[data-complementary-products]",
        xv = "[data-button-quick-view]",
        Iv = "data-url";
    let Hv = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting &&
                        (e.unobserve(this),
                        this.hasAttribute(Iv) &&
                            "" !== this.getAttribute(Iv) &&
                            fetch(this.getAttribute(Iv))
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = document.createElement("div");
                                    e.innerHTML = t;
                                    const i = e.querySelector(Pv);
                                    i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector(xv) && new gh(this);
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" }
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const Fv = "[data-recipient-checkbox]",
        Mv = "[data-recipient-email]",
        Dv = "[data-recipient-name]",
        Ov = "[data-recipient-message]",
        Bv = "[data-recipient-send-on]",
        zv = "[data-recipient-control]",
        _v = "[data-recipient-offset]",
        $v = "[data-product-form]",
        Vv = "[data-cart-drawer]",
        Rv = "js-quick-view-visible";
    let Nv = class extends HTMLElement {
        connectedCallback() {
            this.recipientCheckbox && (this.disableInputFields(), this.recipientCheckbox.addEventListener("change", this.onChangeEvent), document.addEventListener("theme:cart:added", this.onCartAddedEvent));
        }
        onChange(t) {
            if (!t.target.checked) return this.clearInputFields(), void this.disableInputFields();
            this.enableInputFields();
        }
        onCartAdded() {
            const t = this.closest($v).offsetTop,
                e = document.body.classList.contains(Rv);
            if (!(!0 === this.recipientCheckbox.checked)) return;
            e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
            const i = (t) => {
                t.target === this.cartDrawer &&
                    (requestAnimationFrame(() => {
                        (this.recipientCheckbox.checked = !1), this.recipientCheckbox.dispatchEvent(new Event("change"));
                    }),
                    this.cartDrawer.removeEventListener("transitionend", i));
            };
            this.cartDrawer.addEventListener("transitionend", i);
        }
        inputFields() {
            return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn];
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset];
        }
        clearInputFields() {
            this.inputFields().forEach((t) => (t.value = ""));
        }
        enableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !1));
        }
        disableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !0));
        }
        disconnectedCallback() {
            this.recipientCheckbox.removeEventListener("change", this.onChangeEvent), document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
        }
        constructor() {
            super(),
                (this.recipientCheckbox = this.querySelector(Fv)),
                (this.recipientControl = this.querySelector(zv)),
                (this.recipientControl.disabled = !0),
                (this.recipientEmail = this.querySelector(Mv)),
                (this.recipientName = this.querySelector(Dv)),
                (this.recipientMessage = this.querySelector(Ov)),
                (this.recipientSendOn = this.querySelector(Bv)),
                (this.recipientOffset = this.querySelector(_v)),
                this.recipientOffset && (this.recipientOffset.value = new Date().getTimezoneOffset()),
                (this.cartDrawer = document.querySelector(Vv)),
                (this.onChangeEvent = (t) => this.onChange(t)),
                (this.onCartAddedEvent = () => this.onCartAdded());
        }
    };
    const Wv = "[data-product-single-media-slider]",
        Uv = "[data-thumbnail-id]",
        jv = "[data-product-single-media-thumbs]",
        Gv = "[data-product-single-media-wrapper]",
        Kv = "[data-model]",
        Qv = ".product-single__thumbnail-link",
        Yv = "[data-deferred-media]",
        Xv = "[data-deferred-media-button]",
        Jv = "a, button",
        Zv = "[data-upsell-holder]",
        tb = "[data-upsell-slider]",
        eb = "[data-slider]",
        ib = "[data-product-json]",
        sb = "featured-product",
        ob = "featured-product--onboarding",
        nb = "has-media-active",
        rb = "is-selected",
        ab = "media--hidden",
        lb = "no-outline",
        cb = "is-moving",
        hb = "data-media-id",
        db = "data-section-id",
        ub = "data-thumbnail-id",
        pb = "data-tall-layout",
        mb = "loaded",
        gb = "tabindex",
        fb = "aria-hidden",
        yb = {};
    const vb = {
        onLoad() {
            yb[this.id] = new (class {
                productSlider() {
                    this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                checkSlider() {
                    !this.tallLayout || window.innerWidth < theme.sizes.large ? this.initProductSlider() : this.destroyProductSlider();
                }
                resizeFlickityNav() {
                    null !== this.flktyNav && this.flktyNav.resize();
                }
                initProductSlider() {
                    const t = this.container.querySelector(Wv),
                        i = this.container.querySelector(jv),
                        s = this.container.querySelectorAll(Gv);
                    if (
                        s.length > 1 &&
                        ((this.flkty = new e(t, {
                            wrapAround: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            on: {
                                ready: () => {
                                    t.setAttribute(gb, "-1"),
                                        this.slidesAriaHidden(t),
                                        s.forEach((t) => {
                                            if (!t.classList.contains(rb)) {
                                                const e = t.querySelectorAll(Jv);
                                                e.length &&
                                                    e.forEach((t) => {
                                                        t.setAttribute(gb, "-1");
                                                    });
                                            }
                                        });
                                },
                                dragStart: () => {
                                    t.classList.add(cb);
                                },
                                dragMove: () => {
                                    this.isFlickityDragging = !0;
                                },
                                staticClick: () => {
                                    this.isFlickityDragging = !1;
                                },
                                change: () => {
                                    this.slidesAriaHidden(t);
                                },
                                settle: (e) => {
                                    const i = this.flkty.selectedElement.getAttribute(hb);
                                    this.flkty.cells.forEach((t, i) => {
                                        const s = t.element.querySelectorAll(Jv);
                                        s.length &&
                                            s.forEach((t) => {
                                                t.setAttribute(gb, i === e ? "0" : "-1");
                                            });
                                    }),
                                        this.switchMedia(i),
                                        t.classList.remove(cb);
                                },
                            },
                        })),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("theme:media:play", () => {
                                    (this.flkty.options.draggable = !1), this.flkty.updateDraggable(), t.closest(Wv).classList.add(nb);
                                }),
                                    t.addEventListener("theme:media:pause", () => {
                                        (this.flkty.options.draggable = !0), this.flkty.updateDraggable(), t.closest(Wv).classList.remove(nb);
                                    });
                            }),
                        xi(t),
                        null !== i)
                    ) {
                        (this.flktyNav = new e(i, {
                            asNavFor: t,
                            contain: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            resize: !0,
                            on: {
                                ready: () => {
                                    i.setAttribute(gb, "-1"), this.slidesAriaHidden(i);
                                },
                                change: () => {
                                    this.slidesAriaHidden(i);
                                },
                            },
                        })),
                            null !== this.flktyNav && document.addEventListener("theme:resize:width", this.flktyNavOnResize),
                            xi(i);
                        const s = this.container.querySelectorAll(Qv);
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                            });
                    }
                }
                slidesAriaHidden(t) {
                    e.data(t).cells.forEach((t) => t.element.setAttribute(fb, "false"));
                }
                destroyProductSlider() {
                    null !== this.flkty && (this.flkty.destroy(), this.flktyNav.destroy(), (this.flkty = null), (this.flktyNav = null));
                }
                initUpsellSlider() {
                    const t = this.container.querySelector(tb);
                    if (this.container.querySelectorAll(Zv).length > 1) {
                        const i = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 });
                        i.on("change", (t) => {
                            i.cells.forEach((e, i) => {
                                const s = e.element.querySelectorAll(Jv);
                                s.length &&
                                    s.forEach((e) => {
                                        e.setAttribute(gb, i === t ? "0" : "-1");
                                    });
                            });
                        });
                    }
                }
                initFeatureSlider() {
                    this.featureSliders.forEach((t) => {
                        Array.from(t.children).length > 1 && (this.flktyFeature = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 }));
                    });
                }
                handleMediaFocus(t) {
                    if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
                    const i = t.currentTarget.getAttribute(ub),
                        s = this.container.querySelector(`[${hb}="${i}"]`),
                        o = parseInt([...s.parentNode.children].indexOf(s)),
                        n = this.container.querySelector(Wv),
                        r = this.container.querySelector(jv),
                        a = e.data(n) || null,
                        l = e.data(r) || null;
                    a && a.isActive && o > -1 && (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) && a.select(o), l && l.isActive && o > -1 && l.select(o);
                }
                switchMedia(t) {
                    const e = document.querySelectorAll(`${Gv}`),
                        i = this.container.querySelector(`${Gv}[${hb}="${t}"]`),
                        s = !document.body.classList.contains(lb);
                    e.length &&
                        e.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(ab);
                        }),
                        s && i.focus(),
                        i.closest(Wv).classList.remove(nb),
                        i.classList.remove(ab),
                        i.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    const o = i.querySelector(Yv);
                    o && "true" !== o.getAttribute(mb) && i.querySelector(Xv).dispatchEvent(new Event("click"));
                }
                initMediaSwitch() {
                    const t = this.container.querySelectorAll(Uv);
                    t.length &&
                        t.forEach((t) => {
                            t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                        });
                }
                initProductVideo() {
                    this.videos = new Wi(this.container);
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(Kv);
                    t.length &&
                        t.forEach((t) => {
                            theme.ProductModel.init(t, this.sectionId);
                        });
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                        this.container.querySelector(`${Kv}:not(.${ab})`).dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                }
                onUnload() {
                    null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize), document.removeEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                onBlockSelect(t) {
                    const i = e.data(t.target.closest(eb)),
                        s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    i && i.select(s);
                }
                constructor(t) {
                    if (
                        ((this.container = t.container),
                        (this.sectionId = this.container.getAttribute(db)),
                        (this.tallLayout = "true" === this.container.getAttribute(pb)),
                        (this.featureSliders = this.container.querySelectorAll(eb)),
                        (this.flkty = null),
                        (this.flktyNav = null),
                        (this.isFlickityDragging = !1),
                        (this.enableHistoryState = !this.container.classList.contains(sb)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.flktyNavOnResize = () => this.resizeFlickityNav()),
                        this.initUpsellSlider(),
                        this.initFeatureSlider(),
                        new gh(this.container),
                        this.container.classList.contains(ob))
                    )
                        return;
                    const e = this.container.querySelector(ib);
                    if (e && e.innerHTML) {
                        const t = JSON.parse(e.innerHTML).handle;
                        let i = {};
                        t && (i = { handle: t }), Shopify.Products.recordRecentlyViewed(i);
                    } else Shopify.Products.recordRecentlyViewed();
                    new (class {
                        init() {
                            this.zoomWrappers.length &&
                                this.zoomWrappers.forEach((t, e) => {
                                    t.addEventListener("click", (i) => {
                                        i.preventDefault(), (this.slider && this.slider.classList.contains(Cv)) || ((this.a11y.state.trigger = t), this.createZoom(e));
                                    });
                                });
                        }
                        createZoom(t) {
                            const e = this;
                            let i = [],
                                s = 0;
                            this.zoomWrappers.forEach((o) => {
                                const n = o.getAttribute("href"),
                                    r = parseInt(o.getAttribute(qv)),
                                    a = parseInt(o.getAttribute(Tv));
                                if ((i.push({ src: n, w: r, h: a, msrc: n }), (s += 1), e.zoomWrappers.length === s)) {
                                    let e = `${kv}`;
                                    1 === s && (e = `${kv} ${Av}`),
                                        new Yc(i, {
                                            barsSize: { top: 60, bottom: 60 },
                                            history: !1,
                                            focus: !1,
                                            index: t,
                                            mainClass: e,
                                            showHideOpacity: !0,
                                            showAnimationDuration: 250,
                                            hideAnimationDuration: 250,
                                            closeOnScroll: !1,
                                            closeOnVerticalDrag: !1,
                                            captionEl: !1,
                                            closeEl: !0,
                                            closeElClasses: ["caption-close"],
                                            tapToClose: !1,
                                            clickToCloseNonZoomable: !1,
                                            maxSpreadZoom: 2,
                                            loop: !0,
                                            spacing: 0,
                                            allowPanToNext: !0,
                                            pinchToClose: !1,
                                        });
                                }
                            });
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.mediaContainer = this.container.querySelector(Sv)),
                                (this.slider = this.container.querySelector(Ev)),
                                (this.zoomWrappers = this.container.querySelectorAll(Lv)),
                                (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
                                (this.a11y = ri),
                                this.zoomEnable && this.init();
                        }
                    })(this.container),
                        this.productSlider(),
                        this.initMediaSwitch(),
                        this.initProductVideo(),
                        this.initProductModel(),
                        this.initShopifyXrLaunch();
                }
            })(this);
        },
        onUnload: function () {
            yb[this.id].onUnload();
        },
        onBlockSelect(t) {
            yb[this.id].onBlockSelect(t);
        },
    };
    I("product-template", [ml, vb, ho, uo, Kp, Xe, ds, Nl, Or, wv]),
        I("featured-product", [ml, vb, ho, uo, Kp, Xe, ds, Nl, Or, wv]),
        customElements.get("complementary-products") || customElements.define("complementary-products", Hv),
        customElements.get("recipient-form") || customElements.define("recipient-form", Nv);
    const bb = "href",
        wb = "data-media-id",
        Sb = "data-deferred-media-loaded",
        Eb = "[data-product-content-wrapper]",
        Lb = "[data-product-single-media-wrapper]",
        kb = "[data-model]",
        Ab = "[data-product-link]",
        Cb = "[data-product-single-media-image]",
        qb = "[data-slider-contents]",
        Tb = "[data-slider-images]",
        Pb = "[data-tab-button]",
        xb = "[data-tab-item]",
        Ib = "[data-circle-text]",
        Hb = { aosAnimate: "aos-animate", tabButtonActive: "products-list__nav__button--active", tabItemActive: "products-list__item--active", mediaHidden: "media--hidden", isDisabled: "is-disabled" },
        Fb = {};
    I("products-list", [
        {
            onLoad() {
                Fb[this.id] = new (class {
                    listen() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.addEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    resizeSlider() {
                        this.flktyImages.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyImages.forEach((t) => t.resize());
                            }),
                            this.flktyContent.length > 0 &&
                                requestAnimationFrame(() => {
                                    this.flktyContent.forEach((t) => t.resize());
                                });
                    }
                    initButtons() {
                        this.tabButtons.length &&
                            this.tabButtons.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.classList.contains(Hb.tabButtonActive)) return;
                                    const i = t.getAttribute(bb),
                                        s = this.container.querySelector(i),
                                        o = s.querySelector(Lb),
                                        n = o ? o.dataset.mediaId : null,
                                        r = s.querySelector(Ib);
                                    this.tabButtons.forEach((t) => {
                                        t.classList.remove(Hb.tabButtonActive);
                                    }),
                                        this.tabItems.forEach((t) => {
                                            const e = t.querySelector(Ib);
                                            t.classList.remove(Hb.tabItemActive),
                                                null == e || e.classList.add(Hb.isDisabled),
                                                theme.settings.animationsEnabled &&
                                                    t.querySelectorAll(`.${Hb.aosAnimate}`).forEach((t) => {
                                                        t.classList.remove(Hb.aosAnimate),
                                                            setTimeout(() => {
                                                                t.classList.add(Hb.aosAnimate);
                                                            });
                                                    });
                                        }),
                                        t.classList.add(Hb.tabButtonActive),
                                        s.classList.add(Hb.tabItemActive),
                                        document.dispatchEvent(new CustomEvent("theme:resize")),
                                        r && (r.classList.remove(Hb.isDisabled), document.dispatchEvent(new CustomEvent("theme:scroll"))),
                                        this.handleProductVideos(s, n),
                                        e.preventDefault();
                                });
                            });
                    }
                    initSliders() {
                        this.slidersImages.forEach((t, i) => {
                            const s = t.closest(xb).querySelector(qb),
                                o = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                    asNavFor: s,
                                    on: {
                                        change: (t) => {
                                            this.flktyContent.length > 0 && this.flktyContent[i].select(t);
                                        },
                                    },
                                });
                            o.on("settle", (e) => {
                                const i = t.querySelectorAll(Lb);
                                for (let t = 0; t < i.length; t++) t === e ? i[t].querySelector(Cb).removeAttribute("tabindex") : i[t].querySelector(Cb).setAttribute("tabindex", "-1");
                            }),
                                this.flktyImages.push(o);
                        }),
                            this.slidersContents.forEach((t) => {
                                const i = new e(t, { fade: !0, pageDots: !1, prevNextButtons: !1, wrapAround: !0, adaptiveHeight: !0 });
                                i.on("settle", (e) => {
                                    const i = t.querySelectorAll(Eb);
                                    for (let t = 0; t < i.length; t++)
                                        t === e
                                            ? i[t].querySelectorAll(Ab).forEach((t) => {
                                                  t.removeAttribute("tabindex");
                                              })
                                            : i[t].querySelectorAll(Ab).forEach((t) => {
                                                  t.setAttribute("tabindex", "-1");
                                              });
                                }),
                                    this.flktyContent.push(i);
                            });
                    }
                    initProductVideos() {
                        this.tabItems.forEach((t) => {
                            t.classList.contains(Hb.tabItemActive) && this.handleProductVideos(t);
                        });
                    }
                    loadVideos(t, e = null) {
                        new IntersectionObserver(
                            (i, s) => {
                                i.forEach((i) => {
                                    if (i.isIntersecting) {
                                        const o = new Wi(t);
                                        this.videos.push(o), t.setAttribute(Sb, ""), this.playToggle(e), s.unobserve(i.target);
                                    }
                                });
                            },
                            { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                        ).observe(t);
                    }
                    handleProductVideos(t, e = null) {
                        t.hasAttribute(Sb) ? this.playToggle(e) : this.loadVideos(t, e);
                    }
                    playToggle(t) {
                        this.videos.forEach((e) => {
                            "function" == typeof e.pauseContainerMedia && t && (e.pauseContainerMedia(t, this.container), this.switchMedia(t)), t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container);
                        });
                    }
                    switchMedia(t) {
                        const e = this.container.querySelector(`${Lb}[${wb}="${t}"]`);
                        !document.body.classList.contains(Hb.noOutline) && e.focus(), e.classList.remove(Hb.mediaHidden), e.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    }
                    pauseContainerMedia(t) {
                        const e = t.querySelectorAll(Lb);
                        0 !== e.length &&
                            e.forEach((t) => {
                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Hb.mediaHidden);
                            });
                    }
                    initProductModel() {
                        const t = this.container.querySelectorAll(kb);
                        t.length &&
                            t.forEach((t) => {
                                theme.ProductModel.init(t, this.sectionId);
                            });
                    }
                    initShopifyXrLaunch() {
                        document.addEventListener("shopify_xr_launch", () => {
                            this.container.querySelector(`${kb}:not(.${Hb.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"));
                        });
                    }
                    onBlockSelect(t) {
                        t.target.dispatchEvent(new Event("click"));
                    }
                    onUnload() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.removeEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sectionId = this.container.dataset.sectionId),
                            (this.tabButtons = this.container.querySelectorAll(Pb)),
                            (this.tabItems = this.container.querySelectorAll(xb)),
                            (this.slidersImages = this.container.querySelectorAll(Tb)),
                            (this.slidersContents = this.container.querySelectorAll(qb)),
                            (this.videos = []),
                            (this.flktyImages = []),
                            (this.flktyContent = []),
                            (this.sliderResizeEvent = () => this.resizeSlider()),
                            this.initButtons(),
                            this.initSliders(),
                            this.initProductVideos(),
                            this.initProductModel(),
                            this.initShopifyXrLaunch(),
                            this.listen();
                    }
                })(this);
            },
            onUnload() {
                Fb[this.id].onUnload();
            },
            onBlockSelect(t) {
                Fb[this.id].onBlockSelect(t);
            },
        },
        Pu,
    ]);
    const Mb = "[data-product-block]",
        Db = "[data-related-products]",
        Ob = "[data-recent-wrapper]",
        Bb = "[data-recently-viewed-wrapper]",
        zb = "[data-slider]",
        _b = "[data-slide]",
        $b = "[data-aos]",
        Vb = "[data-tabs-holder]",
        Rb = "[data-tabs-link]",
        Nb = "[data-tab]",
        Wb = "[data-tooltip]",
        Ub = "data-section-id",
        jb = "data-product-id",
        Gb = "data-limit",
        Kb = "data-minimum",
        Qb = "data-tabs-link",
        Yb = "data-column-mobile",
        Xb = "hidden",
        Jb = "aos-animate",
        Zb = "mobile--one-whole",
        tw = "mobile--one-half",
        ew = {};
    const iw = {
        onLoad() {
            ew[this.id] = new (class {
                related() {
                    if (((this.relatedProducts = this.container.querySelector(Db)), !this.relatedProducts)) return;
                    const t = this.container.getAttribute(Ub),
                        e = this.container.getAttribute(jb),
                        i = this.container.getAttribute(Gb),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s)
                        .then((t) => {
                            if (!t.ok) {
                                const e = new Error(t.status);
                                throw (this.hideRelated(), e);
                            }
                            return t.text();
                        })
                        .then((t) => {
                            const e = document.createElement("div");
                            e.innerHTML = t;
                            const i = e.querySelector(Db);
                            i &&
                                i.querySelectorAll(Mb).length &&
                                ((this.relatedProducts.innerHTML = i.innerHTML), (this.relatedProductGrid = new yo(this.relatedProducts)), (this.relatedGridSlider = new sf(this.container)), this.initTooltips(this.relatedProducts));
                        });
                }
                recent() {
                    const t = this.container.querySelector(Ob),
                        e = t ? parseInt(t.getAttribute(Gb)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const i = e.container,
                                s = i.querySelector(Ob),
                                o = i.querySelector(Bb),
                                n = t.querySelectorAll(Mb),
                                r = s.querySelectorAll($b),
                                a = s.querySelector(zb),
                                l = s.hasAttribute(Kb) ? parseInt(s.getAttribute(Kb)) : 1,
                                c = !o && n.length > 0,
                                h = o && n.length >= l,
                                d = a.getAttribute(Yb);
                            if (c || h) {
                                (this.recentProductGrid = new yo(s)),
                                    this.initTooltips(s),
                                    h && i.classList.remove(Xb),
                                    a &&
                                        ((this.recentGridSlider = new sf(i)),
                                        requestAnimationFrame(() => {
                                            this.recentGridSlider.sliders.forEach((t) => {
                                                t.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !0 })), this.recentGridSlider.setSliderArrowsPosition(t);
                                            });
                                        }),
                                        a.querySelectorAll(_b).forEach((t) => {
                                            2 == d ? (t.classList.add(tw), t.classList.remove(Zb)) : (t.classList.add(Zb), t.classList.remove(tw));
                                        }));
                                let t = [];
                                s.addEventListener("theme:target:animate", (e) => {
                                    t.push(e.detail), t.length === r.length && requestAnimationFrame(() => r.forEach((t) => t.classList.add(Jb)));
                                });
                            }
                        },
                    });
                }
                hideRelated() {
                    const t = this.relatedProducts.closest(Nb),
                        e = this.relatedProducts.closest(Vb),
                        i = e.querySelector(`[${Qb}="${t.dataset.tab}"]`);
                    t.remove(),
                        i &&
                            (i.remove(),
                            e.querySelector(Rb).dispatchEvent(new Event("click")),
                            this.tabs.customScrollbar.unload(),
                            requestAnimationFrame(() => {
                                this.tabs.customScrollbar = new Yi(this.tabs.container);
                            }));
                }
                initTooltips(t) {
                    (this.tooltips = t.querySelectorAll(Wb)),
                        this.tooltips.forEach((t) => {
                            new hs(t);
                        });
                }
                onDeselect() {
                    this.relatedProductGrid && this.relatedProductGrid.onDeselect(), this.recentProductGrid && this.recentProductGrid.onDeselect();
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = this.container.querySelectorAll(Nb);
                    !e || i.length < 2 || (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                }
                onUnload() {
                    this.relatedProductGrid && this.relatedProductGrid.onUnload(),
                        this.relatedGridSlider && this.relatedGridSlider.onUnload(),
                        this.recentProductGrid && this.recentProductGrid.onUnload(),
                        this.recentGridSlider && this.recentGridSlider.onUnload();
                }
                constructor(t) {
                    (this.section = t), (this.sectionId = t.id), (this.container = t.container), this.related(), this.recent(), (this.tabs = new fr(this.container));
                }
            })(this);
        },
        onDeselect() {
            ew[this.id].onDeselect();
        },
        onBlockSelect(t) {
            ew[this.id].onBlockSelect(t);
        },
        onUnload() {
            ew[this.id].onUnload();
        },
    };
    I("related-products", iw), I("recent-products", iw);
    const sw = "[data-stl-hotspots-item]",
        ow = "[data-stl-hotspots-target]",
        nw = "[data-stl-hotspots-trigger]",
        rw = ".shopify-section",
        aw = "[data-quick-view-item-holder]",
        lw = "[data-product-block] a, [data-product-block] button",
        cw = "data-hotspot",
        hw = "data-stl-initial-open",
        dw = "tabindex",
        uw = "aria-expanded",
        pw = "aos-animate",
        mw = "is-active",
        gw = "is-loading",
        fw = "pswp--open",
        yw = "block-selected";
    let vw = class extends HTMLElement {
        get items() {
            return [...this.querySelectorAll(sw)];
        }
        get targets() {
            return [...this.querySelectorAll(ow)];
        }
        get triggers() {
            return [...this.querySelectorAll(nw)];
        }
        attributeChangedCallback(t, e, i) {
            const s = "class" === t,
                o = i.includes(pw);
            let n = !0;
            e && e.includes(pw) && (n = !1), s && o && n && this.animate();
        }
        connectedCallback() {
            (this.animationsTimeout = null), (this.resetAnimations = !1), this.init(), this.listen();
        }
        init() {
            theme.settings.animationsEnabled || this.animate(), this.initialOpen || this.focusables();
        }
        listen() {
            if (Shopify.designMode) {
                const t = this.closest(rw);
                t.addEventListener("shopify:section:select", () => this.restoreAnimations()),
                    t.addEventListener("shopify:section:deselect", (t) => this.deselectAll(t)),
                    t.addEventListener("shopify:block:deselect", () => this.restoreAnimations()),
                    this.addEventListener("shopify:block:select", (t) => {
                        this.animationsTimeout && (clearTimeout(this.animationsTimeout), (this.animationsTimeout = null)), this.removeAnimations(), this.deselectAll(t), this.select(this.targets.indexOf(t.target));
                    });
            }
            this.targets.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.select(this.targets.indexOf(t.target)), this.restoreAnimations();
                });
            }),
                this.triggers.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        const e = this.triggers.indexOf(t.target);
                        this.select(e), this.restoreAnimations(), we() && this.dispatchEvent(new CustomEvent("stl:open-quick-view", { bubbles: !0, detail: { index: e } }));
                    });
                }),
                this.addEventListener("keyup", (t) => this.onKeyup(t));
        }
        animate() {
            if (!this.initialOpen) return;
            let t = 600;
            Shopify.designMode && (t = 300), this.resetAnimations || setTimeout(() => this.select(0), t);
        }
        removeAnimations() {
            this.items.forEach((t) => {
                t.style.setProperty("--duration", "0s"), t.classList.add(yw);
            }),
                (this.resetAnimations = !0);
        }
        restoreAnimations() {
            Shopify.designMode &&
                (this.items.forEach((t) => t.classList.remove(yw)),
                (this.animationsTimeout = setTimeout(() => {
                    this.items.forEach((t) => {
                        t.style.removeProperty("--duration");
                    }),
                        (this.resetAnimations = !1);
                }, 1e3)));
        }
        deselectAll(t = !1) {
            this.items.forEach((e, i) => {
                e.classList.remove(mw), 0 === i && this.initialOpen && t && !this.resetAnimations && e.classList.add(mw);
            }),
                setTimeout(() => this.focusables());
        }
        select(t) {
            this.items.forEach((e, i) => {
                e.setAttribute("aria-current", t === i ? "true" : "false"), e.classList.toggle(mw, t === i);
            }),
                this.focusables();
        }
        focusables() {
            this.items.forEach((t, e) => {
                const i = t.classList.contains(mw),
                    s = i ? "0" : "-1",
                    o = !!i;
                t.querySelectorAll(lw).forEach((t) => t.setAttribute(dw, s)), this.targets[e].setAttribute(uw, o);
            });
        }
        onKeyup(t) {
            t.code === theme.keyboardKeys.ESCAPE && (this.deselectAll(), t.target.closest(sw).querySelector(ow).focus());
        }
        constructor() {
            super(), (this.initialOpen = this.hasAttribute(hw));
        }
    };
    !(function (t, e, i) {
        e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
    })(vw, "observedAttributes", ["class"]),
        customElements.get("stl-hotspots") || customElements.define("stl-hotspots", vw);
    let bw = class extends HTMLElement {
        get hotspots() {
            return this.querySelector("stl-hotspots");
        }
        get hotspotsTargets() {
            return [...this.querySelectorAll(ow)];
        }
        get hotspotsTriggers() {
            return [...this.querySelectorAll(nw)];
        }
        connectedCallback() {
            this.init(), this.listen();
        }
        disconnectedCallback() {}
        init() {
            (this.quickViewPopup = new gh(this)), (this.openQuickViewPopupCallback = o((t) => this.openQuickViewPopup(t), 500));
        }
        listen() {
            if (Shopify.designMode) {
                const t = this.closest(rw);
                t.addEventListener("shopify:section:unload", this.destroyQuickViewPopup.bind(this)),
                    t.addEventListener("shopify:section:deselect", this.destroyQuickViewPopup.bind(this)),
                    this.addEventListener("shopify:block:select", (t) => this.openQuickViewPopupCallback(t.target));
            }
            this.hotspots &&
                (this.addEventListener("click", (t) => {
                    Boolean(null !== t.target.closest(sw)) || (this.hotspots.deselectAll(), this.hotspots.restoreAnimations());
                }),
                this.hotspots.addEventListener("stl:open-quick-view", (t) => {
                    if (!we()) return;
                    const e = this.hotspotsTargets[t.detail.index];
                    this.openQuickViewPopup(e);
                    const i = () => {
                        var t, s;
                        this.hotspotsTriggers.forEach((t) => t.classList.add(gw)),
                            null === (t = this.quickViewPopup.loadPhotoswipe) ||
                                void 0 === t ||
                                null === (s = t.popup) ||
                                void 0 === s ||
                                s.listen("destroy", () => {
                                    this.hotspotsTriggers.forEach((t) => t.classList.remove(gw)), e.removeEventListener("theme:popup:init", i);
                                });
                    };
                    e.addEventListener("theme:popup:init", i);
                }));
        }
        openQuickViewPopup(t) {
            var e, i;
            if (!we()) return;
            const s = null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i ? void 0 : i.pswpElement;
            s
                ? setTimeout(() => {
                      if (s.classList.contains(fw)) {
                          const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${cw}="${t.getAttribute(cw)}"]`),
                              i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(aw);
                          e.classList.add(mw),
                              i.forEach((t) => {
                                  t !== e && t.classList.remove(mw);
                              });
                      } else this.triggerClick(t);
                  })
                : setTimeout(() => this.triggerClick(t), 400);
        }
        triggerClick(t) {
            requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
        }
        destroyQuickViewPopup() {
            var t, e;
            const i = null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement;
            i && i.classList.contains(fw) && this.quickViewPopup.loadPhotoswipe.popup.close();
        }
        constructor() {
            super();
        }
    };
    customElements.get("shop-the-look") || customElements.define("shop-the-look", bw);
    const ww = {},
        Sw = "[data-slider]",
        Ew = "[data-item]",
        Lw = "[data-button-show]",
        kw = "[data-button-hide]",
        Aw = "[data-item-products]",
        Cw = "[data-item-products-slider]",
        qw = "[data-item-product]",
        Tw = "a, button",
        Pw = "blog-item--active",
        xw = "blog-item__products--visible",
        Iw = "flickity-enabled",
        Hw = "is-selected",
        Fw = { slider: "data-slider", slidePosition: "data-slide-position", sectionId: "data-section-id", tabIndex: "tabindex", ariaHidden: "aria-hidden" };
    const Mw = {
        onLoad() {
            ww[this.id] = new (class {
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus();
                            },
                        },
                    })),
                        this.flkty.on("change", () => {
                            const t = this.container.querySelectorAll(Ew);
                            this.handleFocus(),
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(Aw);
                                        t.classList.remove(Pw), e && t.querySelector(Aw).classList.remove(xw);
                                    }),
                                this.flkty && !this.flkty.options.draggable && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                        });
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(Ew).currentStyle || window.getComputedStyle(this.container.querySelector(Ew));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Ew);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                bindButtons() {
                    const t = this.container.querySelectorAll(Cw),
                        i = this.container.querySelectorAll(Lw),
                        s = this.container.querySelectorAll(kw);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                e.preventDefault(),
                                    this.container.querySelectorAll(Ew).forEach((t) => {
                                        const e = t.querySelector(Aw);
                                        t.classList.remove(Pw), e && (e.classList.remove(xw), this.changeTabIndex(e), this.changeAriaHidden(e, !0));
                                    });
                                const i = t.closest(Ew),
                                    s = i.querySelector(Aw);
                                if ((i.classList.add(Pw), s)) {
                                    s.classList.add(xw), this.changeTabIndex(s, "enable"), this.changeAriaHidden(s, !1);
                                    const t = s.querySelector(Cw),
                                        e = t.querySelectorAll(qw);
                                    t.classList.contains(Iw) &&
                                        e.forEach((t) => {
                                            const e = t.classList.contains(Hw);
                                            t.setAttribute(Fw.tabIndex, e ? "0" : "-1"), this.changeAriaHidden(t, !e);
                                        });
                                }
                                null !== this.flkty && ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()), (this.a11y.state.trigger = t);
                            });
                        }),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    e.preventDefault();
                                    const i = t.closest(Ew),
                                        s = i.querySelector(Aw);
                                    i.classList.remove(Pw),
                                        s && (s.classList.remove(xw), this.changeTabIndex(s), this.changeAriaHidden(s, !0)),
                                        null !== this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()),
                                        this.a11y.state.trigger.focus();
                                });
                            }),
                        t.length &&
                            t.forEach((t) => {
                                t.querySelectorAll(qw).length > 1 &&
                                    new e(t, {
                                        prevNextButtons: !0,
                                        contain: !0,
                                        pageDots: !1,
                                        wrapAround: !0,
                                        on: {
                                            change: (e) => {
                                                t.querySelectorAll(qw).forEach((t, i) => {
                                                    const s = i === e;
                                                    t.setAttribute(Fw.tabIndex, s ? "0" : "-1"), this.changeAriaHidden(t, !s);
                                                });
                                            },
                                        },
                                    });
                            }),
                        this.slider.addEventListener("keyup", (t) => {
                            if (t.code === theme.keyboardKeys.ESCAPE) {
                                const e = t.target.hasAttribute(Fw.slider) ? t.target.querySelectorAll(Ew) : t.target.closest(Sw).querySelectorAll(Ew);
                                e.length &&
                                    (e.forEach((t) => {
                                        const e = t.querySelector(Aw);
                                        t.classList.remove(Pw), e && (e.classList.remove(xw), this.changeTabIndex(e), this.changeAriaHidden(e, !0));
                                    }),
                                    this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable())),
                                    this.a11y.state.trigger.focus();
                            }
                        });
                }
                handleFocus() {
                    const t = this.container.querySelectorAll(Ew);
                    t.length &&
                        t.forEach((t) => {
                            const e = t.classList.contains(Hw),
                                i = t.querySelector(Aw);
                            e ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i)) : (this.changeTabIndex(t), i && i.classList.remove(xw));
                        });
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)), document.addEventListener("mousedown", this.clickOutsideItemEvent);
                }
                changeAriaHidden(t, e) {
                    t.setAttribute(Fw.ariaHidden, !!e);
                }
                changeTabIndex(t, e = "") {
                    const i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(Tw).forEach((t) => {
                        t.setAttribute(Fw.tabIndex, i);
                    });
                    const s = t.querySelectorAll(Cw),
                        o = t.querySelector(Aw),
                        n = t.classList.contains(xw);
                    s.forEach((t) => {
                        t.setAttribute(Fw.tabIndex, n ? "0" : "-1"),
                            t.querySelectorAll(qw).forEach((t) => {
                                this.changeAriaHidden(t, !n);
                            });
                    }),
                        o && this.changeAriaHidden(o, !n);
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), document.removeEventListener("mousedown", this.clickOutsideItemEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.flkty = null),
                        (this.slider = this.container.querySelector(Sw)),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.isFullWidth = this.container.hasAttribute(Fw.fullWidth)),
                        (this.gutter = 0),
                        (this.a11y = ri),
                        (this.clickOutsideItemEvent = (t) => {
                            if (!t.target.matches(Ew) && !t.target.closest(Ew)) {
                                const t = this.container.querySelectorAll(Ew);
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(Aw);
                                        e && (e.classList.remove(xw), this.changeTabIndex(e), this.changeAriaHidden(e, !0)), t.classList.remove(Pw);
                                    });
                            }
                        }),
                        this.bindButtons(),
                        this.listen();
                }
            })(this);
        },
        onUnload(t) {
            ww[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            ww[this.id].onBlockSelect(t);
        },
    };
    I("shoppable-blog", Mw);
    const Dw = "[data-scroll-down]",
        Ow = "[data-site-header]",
        Bw = "[data-slide]",
        zw = "a, button",
        _w = "[data-slider]",
        $w = ".lazy-image",
        Vw = "text-highlight",
        Rw = '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        Nw = "data-style",
        Ww = "data-current-style",
        Uw = "tabindex",
        jw = "site-header--fixed",
        Gw = "slider--no-cached-images",
        Kw = "slider--img-loaded",
        Qw = "img-in",
        Yw = "original-height",
        Xw = "original-height-mobile",
        Jw = "has-mobile-height",
        Zw = {};
    I("slider", [
        {
            onLoad() {
                Zw[this.id] = new (class {
                    initSlider() {
                        const t = this.items.length,
                            i = parseInt(this.container.dataset.duration),
                            s = "true" === this.container.dataset.pageDots && t > 1,
                            o = "true" === this.container.dataset.navArrows && t > 1;
                        let n = "true" === this.container.dataset.autoplay;
                        if ((n && (n = i), t > 1))
                            (this.flkty = new e(this.container, {
                                fade: !0,
                                cellSelector: Bw,
                                autoPlay: n,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                setGallerySize: !0,
                                imagesLoaded: !0,
                                pageDots: s,
                                prevNextButtons: o,
                                dragThreshold: 25,
                                on: {
                                    ready: () => {
                                        const t = this.items[0].getAttribute(Nw);
                                        this.container.setAttribute(Ww, t), requestAnimationFrame(this.resizeEvent), document.addEventListener("theme:vars", this.resizeEvent), this.handleFirstSlideAnimation(!0);
                                    },
                                    change: (t) => {
                                        const e = this.flkty.selectedElement.getAttribute(Nw);
                                        this.container.setAttribute(Ww, e),
                                            this.handleFirstSlideAnimation(!1),
                                            this.flkty.cells.forEach((e, i) => {
                                                e.element.querySelectorAll(zw).forEach((e) => {
                                                    e.setAttribute(Uw, i === t ? "0" : "-1");
                                                }),
                                                    e.element.querySelectorAll(Vw).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                            });
                                    },
                                },
                            })),
                                xi(this.container);
                        else if (1 === t) {
                            const t = this.items[0].getAttribute(Nw);
                            this.container.setAttribute(Ww, t);
                        }
                    }
                    getTallestSlideItem() {
                        if (this.items.length <= 1) return;
                        this.container.style.removeProperty("--item-min-h");
                        const t = [...this.items].map((t) => Math.floor(t.offsetHeight)),
                            e = Math.max(...t),
                            i = [...this.items].some((t) => t.classList.contains(Yw)),
                            s = [...this.items].some((t) => t.classList.contains(Xw)),
                            o = this.container.classList.contains(Jw);
                        ((be() && !i) || (we() && !s && o) || (we() && !i && !o)) && [...this.items].some((t) => Math.floor(t.offsetHeight) !== e) && this.container.style.setProperty("--item-min-h", `${e}px`);
                    }
                    handleFirstSlideAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(Gw), void this.container.classList.remove(Kw);
                        const e = this.items[0].querySelectorAll($w),
                            i = this.container.classList.contains(Qw);
                        if (e.length && !i) {
                            this.container.classList.add(Gw);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add(Kw)), e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    bindScrollButton() {
                        const t = this.container.querySelector(Dw);
                        t &&
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = this.header.classList.contains(jw) ? 60 : 0,
                                    i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                            });
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
                    }
                    onBlockDeselect(t) {
                        "true" === t.target.closest(_w).dataset.autoplay && null !== this.flkty && this.flkty.playPlayer();
                    }
                    onReorder() {
                        this.handleFirstSlideAnimation(!1), null !== this.flkty && this.flkty.resize();
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
                            this.handleFirstSlideAnimation(!1),
                            null !== this.flkty && (document.removeEventListener("theme:vars", this.resizeEvent), this.flkty.destroy(), (this.flkty = null)),
                            this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.header = document.querySelector(Ow)),
                            (this.items = this.container.querySelectorAll(Bw)),
                            (this.flkty = null),
                            (this.parallax = null),
                            (this.resizeEvent = () => {
                                this.flkty.resize();
                            }),
                            this.getTallestSlideItem(),
                            this.initSlider(),
                            this.bindScrollButton(),
                            (this.getTallestSlideItemOnResize = () => this.getTallestSlideItem()),
                            document.addEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
                            this.container.matches(Rw) && (this.parallax = new Tu(this.container));
                    }
                })(this);
            },
            onReorder(t) {
                Zw[this.id].onReorder(t);
            },
            onUnload(t) {
                Zw[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Zw[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                Zw[this.id].onBlockDeselect(t);
            },
        },
        Xp,
    ]);
    const tS = "[data-sticky-card-body]",
        eS = "[data-sticky-card-wrapper]",
        iS = "[data-sticky-card-content]",
        sS = "[data-sticky-card-aside]",
        oS = "[data-sticky-card-text]",
        nS = "[data-sticky-card-image]",
        rS = "[data-sticky-vh]",
        aS = "is-stuck-up",
        lS = "has-passed-sticky",
        cS = "spillover",
        hS = "data-sticky-card-layout-mobile",
        dS = {};
    I("sticky-image-cards", {
        onLoad() {
            dS[this.id] = new (class {
                init() {
                    requestAnimationFrame(() => {
                        this.calculateHeights(), this.onScroll();
                    }),
                        document.addEventListener("theme:scroll", this.onScrollCallback),
                        document.addEventListener("theme:resize", this.onResizeCallback);
                }
                onScroll() {
                    this.isEligible() && this.detectStickyPositions();
                }
                isEligible() {
                    const t = Math.round(this.container.getBoundingClientRect().top + window.scrollY),
                        e = t + this.container.offsetHeight < Math.round(window.scrollY);
                    return t < Math.round(window.scrollY + window.innerHeight) && !e;
                }
                detectStickyPositions() {
                    const t = Math.round(this.body.getBoundingClientRect().top - this.headerHeight - this.wrapperTop);
                    [...this.wrapper].forEach((e, i) => {
                        const s = Math.floor(e.getBoundingClientRect().top - this.headerHeight);
                        if (this.isMobile) {
                            if (i !== this.lastIndex) {
                                const t = Math.floor(this.wrapper[i + 1].getBoundingClientRect().top - this.headerHeight);
                                e.classList.toggle(lS, t <= this.stickyTop);
                            }
                            this.container.classList.toggle(`checkpoint-${i + 1}`, t <= -1 * this.cumulativeHeights[i]);
                        }
                        e.classList.toggle(aS, s <= this.stickyTop);
                    });
                }
                calculateHeights() {
                    let { stickyHeaderHeight: t } = N();
                    (this.headerHeight = t || 0),
                        (this.spacingTop = parseInt(window.getComputedStyle(this.container).getPropertyValue("--padding")) || 20),
                        (this.wrapperTop = parseInt(window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")) || 0),
                        (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
                        (this.gap = parseInt(window.getComputedStyle(this.aside).getPropertyValue("gap")) || 0),
                        (this.viewportHeight = this.vh.offsetHeight),
                        (this.lastIndex = [...this.wrapper].length - 1),
                        (this.cumulativeHeights = []),
                        this.isMobile && ((this.wrapperTop = this.spacingTop), (this.stickyTop = this.spacingTop)),
                        this.textInContent &&
                            (this.isDesktop &&
                                this.textInContent.length > 0 &&
                                this.textInContent.forEach((t, e) => {
                                    t.style.setProperty("--row-height", "auto"), this.wrapper[e].style.setProperty("--row-height", "auto");
                                    const i = t.offsetHeight,
                                        s = this.image[e].offsetHeight,
                                        o = Math.max(i, s);
                                    t.style.setProperty("--row-height", `${o}px`), this.wrapper[e].style.setProperty("--row-height", `${o}px`);
                                }),
                            [...this.wrapper].forEach((t, e) => {
                                t.style.setProperty("--item-height", "auto"),
                                    t.style.setProperty("--item-double-height", "auto"),
                                    requestAnimationFrame(() => {
                                        const i = t.offsetHeight,
                                            s = i + this.wrapperTop + this.headerHeight > this.viewportHeight,
                                            o = [...this.wrapper].map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight));
                                        this.cumulativeHeights.push(o.reduce((t, e) => t + e, 0)),
                                            t.classList.toggle(cS, s),
                                            s && this.isMobile && (t.style.setProperty("--item-height", `${i}px`), t.style.setProperty("--item-double-height", 2 * i + "px"));
                                    });
                            }));
                }
                onResize() {
                    requestAnimationFrame(() => {
                        (this.isDesktop = Boolean(ve() >= window.theme.sizes.large)), (this.isMobile = we());
                        const t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                        let e = this.isDesktop || (!t && this.isMobile);
                        this.orientation !== Y() && t && ((e = !0), (this.orientation = Y())), e && this.calculateHeights();
                    });
                }
                onUnload() {
                    document.removeEventListener("theme:scroll", this.onScrollCallback), document.removeEventListener("theme:resize", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    requestAnimationFrame(() => {
                        const e = Number(t.target.dataset.index),
                            i =
                                Math.round(this.body.getBoundingClientRect().top + window.scrollY) +
                                [...this.wrapper].map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight)).reduce((t, e) => t + e, 0) -
                                (() => (this.isMobile && "stacked" === this.layoutMobile ? this.gap * e * -1 + this.gap / 2 : this.stickyTop))() -
                                this.headerHeight;
                        setTimeout(() => {
                            window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                        }, 400);
                    });
                }
                constructor(t) {
                    var e;
                    (this.container = t.container),
                        (this.body = this.container.querySelector(tS)),
                        (this.wrapper = this.container.querySelectorAll(eS)),
                        (this.content = this.container.querySelector(iS)),
                        (this.aside = this.container.querySelector(sS)),
                        (this.text = this.container.querySelectorAll(oS)),
                        (this.image = this.container.querySelectorAll(nS)),
                        (this.textInContent = null === (e = this.content) || void 0 === e ? void 0 : e.querySelectorAll(oS)),
                        (this.vh = this.container.querySelector(rS)),
                        (this.layoutMobile = this.container.getAttribute(hS)),
                        (this.isDesktop = Boolean(ve() >= window.theme.sizes.large)),
                        (this.isMobile = we()),
                        (this.orientation = Y()),
                        0 !== this.image.length && ((this.onScrollCallback = () => this.onScroll()), (this.onResizeCallback = () => this.onResize()), this.init());
                }
            })(this);
        },
        onUnload() {
            dS[this.id].onUnload();
        },
        onBlockSelect(t) {
            dS[this.id].onBlockSelect(t);
        },
    });
    const uS = "[data-sticky-wrapper]",
        pS = "[data-sticky-aside]",
        mS = "[data-sticky-inner]",
        gS = "[data-sticky-content]",
        fS = ".js-only [data-sticky-text]",
        yS = ".js-only [data-sticky-text-inner]",
        vS = ".js-only [data-sticky-image]",
        bS = "[data-sticky-images]",
        wS = ".image-wrapper",
        SS = "[data-sticky-dot]",
        ES = "text-highlight",
        LS = "data-sticky-with-gaps",
        kS = "data-sticky-single-text",
        AS = "data-index",
        CS = 0.5,
        qS = { horizontal: "horizontal", horizontalReversed: "horizontal-reversed", vertical: "vertical", verticalReversed: "vertical-reversed" },
        TS = { maxVisibility: "maximum-visibility-of-each-image-in-viewport", middleOfViewport: "image-in-the-middle-of-viewport" },
        PS = "is-active",
        xS = {};
    I("sticky-images-and-text", [
        {
            onLoad() {
                xS[this.id] = new (class {
                    init() {
                        this.getTypeOfIntersecting(),
                            this.observeImagesIntersecting(),
                            this.calculateHeights(),
                            (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => this.calculateHeights());
                            }),
                            document.addEventListener("theme:scroll", this.onScrollCallback),
                            document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.syncDots();
                    }
                    getTypeOfIntersecting() {
                        (this.typeOfIntersecting = TS.maxVisibility),
                            (this.fractionOfViewport = this.image[0].offsetHeight / window.innerHeight),
                            this.verticalScroll && !we() && this.fractionOfViewport < 0.6 && (this.typeOfIntersecting = TS.middleOfViewport);
                    }
                    observeImagesIntersecting() {
                        (this.observersCollection = new Set()),
                            (this.compareIntersectionRatio = []),
                            (this.maxVisibility = 0),
                            (this.observer = new IntersectionObserver(
                                (t, e) => {
                                    t.forEach((t) => {
                                        const e = t.target.offsetHeight,
                                            i = t.intersectionRatio,
                                            s = t.isIntersecting,
                                            o = { target: t.target, intersectionRatio: t.intersectionRatio },
                                            n = this.typeOfIntersecting === TS.maxVisibility;
                                        let r = CS;
                                        this.windowHeight <= e && (r = 0),
                                            n &&
                                                s &&
                                                (this.observersCollection.forEach((e) => {
                                                    e.target === t.target && this.observersCollection.delete(e);
                                                }),
                                                this.observersCollection.add(o),
                                                (this.compareIntersectionRatio = [...this.observersCollection].map((t) => t.intersectionRatio)),
                                                (this.maxVisibility = Math.max(...this.compareIntersectionRatio))),
                                            s &&
                                                i > r &&
                                                n &&
                                                this.maxVisibility === i &&
                                                ((this.maxVisibilityItem = [...this.observersCollection].find((t) => t.intersectionRatio === this.maxVisibility)),
                                                (this.activeIndex = Number(this.maxVisibilityItem.target.dataset.index)),
                                                this.lastActiveIndex !== this.activeIndex && (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                                    });
                                },
                                { root: null, rootMargin: "0px", threshold: [0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1] }
                            )),
                            this.image.forEach((t) => this.observer.observe(t));
                    }
                    onScroll() {
                        this.performAnimation || (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            this.typeOfIntersecting === TS.middleOfViewport && this.image.forEach((t) => this.checkImagePositionInViewport(t));
                    }
                    removeAnimationFrame() {
                        this.performAnimation && (cancelAnimationFrame(this.performAnimation), (this.performAnimation = null));
                    }
                    checkImagePositionInViewport(t) {
                        if (!t) return;
                        const e = window.innerHeight,
                            i = window.scrollY,
                            s = i + e / 2,
                            o = i + e,
                            n = Math.round(t.getBoundingClientRect().top + i),
                            r = n + t.offsetHeight;
                        n < o && !(r < i) && s > n && r > s && ((this.activeIndex = Number(t.dataset.index)), this.lastActiveIndex !== this.activeIndex && (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                    }
                    calculateImagesOffset() {
                        const t = this.aside.getBoundingClientRect().top - this.headerHeight,
                            e = t - this.innerStickyTop;
                        let i = 0,
                            s = 0;
                        const o = this.hasShortImages ? e : t;
                        (i = o < 0 ? (o / this.bottomEndingPoint) * -1 * 100 : o >= 0 ? 0 : 100),
                            (s = i > 100 ? 100 : i),
                            (s *= this.image.length - 1),
                            (we() || this.horizontalScroll) && this.aside.style.setProperty("--translateX", `${Number(s * this.direction).toFixed(2)}%`),
                            this.lastOffset !== s ? (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)) : this.performAnimation && this.removeAnimationFrame(),
                            (this.lastOffset = s);
                    }
                    calculateHeights() {
                        let { stickyHeaderHeight: t, windowHeight: e } = N();
                        if (((this.headerHeight = t || 0), (this.windowHeight = e || window.innerHeight), this.text.length > 0)) {
                            const t = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-top")) : 0,
                                e = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-bottom")) : 0,
                                i = [...this.text].map((i) => i.offsetHeight + t + e),
                                s = [...this.textInner].map((t) => t.offsetHeight),
                                o = Math.max(...i),
                                n = Math.max(...s),
                                r = we() ? n : o,
                                a = i.reduce((t, e) => t + e, 0),
                                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
                            this.container.style.removeProperty("--average-text-height"),
                                this.container.style.setProperty("--average-text-height", `${l}px`),
                                this.container.style.removeProperty("--highest-text"),
                                this.container.style.setProperty("--highest-text", `${r}px`);
                        }
                        (this.imagesHeight = this.images.offsetHeight),
                            (this.hasShortImages = !1),
                            this.image.length > 0 &&
                                ((this.imgHeight = this.image[0].querySelector(wS).offsetHeight),
                                (this.imgPadding = parseInt(window.getComputedStyle(this.image[0]).getPropertyValue("padding-top"))),
                                this.container.style.removeProperty("--images-height"),
                                this.container.style.setProperty("--images-height", `${this.imagesHeight}px`),
                                this.container.style.removeProperty("--img-height"),
                                this.container.style.setProperty("--img-height", `${this.imgHeight + 2 * this.imgPadding}px`)),
                            (this.asideHeight = this.aside.offsetHeight),
                            (this.asidePadding = parseInt(window.getComputedStyle(this.aside).getPropertyValue("padding-top"))),
                            (this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2),
                            (this.innerStickyTop = parseInt(window.getComputedStyle(this.inner).getPropertyValue("top")) - this.headerHeight - this.breathingSpace),
                            (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
                            (this.additionalSpace = we() ? (this.withGaps ? this.asidePadding + 10 : 10) : this.gutters),
                            (this.minHeightForEndingPoing = this.imagesHeight + this.additionalSpace),
                            !we() &&
                                this.horizontalScroll &&
                                ((this.minHeightForEndingPoing = this.windowHeight - this.headerHeight),
                                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                                this.hasShortImages && (this.minHeightForEndingPoing = this.imagesHeight - this.innerStickyTop + 3 * this.breathingSpace)),
                            (this.bottomEndingPoint = this.asideHeight - this.minHeightForEndingPoing);
                    }
                    refreshImagesOffsetValues() {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                document.dispatchEvent(new CustomEvent("theme:scroll"));
                            });
                        });
                    }
                    onResize() {
                        this.calculateHeights(), requestAnimationFrame(() => this.calculateHeights()), this.getTypeOfIntersecting(), this.refreshImagesOffsetValues();
                    }
                    sync() {
                        const t = this.singleText ? [] : this.text;
                        [...this.image, ...t, ...this.dot].forEach((t) => {
                            const e = Number(t.getAttribute(AS));
                            t.classList.toggle(PS, e === Number(this.activeIndex));
                        }),
                            this.textHighlight.forEach((t) => t.shouldAnimate());
                    }
                    syncDots() {
                        this.dot.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault(), this.scrollTo(this.image[Number(t.target.dataset.index)]);
                            });
                        });
                    }
                    scrollTo(t, e = 0) {
                        if (!t) return;
                        const i = Number(t.dataset.index),
                            s = Math.round(t.getBoundingClientRect().top + window.scrollY),
                            o = t.offsetHeight,
                            n = Math.round(this.wrapper.getBoundingClientRect().top + window.scrollY),
                            r = this.aside.getBoundingClientRect().top - this.headerHeight,
                            a = n + this.images.offsetHeight * i,
                            l = Boolean((this.image[0].offsetHeight + this.gutters) / (window.innerHeight - this.headerHeight) >= 1);
                        let c = a - this.headerHeight;
                        if ((we() && (c = r + window.scrollY + (this.bottomEndingPoint / (this.image.length - 1)) * i), this.horizontalScroll && be() && !l)) {
                            const t = r - this.innerStickyTop;
                            c = (this.hasShortImages ? t + window.scrollY : r + window.scrollY) + (this.bottomEndingPoint / (this.image.length - 1)) * i;
                        }
                        this.verticalScroll && be() && ((c = s - this.headerHeight), this.typeOfIntersecting === TS.middleOfViewport && (c = s - window.innerHeight / 2 + o / 2 - this.headerHeight));
                        const h = { top: c, left: 0, behavior: "smooth" };
                        e > 0 ? setTimeout(() => window.scrollTo(h), e) : window.scrollTo(h);
                    }
                    onUnload() {
                        this.image.forEach((t) => this.observer.unobserve(t)), document.removeEventListener("theme:scroll", this.onScrollCallback), document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    onBlockSelect(t) {
                        this.scrollTo(t.target, 500);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.scrollDirection = this.container.dataset.scrollDirection),
                            (this.horizontalScroll = this.scrollDirection === qS.horizontal || this.scrollDirection === qS.horizontalReversed),
                            (this.verticalScroll = this.scrollDirection === qS.vertical || this.scrollDirection === qS.verticalReversed),
                            (this.reverseDirection = this.scrollDirection === qS.horizontalReversed || this.scrollDirection === qS.verticalReversed),
                            (this.direction = this.reverseDirection ? 1 : -1),
                            (this.withGaps = this.container.hasAttribute(LS)),
                            (this.singleText = this.container.hasAttribute(kS)),
                            (this.image = this.container.querySelectorAll(vS)),
                            (this.text = this.container.querySelectorAll(fS)),
                            (this.textInner = this.container.querySelectorAll(yS)),
                            (this.images = this.container.querySelector(bS)),
                            (this.dot = this.container.querySelectorAll(SS)),
                            (this.aside = this.container.querySelector(pS)),
                            (this.inner = this.container.querySelector(mS)),
                            (this.content = this.container.querySelector(gS)),
                            (this.wrapper = this.container.querySelector(uS)),
                            (this.textHighlight = this.container.querySelectorAll(ES)),
                            (this.performAnimation = null),
                            (this.lastOffset = 0),
                            (this.activeIndex = 0),
                            (this.lastActiveIndex = this.activeIndex),
                            this.wrapper && ((this.onScrollCallback = () => this.onScroll()), (this.onResizeCallback = () => this.onResize()), (this.calculateImagesOffsetCallback = () => this.calculateImagesOffset()), this.init());
                    }
                })(this);
            },
            onUnload() {
                xS[this.id].onUnload();
            },
            onBlockSelect(t) {
                xS[this.id].onBlockSelect(t);
            },
        },
        Xp,
    ]),
        I("subcollections", of),
        I("tab-collections", [vo, of, yr]);
    const IS = {},
        HS = "[data-slider]",
        FS = "[data-item]",
        MS = "a, button",
        DS = ".flickity-button",
        OS = "flickity-enabled",
        BS = "has-arrows",
        zS = "carousel--resize",
        _S = "flickity-button-holder",
        $S = "is-selected",
        VS = "data-section-id",
        RS = "tabindex";
    I("testimonials", {
        onLoad() {
            IS[this.id] = new (class {
                init() {
                    this.checkSlideCount(), this.listen();
                }
                onResize() {
                    this.checkSlideCount(), null !== this.flkty && (this.flkty.resize(), this.flkty.size.width >= this.flkty.slideableWidth && this.destroySlider());
                }
                checkSlideCount() {
                    const t = this.slides.length,
                        e = Boolean(2 == t && window.innerWidth >= theme.sizes.small),
                        i = Boolean(1 == t);
                    if (!e && !i)
                        return this.flkty
                            ? void (this.flkty && (this.flkty.isActive || this.initSlider(), this.flkty.slideableWidth > this.flkty.size.width ? this.initSlider() : this.destroySlider()))
                            : (this.initSlider(), void this.onResize());
                    this.destroySlider();
                }
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        cellSelector: FS,
                        prevNextButtons: !0,
                        pageDots: !0,
                        groupCells: !0,
                        cellAlign: this.alignment,
                        contain: !0,
                        adaptiveHeight: !1,
                        on: {
                            ready: () => {
                                this.slidesTabIndex(),
                                    requestAnimationFrame(() => {
                                        this.slider.querySelectorAll(DS).forEach((t) => {
                                            ut(t, _S);
                                        });
                                    });
                            },
                            change: () => {
                                this.slidesTabIndex();
                            },
                        },
                    })),
                        we() ? this.container.classList.remove(BS) : this.container.classList.add(BS),
                        this.createResizeClass();
                }
                createResizeClass() {
                    if ("function" == typeof e.prototype._createResizeClass) return;
                    (e.prototype._createResizeClass = function () {
                        this.element.classList.add(zS);
                    }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(zS), t.call(this), this.element.classList.add(zS);
                    };
                }
                slidesTabIndex() {
                    e.data(this.slider).cells.forEach((t) => {
                        let e = "-1";
                        t.element.classList.contains($S) && (e = "0"),
                            t.element.querySelectorAll(MS).forEach((t) => {
                                t.setAttribute(RS, e);
                            });
                    });
                }
                destroySlider() {
                    var t;
                    this.slider.classList.contains(OS) &&
                        (null !== this.flkty &&
                            (null === (t = this.slider.querySelectorAll(DS)) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    const e = t.parentNode;
                                    e && e.classList.contains(_S) && (e.parentNode.insertBefore(t, e), e.parentNode.removeChild(e));
                                }),
                            this.flkty.destroy()),
                        this.container.classList.remove(BS));
                }
                listen() {
                    document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    if (null !== this.flkty && this.flkty.isActive) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.sectionId = this.container.getAttribute(VS)),
                        (this.slider = this.container.querySelector(HS)),
                        (this.alignment = this.slider.dataset.sliderAlignment),
                        this.slider && ((this.slides = this.slider.querySelectorAll(FS)), (this.flkty = null), (this.onResizeCallback = () => this.onResize()), this.init());
                }
            })(this);
        },
        onUnload(t) {
            IS[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            IS[this.id].onBlockSelect(t);
        },
    });
    const NS = "no-outline",
        WS = "[data-skip-content]",
        US = 'a[href="#"]';
    document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${(() => {
            const t = document.createElement("div");
            (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
            const e = document.createElement("div");
            t.appendChild(e);
            const i = t.offsetWidth - e.offsetWidth;
            return t.parentNode.removeChild(t), i;
        })()}px`
    ),
        document.addEventListener("DOMContentLoaded", function () {
            H("*"),
                new (class {
                    init() {
                        (this.body = document.body),
                            (this.inPageLink = document.querySelector(WS)),
                            (this.linkesWithOnlyHash = document.querySelectorAll(US)),
                            (this.isFocused = !1),
                            this.focusHash(),
                            this.bindInPageLinks(),
                            this.clickEvents(),
                            this.focusEvents(),
                            this.focusEventsOff();
                    }
                    clickEvents() {
                        this.inPageLink &&
                            this.inPageLink.addEventListener("click", (t) => {
                                t.preventDefault();
                            }),
                            this.linkesWithOnlyHash &&
                                this.linkesWithOnlyHash.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                                });
                    }
                    focusEvents() {
                        document.addEventListener("keyup", (t) => {
                            t.code === theme.keyboardKeys.TAB && (this.body.classList.remove(NS), (this.isFocused = !0));
                        });
                    }
                    focusEventsOff() {
                        document.addEventListener("mousedown", () => {
                            this.body.classList.add(NS), (this.isFocused = !1);
                        });
                    }
                    forceFocus(t, e) {
                        e = e || {};
                        var i = t.tabIndex;
                        (t.tabIndex = -1),
                            (t.dataset.tabIndex = i),
                            t.focus(),
                            void 0 !== e.className && t.classList.add(e.className),
                            t.addEventListener("blur", function s(o) {
                                o.target.removeEventListener(o.type, s), (t.tabIndex = i), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
                            });
                    }
                    focusHash(t) {
                        t = t || {};
                        let e = window.location.hash;
                        void 0 !== theme.settings.newHash && ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
                        const i = document.getElementById(e.slice(1));
                        if (i && t.ignore && i.matches(t.ignore)) return !1;
                        e && i && this.forceFocus(i, t);
                    }
                    bindInPageLinks(t) {
                        return (
                            (t = t || {}),
                            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                                if ("#" === e.hash || "" === e.hash) return !1;
                                if (t.ignore && e.matches(t.ignore)) return !1;
                                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                                var i,
                                    s = document.querySelector(e.hash);
                                return (
                                    !!s &&
                                    (e.addEventListener("click", () => {
                                        this.forceFocus(s, t);
                                    }),
                                    !0)
                                );
                            })
                        );
                    }
                    constructor() {
                        this.init();
                    }
                })(),
                customElements.get("product-grid-item-swatch") || "disabled" == window.theme.settings.colorSwatchesType || customElements.define("product-grid-item-swatch", ao);
            "scrollBehavior" in document.documentElement.style || li({ url: theme.assets.smoothscroll });
        });
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate);
